export const lang = ({
  en: {
    postex: {
      navBar: {
        t1: 'Sign In / Sign Up',
        t2: 'Home',
        t3: 'Single Order',
        t4: 'Multi Order',
        t5: 'Wallet',
        t6: 'Dashboard',
        t7: 'my account',
        t8: 'user',
        t9: 'Coordinator Registration',
        t10: 'Contact the head office',
        t11: 'multi send box'
      },
      bottomNavigation: {
        t1: 'Home',
        t2: 'Support',
        t3: 'Order',
        t4: 'wallet',
        t5: 'Dashboard',
        t6: 'My Orders',
      },
      footer: {
        t1: 'General site information',
        t2: 'Postex system rules',
        t3: 'About Postex',
        t4: 'News',
        t5: 'Forums',
        t6: 'blog',
        t7: 'Customer guide',
        t8: 'API documentation',
        t9: 'Received money from recipient by mistake',
        t10: 'http and training to enter the site',
        t11: 'Conditions for obtaining Postex representation',
        t12: 'Carton and wrapper',
        t13: 'Academy of Education',
        t14: 'Frequently Asked Questions',
        t15: 'my account',
        t16: 'Dashboard',
        t17: 'List of orders',
        t18: 'Edit user account',
        t19: 'Services',
        t20: 'Accounting',
        t21: 'ticket',
        t22: 'Communication with Postex',
        t23: 'Download Our Apps',
        t24: 'Haft Municipal District, Shariati Street, Masjid Alley, No. 18, 2nd Floor',
        t25: 'Phone number',
        t26: ' All Rights Are Reserved for Memaran Beh Tarh | 2023'
      },
      drawer: {
        t1: 'Postal service',
        t2: 'Courier hub (courier within the city)',
        t3: 'PME (Foreign Post)',
        t4: 'Shapex (store maker)',
        t5: 'Ludex (heavy transport)',
        t6: 'biopost (cold post)',
        t7: 'Cadox (send a gift)',
        t8: 'My Orders',
        t9: 'Modify the package size',
        t10: 'Download the application',
        t11: 'Support',
        t12: 'Submit a ticket to support',
        t13: 'My ticket list',
        t14: 'Representation',
        t15: 'User comments',
        t16: 'Plugin / API',
        t17: 'Transportation magazine',
        t18: 'about us',
        t19: 'Postex Yar (frequently asked questions)',
        t20: 'User account settings',
        t21: 'Sign out of the user account',
        t22: 'orders of Others for me',
        t23: "home",
        t24: "Cooperation with us"
      },
      login: {
        t1: 'Postex is Iran first postal hub with a door-to-door online mail service provider',
        t2: 'Login to account',
        t3: 'phone number',
        t4: 'password',
        t5: 'remember me',
        t6: 'forget password?',
        t7: 'Login to account',
        t8: 'Are you a new user in Postex?',
        t9: 'Sign Up',
        t10: 'Return to main page',
      },
      register: {
        t1: 'You can easily use the various services of the Postex system by comparing the price, speed and quality of services',
        t2: 'Register in Postex',
        t3: 'Mobile number with zero',
        t4: 'National Code',
        t5: 'password',
        t6: 'Confirm password',
        t7: 'Register in Postex',
        t8: 'Registering in Postex means agreeing to the rules.',
        t9: 'rules',
        t10: 'Already registered in Postex?',
        t11: 'log in',
        t12: 'Return to main page',
        t13: 'The passwords are not the same',
        t14: 'First Name',
        t15: 'Last Name',
        t16: 'Accept'
      },
      newPassword: {
        t1: 'You can easily use the various services of the Postex system by comparing the price, speed and quality of services',
        t2: 'Please enter a new password',
        t3: 'New password',
        t4: 'confirm the new password',
        t5: 'Register password',
        t6: 'Return to main page',
        t7: 'phone number',
        t8: 'Send',
      },
      forgetPassword: {
        t1: 'You can easily use the various services of the Postex system by comparing the price, speed and quality of services',
        t2: 'Please enter the received code',
        t3: 'submit code',
        t4: 'Have not received a code?',
        t5: 'Modify the contact number',
        t6: 'Return to main page',
        t7: 'Resend Code',
        t8: 'verify code',
        t9: 'new password',
        t10: 'confirm new password',
        t11: 'save',
      },
      homeDesktop: {
        s1: {
          t1: "Online Door-to-Door Postal Services",
          t2: 'Postex is a smart postal hub with door-to-door delivery services',
          t3: {
            tt1: 'Order Tracking',
            tt2: 'Enter the postal barcode (tracking code), order number or mobile number of the sender/receiver:',
            tt3: 'Postal BarCode',
            tt4: 'Order Number',
            tt5: 'Mobile Number',
            tt6: 'Find It',
            tt7: 'Postal barcode or Order number',
            tt8: "tracking and price calculation",
          },
          t4: {
            tt1: 'Estimate Rates',
            tt2: 'Please enter the information below to calculate the postage price',
            tt3: 'Domestic',
            tt4: 'International',
            tt5: 'sender',
            tt6: 'City and State of Origin',
            tt7: 'Receiver',
            tt8: 'City and State of Destination',
            tt9: 'size',
            tt10: 'Select',
            tt11: 'Shipment Value ($)',
            tt12: 'weight (gram)',
            tt13: 'Distribution',
            tt14: 'Need collecting?',
            tt15: 'packing',
            tt16: 'Get Rates',
            tt17: 'Post Payment',
            tt18: 'Cash on Delivery? (COD)',
            tt19: 'Destination',
            tt20: 'Is it fragile?',
            tt21: 'Does it contain liquids?',
            tt22: "Size bigger than 9",
            tt23: "The value of goods to determine the limit of obligations"
          },
          t5: 'Send your package',
          t6: 'The result of tracking your shipment',
          t7: 'Tracking code/order number/mobile',
          t8: 'Postal service name',
          t9: 'Shipment type',
          t10: 'Date of collection',
          t11: 'sent date',
          t12: 'Delivery Date',
          t13: 'sender name',
          t14: 'sender address',
          t15: 'Recipient\'s name',
          t16: 'receiver address',
          t17: 'The result of quick price calculation',
          t18: 'Easy',
          t19: 'Delivery',
          t20: 'with',
          t21: 'Postex',
          t22: 'shapex',
          t23: 'eCommerce Website Builder',
          t24: 'We Cover You for International Shipping!',
          t25: 'PeykHub Handles Your Local Courier Needs',
          t26: 'Tracking Number',
          t27: 'send box',
          t28: "Postex's presence at the Gitex exhibition",
          t29: "",
          t30: "The only event to connect with 250 government entities",
          t31: "The largest government presence among technology events, unveiling national digital projects and public-private partnerships",
          t32: "The most innovative companies in the world",
          t33: "Experience the undeniable power of innovation in a comprehensive display of global products and solutions with diverse industrial applications",
          t34: "Gitex, inspiring and improving life",
          t35: "The press conference of the world GITEX exhibition, which will be opened on Monday next week, was held with the presence of the minister of the United Arab Emirates government in the field of artificial intelligence",
          t36: "For the first time, GITEX Global will be held in two large places this year",
          t37: "This exhibition is the place to present the latest technologies and developments in the field of artificial intelligence, cloud computing, Web 3.0 and sustainable digital economy.",
        },
        s2: {
          t1: 'Why should I send my parcels with Postex?',
          t2: 'Postex services',
          t3: '',

          t4: 'amnito service',
          t5: '<h2>Amnito: Secure and Convenient <b>Online Shopping Experience</b></h2>',
          t6: 'One of the challenges of eCommerce is to establish trust and security between buyers and sellers. Postex has addressed this issue with a secure payment service called Amnito, which offers a reliable solution for both parties. Amnito ensures that both buyers and sellers are protected from fraud and disputes, and enjoy a smooth and pleasant online shopping experience.',
          t7: 'With Amnito, the buyer deposits the payment for the product in a secure escrow account managed by Postex until the product is delivered and inspected. The payment is then released to the seller if the product meets the buyer’s expectations and the delivery status is confirmed. If the product is not satisfactory or the delivery status is not confirmed, the payment is refunded to the buyer.',
          t8: 'Safe buying and selling in online stores',
          t9: 'Explore',

          t10: 'Bio post service',
          t11: '<h2>Bio Post: A Safe and Fast <b>Delivery Service for Sensitive Goods</b></h2>',
          t12: 'Do you need to transport laboratory samples, vaccines, or chemicals that require cold storage? If so, Bio Post is the service for you. Bio Post is a new service from Postex that specializes in delivering sensitive goods that need to be kept at low temperatures. ' +
             'Bio Post ensures that your goods are delivered safely and securely to any part of the world within 24 to 48 hours. Bio Post also provides you with special containers and parcels that are designed to protect your goods from contamination and damage. Bio Post is the best choice for moving sensitive goods with confidence and convenience.',
          t13: 'A Safe and Fast Delivery Service for Sensitive Goods',

          t14: 'Subex',
          t15: '<h2> Subex: A Smart and Simple Solution for <b>Instagram Shops</b></h2>',
          t16: 'Are you tired of Instagram’s restrictions and limitations? Do you want to grow your online store and reach more customers? If so, Subex is the service for you. Subex allows you to create your own personalized webpage with a point-of-sale portal for your Instagram shop.',
          t17: 'You can upload all your products to your Subex dashboard and get a unique link to share with your customers or put in your bio. When your customers click on your link, they will see a complete list of your products and prices. They can easily select the product they want, add their address, choose the shipping method, and pay securely with their preferred payment service.',
          t18: 'A Smart and Simple Solution for Instagram Shops',

          t19: 'Shipito Plus',
          t20: '<h2>Shipito: Using AI for  <b> Efficient and Cost-effective Delivery </b></h2>',
          t21: 'If you run a store that has a fleet of vehicles for collecting and distributing your parcels, one of the most important challenges you face is how to optimize your fleet routes based on the shortest and least congested routes. You may think that this is possible for a small number of parcels based on your knowledge of the area, but human calculation is impossible for a large number of parcels. ',
          t22: 'Moreover, your knowledge of the traffic conditions may not be up to date or accurate. That’s why you need Shipito, a VRP (Vehicle Routing Problem) solution that uses advanced AI algorithms and real-time data to calculate the best routes for your fleet. Shipito helps you save time, money, and fuel by finding the most efficient and cost-effective routes for your delivery needs. Shipito is the smart way to manage your fleet and satisfy your customers.',
          t23: 'Using AI for Efficient and Cost-effective Delivery ',

          t24: 'Shapex store builder',
          t25: '<h2> Shapex: A Professional Website Builder for  <b>Social Media Shops</b></h2>',
          t26: 'Do you want to take your online sales and marketing to the next level? Do you want to create your own eCommerce website without any hassle or coding? If so, Shapex is the service for you. Shapex is a website builder that allows you to create a stunning and functional eCommerce website for your Instagram, Facebook, or Pinterest shop.',
          t27: 'You can upload all your products to your Shapex dashboard and customize your website with your own logo, colors, and layout. You can also offer your customers various options and features, such as free shipping, on-site payment, cash payment, secure buying and selling, and leasing the amount of the sold goods based on the return percentage. Shapex also provides you with valuable information and analytics, such as customer feedback, sales reports, inventory management, and more.',
          t28: 'A Professional Website Builder for Social Media Shops',

          t29: 'Internal post',
          t30: '<h2> Send your package with a variety of <b> domestic mail </b> services! </h2>',
          t31: 'With the ever-increasing expansion of sales and advertising methods, one of the oldest sales methods, telemarketing using call centers, is still one of the most effective methods in sales.',
          t32: 'Now you can upload all your products in your personal panel and use 4 methods of free shipping, on-site payment, cash payment, safe buying and selling, and facilities such as leasing the amount of the sold goods based on the return percentage, such as a permanent credit line from Shopex. and with this method you can get great facilities and information',
          t33: 'Don\'t worry about sending your package by post bar',

          t34: 'kadox',
          t35: '<h2>Kadox: A <b>Gift Delivery Service</b> that Makes Your Loved Ones Happy</h2>',
          t36: 'Have you ever wanted to surprise someone with a gift on their birthday, but couldn’t be there in person? Have you ever ordered a gift online, but it arrived late or damaged? If so, you need Kadox, a gift delivery service that guarantees your satisfaction and happiness.' +
             'Kadox is a gift express system that allows you to send wrapped gifts, flowers, and even cakes to your loved ones in any city. You can choose from a variety of gifts and customize them according to your preferences. You can also add a personal message or a card to make your gift more special. Kadox delivers your gift on time and in perfect condition, so you can make your loved ones feel appreciated and loved. Kadox is the best way to send gifts and spread joy.',
          t37: 'Gift Delivery Service that Makes Your Loved Ones Happy',

          t38: 'Postex yar',
          t39: '<h2> Postex Yar: A <b>Postal Service</b> for Everyone',
          t40: 'Do you have a disability or a limitation that makes it hard for you to use a smartphone or the internet? Do you want to send or receive parcels without any hassle or delay? If so, Postex Yar is the service for you. Postex Yar is a new postal service that caters to the needs of people with disabilities, veterans, or anyone who prefers a more personal and convenient way of sending and receiving parcels.' +
             'With Postex Yar, you don’t need to register your order online or use an app. You just need to call Postex Yar and request a collector to come to your door. The collector will pick up your parcel, fill out the necessary information, and deliver it to the destination in the shortest possible time. Postex Yar is a postal service that respects your privacy, dignity, and comfort.',
          t41: 'Postal Service for Everyone',
          t42: 'Coming Soon'
        },
        s3: {
          t1: 'How to Become a Postex Representative',
          t2: '<h2>Do you want to earn money by working as a <b>cargo handler</b> and <b>representative for Postex? </b></h2>',
          t3: 'If so, you can apply for a Postex agency and start your cooperation with us. Postex agency is a great opportunity for anyone who wants to work independently and flexibly, with minimal costs and maximum benefits. To become a Postex representative, you need to follow these steps:',
          t4: ' More Info',
          t5: 'Your agency request has been approved!',
          t6: 'Fill out an online agency request form on our website.',
          t7: 'Wait for our technical team to contact you and confirm your eligibility.',
          t8: 'Provide the required documents, such as checks, promissory notes, contracts, car and motorcycle papers, business lease, etc.',
          t9: 'Receive your Postex agency certificate and start your work.'
        },
        s4: {
          t1: 'Postex Apps',
          t2: '<h2>Now you can enjoy <b>Postex</b> on your <b>Android</b> smartphone</h2>',
          t3: '',
          t4: 'You can use the Postex app on your Android smartphone to create and track your shipments, find a Postex location, get cost estimates, choose from different postal options, and more. You can also use the Postex Tracking app to track the status of your parcels and get notifications. The Postex apps are free, easy, and secure.',
          t5: 'Google Play',
          t6: 'cafe bazaar',
          t7: 'Track your order. Anytime, anywhere!',
          t8: 'postex',
          t9: 'memaran behtarh',
          t10: 'Postex system (www.postex.ir) is Iran\'s first comprehensive door-to-door postal online transportation system.',
          t11: '',
          t12: ''

        },
        s5: {
          t1: 'Postex colleagues',
          t2: '<h2>Services that we are <b>honored to cooperate</b> with</h2>',
          t3: 'Snapbox',
          t4: 'Speed Co',
          t5: 'Ganja Co',
          t6: 'bio post (cold post)',
          t7: 'Sky Post',
          t8: 'blue sky way',
          t9: 'Foreign post',
          t10: 'Aramex',
          t11: 'chapar',
          t12: 'leading post',
          t13: 'Mahex',
          t14: 'National post of Iran',
          t15: 'box Yar',
          t16: 'Nedex',
          t17: 'kala resan',
        },
        s6: {
          t1: 'Postex newsletter',
          t2: '<h2> <b>Latest News</b>!</h2>',
          t3: 'Please enter your email...',
          t4: 'Subscribe',
        }

      },
      homeMobile: {
        t1: 'Tracking of shipments',
        t2: 'Please enter your information',
        t3: 'Postal barcode',
        t4: 'Shipment interception',
        t5: 'Quick calculation of postage',
        t6: 'Send your package',
        t7: 'Quick calculation of postage',
        t8: 'Internal mail',
        t9: 'Foreign post',
        t10: 'sender',
        t11: 'City - Province',
        t12: 'Receiver',
        t13: 'size',
        t14: 'Select',
        t15: 'product price ($)',
        t16: 'Shipment weight (grams)',
        t17: 'Distribution',
        t18: 'Collect',
        t19: 'packing',
        t20: 'sender',
        t21: 'Country',
        t22: 'Call for price',
        t23: 'My packages',
        t24: 'Post delivery given',
        t25: 'Last update: 3 hours ago',
        t26: 'Order number',
        t27: 'Mobile sender/receiver',
        t28: 'Postal barcode or Order number',
        t29: 'Send your first package',
        t30: 'start order',
        t31: 'Shipment tracking or price inquiry'
      },
      dashboard: {
        sideBar: {
          t1: 'Address book',
          t2: 'Messages',
          t3: 'My Order',
          t4: 'Invoice request',
          t5: 'Introduction points',
          t6: 'Settings',
          t7: 'Sign out',
          t8: 'List of addresses',
          t9: 'Orders Of Others for me',
          t10: 'my requests',
        },
        address: {
          t1: 'Address book',
          t2: 'Add new address',
          t3: 'Search in previous addresses',
          t4: 'first name',
          t5: 'last name',
          t6: 'phone number',
          t7: 'company name',
          t8: 'Add province',
          t9: 'city - province',
          t10: 'Address text',
          t11: 'Text address',
          t12: 'save',
          t13: 'Type part of the address',
          t14: 'Tehran - Akbatan town - ...',
          t15: 'list address',
          t16: 'address',
          t17: 'Receiver',
          t18: 'select city',
          t19: 'Sender',
          t20: 'address for',
          t21: 'Do you want to delete the address?',
          t22: 'accept',
          t23: 'cancel',
          t24: 'Select address as default',
          t25: 'default address',
          t26: 'Address Edit'
        },
        message: {
          t1: 'messages'
        },
        order: {
          t1: 'my orders',
          t2: 'all',
          t3: 'Paid',
          t4: 'suspended',
          t5: 'print',
          t6: 'order number',
          t7: 'Payment status',
          t8: 'order status',
          t9: 'Shipping status',
          t10: 'sender',
          t11: 'Receiver',
          t12: 'price',
          t13: 'dollar',
          t14: 'payment',
          t15: 'Payment Method',
          t16: 'cancel',
          t17: 'Orders Of Others for me',
          t18: 'order search',
          t19: 'from date',
          t20: 'to date',
          t21: 'search',
          t22: 'close',
          t23: "cancel",
          t24: "Collect",
          t25: "edit",
          t26: "details",
          t27: "order number",
          t28: "Consignment Number",
          t29: "order status",
          t30: "payment status",
          t31: "tracking number",
          t32: "date",
          t33: "province/City of origin",
          t34: "City of origin",
          t35: "source address",
          t36: "Sender full Name",
          t37: "Last Name of Sender",
          t38: "sender's mobile number",
          t39: "destination province/City",
          t40: "Destination City",
          t41: "destination address",
          t42: "recipient full name",
          t43: "recipient's last name",
          t44: "Contents of shipment",
          t45: "shipment weight",
          t46: "insurance cost",
          t47: "requires a printer",
          t48: "shipment value",
          t49: "electronic registration rights",
          t50: "need cartoon",
          t51: "package length",
          t52: "wrap width",
          t53: "package height",
          t54: "need to print logo",
          t55: "need to collect",
          t56: "need to distribute",
          t57: "Yes",
          t58: "No",
          t59: "details order",
          t60: "shipment info",
          t61: "Services",
          t62: " not available ",
        },
        affiliate: {
          t1: 'Introduction points',
          t2: 'Receive invitation code',
          t3: 'Get a gift by inviting your friends to Postex',
          t4: 'copied',
        },
        setting: {
          t1: 'setting',
          t2: 'Service to receive order information email',
          t3: 'Access to the printer',
          t4: 'Access to the postal package',
          t5: 'upload brand',
          t6: 'Changing theme',
          t7: 'Changing language',
          t8: 'save',
        },
        requestFactor: {
          t1: 'factor list',
          t2: 'request factor',
          t3: 'first name',
          t4: 'last name',
          t5: 'national code',
          t6: 'economic Code',
          t7: 'foriegn Code',
          t8: 'postal Code',
          t9: 'address',
          t10: 'request',
          t11: 'Pending'
        }
      },
      wallet: {
        t1: 'Increase credit',
        t2: 'Choose the amount',
        t3: 'Select',
        t4: 'desired amount (riyals)',
        t5: 'Choose a payment method',
        t6: 'Mellat Bank',
        t7: 'Payment and credit increase',
        t8: 'financial report',
        t9: 'weekly',
        t10: 'monthly',
        t11: 'yearly',
        t12: 'dollar',
        t13: 'deposit',
        t14: 'harvest',
        t15: 'financial report',
        t16: 'Row',
        t17: 'Transaction type',
        t18: 'Amount',
        t19: 'Transaction date',
        t20: 'Transaction number',
        t21: 'pocket',
        t22: 'Which order',
        t23: 'confirm and pay',
        t24: 'credit transfer',
        t25: 'phone number',
        t26: 'desired amount (riyals)',
        t27: 'Choose the amount',
        t28: 'Current Balance',
        t29: 'List of wallet',
        t30: 'Clear transaction list',
        t31: 'Checkout'

      },
      singleOrder: {
        t1: 'previous level',
        t2: 'next level',
        t3: 'Order completion',
        t4: 'Payment',
        t5: 'cancel',
        t6: 'Factor',
        step: {
          t1: 'sender',
          t2: 'Receiver',
          t3: 'Package info',
          t4: 'Service type',
          t5: 'Review',
        },
        sender: {
          t1: 'Register the address of the sender',
          t2: 'bulk order',
          t3: 'Select previous addresses',
          t4: 'Add new address',
          t5: 'Register sender information',
          t6: 'first name',
          t7: 'last name',
          t8: 'mobile number',
          t9: 'email',
          t10: 'company name',
          t11: 'address',
          t12: 'Need to collect',
          t13: 'If you choose the need to collect, your shipment will be collected from the sender\'s door' +
             'If the order is placed before 8:00 am, it will be collected today by 6:00 pm and after 8:00 a.m. tomorrow (if there is no holiday) it will be collected by 6:00 pm',
          t14: 'Select previous addresses',
          t15: 'Choose a address',
          t16: 'Enter a part of the profile or mobile phone or previous address',
          t17: 'Add new address',
          t18: 'Add address',
          t19: 'Province / city of origin',
          t20: 'Address text',
          t21: 'Text address',
          t22: 'add',
          t23: 'If you do not choose to collect the parcel, you must deliver it to the Postex representative office or the chosen postal service.',
          t24: 'Select city',
          t25: 'phone number (with city code)',
          t26: 'national code',
          t27: 'Postal code',
          t28: 'Search for your city',
          t29: 'select sender Coordinate ',
          t30: 'more',
          t31: 'close',
          t32: "Select the address from the map (optional)"
        },
        receiver: {
          t1: 'Register the address of the Receiver',
          t2: 'bulk order',
          t3: 'Select previous addresses',
          t4: 'Add new address',
          t5: 'Register Receiver information',
          t6: 'first name',
          t7: 'last name',
          t8: 'mobile number',
          t9: 'email',
          t10: 'company name',
          t11: 'address',
          t12: 'Need to distribute',
          t13: 'If you choose the need for distribution, your shipment will be distributed at the recipient\'s location',
          t14: 'Select previous addresses',
          t15: 'Choose a address',
          t16: 'Enter a part of the profile or mobile phone or previous address',
          t17: 'Add new address',
          t18: 'Add address',
          t19: 'Province / city of destination',
          t20: 'Address text',
          t21: 'Text address',
          t22: 'add',
          t23: 'If you do not select the need for distribution, the parcel will be delivered to the representative office of the postal company',
          t24: 'Select city',
          t25: 'phone number (with city code)',
          t26: 'national code',
          t27: 'Postal code',
          t28: 'Search for your city',
          t29: 'select Receiver Coordinate'
        },
        packageInfo: {
          t1: 'Package information',
          t2: 'The contents of the shipment',
          t3: 'dollar value of the shipment',
          t4: 'Shipment weight (grams)',
          t5: 'Postal package size',
          t6: 'I want packaging',
          t7: 'Print receipt',
          t8: 'SMS notification',
          t9: 'SMS notification has been activated',
          t10: 'Lorem Epsom is a mock text produced with incomprehensible simplicity from the printing industry, and used by graphic designers.',
          t11: 'confirmation',
          t12: 'Your brand',
          t13: 'payment type',
          t14: 'Pay shipping - normal',
          t15: 'Payment on site (COD)',
          t16: 'Payment of shipping and goods-amnito',
          t17: 'free delivery',
          t18: 'So rent',
          t19: 'Add package',
          t20: 'Package added successfully',
          t21: 'You can see your package information from the package details section',
          t22: 'breakable',
          t23: 'Contains liquids',
          t24: 'If you choose the need for packaging, your shipment will be packed and the bill of lading label will be installed on it after collection and at the Postex warehouse.',
          t25: 'If you do not select the need for packaging, deliver the parcel to the Postex collector with standard packaging.',
          t26: 'If you choose the need to print a bill of lading label, your shipment will be labeled and a bill of lading label will be installed on it after collection and at the Postex warehouse.' +
             'When delivering the parcel to the Postex collector, write your order number on the parcel in such a way that it cannot be torn off or erased.',
          t27: 'If you do not select the need to print the bill of lading label, print the label and install it on the shipment and deliver it to the Postex collector.',
          t28: 'The postal review must be printed and affixed to the package',
          t29: 'If you select the SMS notification option in all sending stages, the status of the shipment will be notified to the recipient and the sender via SMS.',
          t30: 'If you do not have access to a printer to print your waybill label, select the option to print an review. After collecting the cargo at the Postex warehouse, the label will be attached to the shipment, and at the time of delivery to the Postex collector, you must enter the shipment number on the shipment.',
          t31: 'You select the option of needing to print the review, print the bill of lading label and attach it to the bill of lading',
          t32: 'If your shipment contains breakable goods, select the breakable option.',
          t33: 'If your shipment contains liquids, select the liquids option.',
          t34: "The cost of shipping + the cost of goods at the door of the recipient is the responsibility of the recipient",
          t35: "The shipping fee is paid by the sender or recipient",
          t36: "All shipping costs and the value of the goods are received from the recipient and the total amount received is deposited into the sender's account after deducting the costs specified in the rules.",
          t37: "The cost of goods and shipping is paid by the recipient and the deposit remains with Postex until the goods are received from the sender",
          t38: "The cost of sending the parcel at the time of delivery to the recipient will be collected from them",
          t39: 'Agency services',
          t40: 'Agent services',
          t41: "dollar value of the consignment to determine the limit of obligations",
          t42: "Register store request to activate more payment methods",
          t43: "store request",
          t44: "Payment methods",
        },
        serviceType: {
          t1: 'Choose a server',
          t2: 'cheapest',
          t3: 'fastest',
          t4: 'Most Popular',
          t5: 'Available services',
          t6: 'Unavailable services',
          t7: 'Service type',
          t8: 'shipping time',
          t9: 'Post price and technical services',
          t10: 'Description',
          t11: 'dollar',
          t12: 'Collect',
          t13: 'Distribution',
          t14: 'Insurance up to the limit',
          t15: 'Service selection is required',
          t16: 'Choose one of the agencies below',
          t17: "approximate price",
          t18: "Collecting the shipment from the sender's door",
          t19: "Currently, Postex collects the parcel from your door by charging the following fee, by disabling this option, the sender is responsible for delivering the parcel." +
             "The collection time for orders placed after 8:00 AM is the next day from 8:00 AM to 5:00 PM.",
          t20: "Collection price",
          t21: "Centers near you for package delivery",
          t22: "Due to the fact that the need to collect tick has not been selected by you, you are responsible for the delivery of the goods.",
          t23: "change status",
          t24: "Address of centers near you for package delivery",
          t25: "No service found for your selected origin",
          t26: "Choose one of the centers on the map",
          t27: "This service is not active for your entered information",
          t28: "The center of your choice",
          t29: "Your chosen service"
        },
        review: {
          t1: 'Package details',
          t2: 'pack',
          t3: 'The contents of the shipment',
          t4: 'Number of postal packages',
          t5: 'dollar value of the shipment',
          t6: 'dollar',
          t7: 'Shipment weight (gram)',
          t8: 'gram',
          t9: 'Postal package size',
          t10: 'size',
          t11: 'Invoice printing',
          t12: 'Receiver information',
          t13: 'Service type',
          t14: 'shipping time',
          t15: 'shipping cost',
          t16: 'packing',
          t17: 'Label printing',
          t18: 'Logo insertion',
          t19: 'technical and engineering service',
          t20: 'Collection at home',
          t21: 'Distribution',
          t22: 'Add a new order',
        },
        invoice: {
          t1: 'date and time',
          t2: 'Order number',
          t3: 'Proforma postal review and technical services',
          t4: 'Postal service',
          t5: 'Row',
          t6: 'Description',
          t7: 'Number',
          t8: 'Price (dollar)',
          t9: 'Total',
          t10: 'dollar including tax',
          t11: 'Technical services and support',
          t12: 'payment',
          t13: 'Order total',
          t14: 'dollar',
          t15: 'Pay with wallet',
          t16: 'Your inventory',
          t17: 'Mellat Bank',
          t18: 'Register a new order',
          t19: 'Technical services, insurance and collection of goods from the place and...',
          t20: 'Value added tax',

          t21: 'printing and pasting the invoice',
          t22: 'added value of agency',
          t23: 'Cost of cartons and wrappers',
          t24: 'Fees and finance charges',
          t25: 'shipping cost',
          t26: 'Amount of goods',
          t27: 'Insurance amount',
          t28: 'technical engineering services',
          t29: 'print trade mark',
          t30: 'electronic registration',
          t31: 'cost of SMS and interception',
          t32: 'collection fee',
          t33: 'discount code',
        }
      },
      multiOrder: {
        t1: 'previous level',
        t2: 'next level',
        t3: 'Order completion',
        s1: {
          t1: 'Sender information',
          t2: 'Select previous addresses',
          t3: 'Add new address',
          t4: 'Service information',
          t5: 'Service type',
          t6: 'Select',
          t7: 'Affixing the trademark on the review',
          t8: 'Postal envelope / carton',
          t9: 'SMS notification',
          t10: 'SMS notification has been activated',
          t11: 'Lorem Epsom is a mock text produced with incomprehensible simplicity from the printing industry, and used by graphic designers.',
          t12: 'confirmation',
          t13: 'Download the Excel file',
          t14: 'Upload Excel file',
          t15: 'Choose an address',
          t16: 'Enter a part of the profile or mobile phone or previous address',
          t17: 'Add address',
          t18: 'Select city',
          t19: 'Address text',
          t20: 'Text address',
          t21: 'add',
          t22: 'Row',
          t23: 'operations',
          t24: 'Is it breakable?',
          t25: 'Does it contain liquids?',
          t26: 'Receive the raw Excel file for pre-rental orders',
          t27: 'Receive the raw Excel file for COD orders.',
          t28: 'Search for your city',

        },
        s2: {
          t1: 'Shipment information',
          t2: 'New line',
          t3: 'consignment',
          t4: 'contents of the shipment',
          t5: 'Postal package size',
          t6: 'Select',
          t7: 'length',
          t8: 'width',
          t9: 'Height',
          t10: 'dollar value of the shipment',
          t11: 'Shipment weight (grams)',
          t12: 'Insurance',
          t13: 'Add recipient information',
          t14: 'Receiver information',
          t15: 'Select recipient address',
          t16: 'first name',
          t17: 'last name',
          t18: 'phone number (with city code)',
          t19: 'company name',
          t20: 'address',
          t21: 'Enter a part of the profile or mobile phone or previous address',
          t22: 'Select city - province',
          t23: 'Text address',
          t24: 'add',
          t25: 'Search for your city',
          t26: "Rial value of the consignment to determine the limit of obligations"
        }
      },
      packing: {
        t1: 'Shipment information',
        t2: 'contents shipment',
        t3: 'dollar value',
        t4: 'dollar',
        t5: 'weight shipment',
        t6: 'grams',
        t7: 'Postal package size',
        t8: 'Number of postal packages',
        t9: 'Current order details',
        t10: 'Receiver',
        t11: 'Phone number (with city code)',
        t12: 'receiver address',
        t13: 'Service type',
        t14: 'Need to collect',
        t15: 'Label printing',
        t16: 'Logo insertion',
        t17: 'Edit the information sent',
        t18: 'contents shipment',
        t19: 'dollar value',
        t20: 'Shipment weight (grams)',
        t21: 'Package size',
        t22: 'Number of postal packages',
        t23: 'Invoice printing',
        t24: 'add',
        t25: 'Unit price',
        t26: 'Save changes',
        t27: 'yes',
        t28: 'no',
        t29: 'length',
        t30: 'width',
        t31: 'height',
      },
      sendTicket: {
        t1: 'support',
        t2: 'Please first before submitting a support ticket ',
        t3: 'common questions',
        t4: 'see that',
        t5: 'subject ticket',
        t6: 'Select the topic',
        t7: 'first name and last name',
        t8: 'mobile or email',
        t9: 'order code',
        t10: 'Tracking Code',
        t11: 'Priority',
        t12: 'Message text',
        t13: 'Product Type',
        t14: 'Select the type of product',
        t15: 'New product',
        t16: 'Category two goods',
        t17: 'Product Name',
        t18: 'Purchase price',
        t19: 'Product brand name',
        t20: 'Shaba number',
        t21: 'Description',
        t22: 'Phone',
        t23: 'Postal code',
        t24: 'National Code',
        t25: 'National card serial number',
        t26: 'Date of birth',
        t27: 'account number',
        t28: 'Name of the bank branch',
        t29: 'Province - city',
        t30: 'address',
        t31: 'select picture',
        t32: 'Up to 3 JPEG images, up to 1 MB',
        t33: 'Register and send',
        t34: 'Request for damages',
        t35: 'Rent request',
        t36: 'other',
        t37: 'Department Name',
        t38: 'ticket type',
      },
      listTicker: {
        t1: 'My ticket list',
        t2: 'All tickets',
        t3: 'In the turn of sending to support',
        t4: 'has been answered',
        t5: 'Message text',
        t6: 'Answer support',
        t7: 'close',
        t8: 'Reply to support',
        t9: 'save and send',
      },
      faq: {
        t1: 'FAQ',
        t2: 'Search for the desired word...',
        t3: 'Fees and services',
        t4: 'Delivery schedule',
        t5: 'Postal and financial compensation and damages',
        t6: 'Postal prohibitions',
        t7: 'Submission limits',
        t8: 'Questions about obtaining representation',

        t9: 'Can I use post-rental or pay-on-the-spot services?',
        t10: 'By paying an annual fee, you can use post-rental services, free shipping and on-site payment (cod) of the Postex platform to register your application by referring to the Post-rental link, register your application in Postex and get informed about the prerequisites of your application. It should be noted that the cost of financial services for using free shipping and cash on delivery (cod) services is equivalent to 1-3% of the product value.',
        t11: 'Where can I send goods from or where are the cities covered by Postex?',
        t12: 'Study this page',
        t13: 'What are the rules for using Postex services?',
        t14: 'Study this page',
        t15: 'Does Postex also have foreign mail?',
        t16: 'Yes, refer to the page below to inquire about the postal price online',
        t17: 'How can I get a discount?',
        t18: 'The Postex smart system provides discounts by calculating the number of your shipments per month, but if you need to negotiate more, you can register your ticket by referring to the link below.',
        t19: 'I have an online store, what are the terms of cooperation with Postex?',
        t20: 'By registering on the Postex website and if you have a standard, non-trafficked and non-prohibited product, you can use Postex services in the form of prepaid, postpaid, free shipping and payment on site (cod).',
        t21: 'My shipment is not packed and how can I receive service from you?',
        t22: 'Dear customer, if in the city where you are placing your order, Postex has a warehouse representative, you can select the option "I do not need packaging" or "I do not have access to printing" when placing the order, after the shipment is collected by the Postex representative at the warehouse of the Postex representative. The pistachio packing and label will be barcoded, so please note that the representative will not be able to pack at your place.',
        t23: 'Do you have phone order registration and can you guide me through the website, how is it done?',
        t24: 'Unfortunately, it is not possible to place an order by phone in Postex, so you can place an order by referring to the link below and after registering.',
        t25: 'Does Postex also collect?',
        t26: 'Dear customer, in all places where Postex has a representative, Postex can collect it upon your request, and if there is no representative, you can personally deliver the cargo to the postal company after registering with Postex, which will include a discount.',
        t27: 'How much will it cost to send my parcel?',
        t28: 'Dear customer, you can compare the cost of various postal services by referring to the link below',

        t29: 'where is my bar',
        t30: 'Dear customer, various postal services have different schedules as follows:\n' +
           '          Postbar express service 24 to 48 hours\n' +
           '          Vantaz post service within the province 4 to 6 hours\n' +
           '          Interprovincial vanguard post service 7 to 9 hours\n' +
           '          Mahex service 24 to 48 hours\n' +
           '          Chapar service 36 to 72 hours\n' +
           '          Chapar Express service 36 to 48 hours\n' +
           '          Skypost service 24 to 48 hours\n' +
           '          Delivery service 36 to 48 hours\n' +
           '          Pik Hub inner city service 18 to 24 hours\n' +
           '          Please note that all the above schedules are working days and hours, and the calculation does not include holidays and is calculated from the time of delivery of the parcel to the Postex representative.\n' +
           'Therefore, if you want to know about the process of sending the parcel, please refer to the tracking link',
        t31: 'My shipment has not been collected. When will my shipment be collected?',
        t32: 'If you register before 8:00 am today, it will be collected until 19:00, and if you register after 8:00, it will be collected until 19:00 tomorrow. If you are not satisfied with the result of the interception, please let us know in the ticket so that our colleagues at Postex can handle it\n' +
           'If you placed your order before 8:00 AM today and your shipment has not been collected by 7:00 PM today, please notify us of your ticket by referring to the link below.',
        t33: 'They sent me several packages together, but I didn\'t receive the complete packages?',
        t34: 'Dear customer, please note that if several parcels are sent to you from the same source on the same day, they will not all reach you on the same day, because they may have been loaded on different machines for sending, so based on the time specified in the time Place an order for delivery, wait for the shipment to arrive, and if it takes longer than the scheduled time, contact us through a support ticket.',
        t35: 'The movement of my shipment has been stopped for several days and there is no progress, how can I follow up?',
        t36: 'Dear customer, please refer to the ticket link and wait for the call of our colleagues at Postex by registering your bill of lading number',
        t37: 'When will my shipment or package arrive?',
        t38: 'Dear customer, various postal services have different schedules as follows:\n' +
           '          Postbar express service 24 to 48 hours\n' +
           '          Vantaz post service within the province 4 to 6 hours\n' +
           '          Interprovincial vanguard post service 7 to 9 hours\n' +
           '          Mahex service 24 to 48 hours\n' +
           '          Chapar service 36 to 72 hours\n' +
           '          Chapar Express service 36 to 48 hours\n' +
           '          Skypost service 24 to 48 hours\n' +
           '          Delivery service 36 to 48 hours\n' +
           '          Pik Hub inner city service 18 to 24 hours\n' +
           '          Please note that all the above schedules are working days and hours, and the calculation does not include holidays and is calculated from the time of delivery of the parcel to the Postex representative.',
        t39: 'My shipment is pending, what should I do?',
        t40: 'If the tracking shows your shipment at the pending counter, you can go to the pending counter of your city\'s postal company and pick up the shipment within 5 days, and if the tracking shows the postman\'s visit twice and you have an appointment on the same day, you can go to the postal company. Receive the shipment.',

        t41: 'What should I do to receive compensation for the damaged parcel that I received?',
        t42: 'The responsibility for guaranteeing the compensation of postal items is up to the recipient\'s door, so if you have received the item, it does not include any type of damage guarantee, because you have the opportunity to ask the postman at the time of delivery to allow the content of the item to be checked for health or compliance with the order. control\n' +
           '          Now, if you did not manage to do this and your shipment was sent through the National Post Company and if a maximum of 24 hours has passed since the delivery time, try your luck to receive compensation by referring to the postal compensation system.\n' +
           '          If your shipment is other than postal bans, we do not provide any service to track the parcel (postal bans link).\n' +
           '          If you are not satisfied with the result of the interception, please let us know in the ticket so that our colleagues at Postex can handle it',
        t43: 'Why hasn\'t the payment been made for my goods that have reached their destination?',
        t44: 'Dear customer, basically, the status of distribution does not mean the settlement of the value of the shipment, and if you see the status of confirmation or financial settlement, your money will be paid after 48 hours.\n' +
           'If you are not satisfied with the result of the answer and more than 48 hours have passed since the change of status to confirmation and financial settlement, please indicate in the ticket so that our colleagues at Postex can handle it.',
        t45: 'I requested the cancellation of the shipment, but my money has not been deposited or has been deposited less',
        t46: 'Dear customer, if you have a request to cancel the order before visiting the collector, the refund will be paid to you without deducting any money after 48 hours of delivery.\n' +
           '  But if you have a request to cancel the order after sending the collector, after deducting the collection costs, the remaining amount will be returned.\n' +
           'Now, if you have a request to cancel your order after complete collection, no money will be returned and you will be charged a fee of 50,000 Tomans to return the shipment to the origin. Please register your request by referring to the link below to cancel the order.',
        t47: 'Do you have phone order registration and can you guide me through the website, how is it done?',
        t48: 'Unfortunately, it is not possible to place an order by phone in Postex, so you can place an order by referring to the link below and after registering.',
        t49: 'The address and information were registered incorrectly and my shipment was sent. Can you help me?',
        t50: 'If you have registered an address in Postex, it is not possible to change the address after receiving the barcode.',
        t51: 'My shipment is not packed and how can I receive service from you?',
        t52: 'Dear customer, if in the city where you are placing your order, Postex has a warehouse representative, you can select the option "I do not need packaging" or "I do not have access to printing" when placing the order, after the shipment is collected by the Postex representative at the warehouse of the Postex representative. The pistachio packing and label will be barcoded, so please note that the representative will not be able to pack at your place.\n' +
           '  At the same time, please note that if you need packaging service at the time of delivery, you should write the barcode number and your order on the package in such a way that it will not be erased until the end of the shipment.',
        t53: 'How can I get a discount?',
        t54: 'The Postex smart system provides discounts by calculating the number of your shipments per month, but if you need to negotiate more, you can register your ticket by referring to the link below.',
        t55: 'When I check the tracking code, it says that the package has been delivered to the recipient, but I, who am the recipient, did not receive the package! what should I do?',
        t56: 'Dear customer, please refer to the ticket link and wait for the call of our colleagues at Postex by registering your bill of lading number',

        t57: 'Can I send gold or silver?',
        t58: 'You cannot send gold and silver through postal companies, because this type of shipment is prohibited by the postal service, and the responsibility for sending this type of shipment is the responsibility of the sender, and it does not include any guarantee of compensation.',
        t59: 'Can I send a check or cash or official documents?',
        t60: 'You are not able to send checks or cash or administrative documents through postal companies, because these types of mails are prohibited by mail and the responsibility of sending these types of mails is the responsibility of the sender and does not include any guarantee of compensation.',
        t61: 'What are postal restrictions?',
        t62: '-',

        t63: 'Can I ship fragile cargo or liquids?',
        t64: 'You can send liquids and breakables if you choose breakables or liquids when placing the order and make sure to use the appropriate packaging for this, otherwise you are responsible for the freight.',
        t65: 'What is the maximum weight I can send?',
        t66: 'The maximum weight in postal services is equal to 30 kg\n' +
           '          The maximum weight in Mahex services is equal to 30 kg\n' +
           '          The maximum weight in Chapar services is 35 kg\n' +
           '          The maximum weight in Sky Post is equal to 50 kg\n' +
           '          The maximum weight in the carrier is equal to 50 kg\n' +
           '          The maximum weight in podo is equal to 50 kg\n' +
           '          The maximum weight in the courier hub is equal to 50 kg',
        t67: 'What is the maximum size that I can send?',
        t68: '-',
        t69: 'I don\'t know what is the size of my package?',
        t70: 'Dear customer, please refer to the link below to familiarize yourself with the size of postal packages and make the right choice when choosing the size of the shipment.',
        t71: 'The address and information were registered incorrectly and my shipment was sent. Can you help me?',
        t72: 'If you have registered an address in Postex, it is not possible to change the address after receiving the barcode.',


        t73: 'How to get a Postex representative?',
        t74: 'You can register your application by referring to the link to get representation in Postex and get informed about the prerequisites of your application',
        t75: 'How is the income of the agency?',
        t76: 'The answer to this question lies in the regional effort of the representative to attract postal items from the same region, which means that by obtaining a Postex representative, you have access to all kinds of postal services and you can guarantee your income by marketing from that region.\n' +
           'Reference to the page for getting representation in Postex',

        t77: 'If you have not found the answer to your question\n' +
           '   Contact support.',
        t78: 'Postex support team will answer you as soon as possible\n' +
           '  It will be and will answer you.',
        t79: 'Contact support',
        t80: 'page link'
      },
      profile: {
        t1: 'User account settings',
        t2: 'first name',
        t3: 'last name',
        t4: 'phone number (with city code)',
        t5: 'Contact support to edit the phone number',
        t6: 'Identification code',
        t7: 'Change password',
        t8: 'Current password',
        t9: 'New password',
        t10: 'Repeat password',
        t11: 'save',
        t12: 'Get Code',
        t13: 'change Password',
        t14: 'One time code',
        t15: 'cart number',
        t16: 'sheba number',
        t17: 'national code'
      },
      myPackage: {
        t1: 'my package',
        t2: 'Order number',
        t3: 'sender name',
        t4: 'receiver address',
        t5: 'Service type',
        t6: 'remaining time',
        t7: 'Delivery history',
        t8: 'received',
        t9: 'Warehouse delivery',
        t10: 'courier delivery',
        t11: 'Delivery of the parcel',
      },
      map: {
        t1: 'search...'
      },
      error: {
        t1: 'Log in first',
        t2: 'Nothing found',
        t3: "According to the entered items, including the size or Rial value, the service is not available. Please go back to the previous step and change the items.",
        t4: "Entering the name is required",
        t5: "Entering the last name is required",
        t6: "Entering the mobile number is required",
        t7: "The mobile number entered is invalid",
        t8: "Entering the address is required",
        t9: "Your address is not correct",
        t10: "Your address should not be more than 150 characters",
        t11: "Your name should not be more than 50 characters",
        t12: "Your last name should not be more than 50 characters",
        t13: "Your address does not have a location",
        t14: "The entered postal code is invalid",
        t15: "The entered mobile number is invalid",
        t16: "The entered phone number is invalid",
        t17: "The email entered is invalid",
        t18: "Company name should not be more than 50 characters",
        t19: "The sender's mobile number and the recipient's mobile number should not be the same",
        t20: "Selecting the city and province of the sender is mandatory",
        t21: "Selecting the recipient's city and province is mandatory",
        t22: "It is required to enter the size of the postal package",
        t23: "It is mandatory to enter the weight of the shipment",
        t24: "The weight of the shipment should not be less than 50 grams",
        t25: "It is mandatory to enter the Riyal value of the shipment",
        t26: "It is mandatory to enter the contents of the shipment",
        t27: "Choosing the type of payment is required",
        t28: "Choosing the receiving country is mandatory",
        t29: "Selecting or entering the amount is required",
        t30: "Select a port",
        t31: "Entering the national code is required",
        t32: "Password is required",
        t33: "Re-enter your password",
        t34: "Passwords must be the same",
        t35: "Entering a one-time code is required",
        t36: "It is mandatory to enter the topic",
        t37: "Priority entry is required",
        t38: "Entering the section name is required",
        t39: "It is mandatory to enter the ticket type",
        t40: "Entering the order code is required",
        t41: "Entering tracking code is required",
        t42: "Entering the text of the message is required",
        t43: "It is mandatory to enter Shaba number",
        t44: "Entering the amount is required",
        t45: "Selected file must be less than 2 MB",
      },
      autoComplete: {
        t1: 'No Option'
      },
      rules: {
        t1: 'Postex rules',
        t2: 'The timing of collection of orders whose request is from 8:00 am to 8:00 am the next day will be collected by 7:00 pm and in the case of force majeure, the collection will be done with a 24-hour delay without any objection.',
        s1: {
          t1: 'Implementation rules',
          t2: 'I undertake to declare the weight and content of the package accurately and honestly. If the declared weight is inconsistent with the actual weight (which is specified in the analysis and exchanges unit), the order will be canceled and the responsibility for the delay in sending I will be responsible for the cost of reordering or any damage caused by this',
          t3: 'I undertake to declare the recipient\'s address correctly in the system so that the order will not be returned or the maintenance costs at the counter will not be delayed.',
          t4: 'I undertake to coordinate with the recipient to receive the shipment that is pending at the counter',
          t5: 'I undertake to choose the correct address of the sender, including the province, city and region, and if this is not done correctly, I will be responsible for the delay in collecting or canceling the order.',
          t6: 'I undertake to be present from Saturday to Thursday in order to deliver the parcel to the collector until 19:00 at the stated place of order registration (sender\'s address) will not be returned and I also promise that I will not have any claim in this regard. Also, in rainy or snowy weather conditions, or tropical areas (temperature above 45 degrees) and cold areas (temperature below zero degrees), there is a possibility that the collection process will be delayed.',
          t7: 'I declare again that I agree that all orders placed on Fridays and holidays will be collected on the first working day after placing the order, and I will not have any objection in this regard.',
          t8: 'I promise that I will report any complaints regarding the damage caused to any shipment within 24 hours after the order from and non-acceptance of that shipment, and otherwise I will not have any objection. In addition, the obligation of insurance of the shipment until the moment of its delivery to the credit recipient. Will have',
          t9: 'I undertake not to put perishable goods, postal prohibitions and smuggling, weight more than 30 kilos, liquids and dimensions more than 1 meter in the mail and to observe the contents of the postal prohibitions clause.',
          t10: 'I undertake not to send breakable goods unless I have complied with all the packaging regulations, that in case of non-compliance with the above regulations and damage occurs, I will not have any objection and the responsibility for the content of all the goods included in the package is my responsibility, as well as the company\'s It has no responsibility for informing about the packaging of the shipment, and if the shipment is sent with any kind of packaging, the consequences are the responsibility of the sender.',
          t11: 'I undertake to print the PDF file of my order that contains the tracking code and paste it on the package and sign it, and then sign the other copy and keep it with me as a receipt. I must respect the contents of the postal package and if I do otherwise, all the responsibilities for damages etc. will be my responsibility and if I do not have access to the printer, I will write the address of the sender, receiver and order number on the package sent with Insert magic',
          t12: 'I promise that my username and password will not be used by anyone else, otherwise all the responsibilities and obligations contained in the clauses of this commitment letter will be my responsibility.',
          t13: 'I undertake to do all the necessary things regarding correct packaging and baling at my own expense so that the package does not break during transportation, and if my shipment needs repackaging, I will pay for it according to the expert\'s opinion or the packaging amount from the bag account. My money will be deducted automatically',
          t14: 'The working process of the system is such that the orders that are registered before 12 o\'clock in pre-fare and 7 o\'clock in post-fare and COD are referred to the postal operator or courier for collection on the same day and collected from the registered place by 6 p.m. to be collected for the sender, that I undertake that in case of 24 hours delay in collection, I have waived the right to object to the collection of the goods.',
          t15: 'I am committed and informed that the collection of goods is done from the door of the home or workplace and the process of receiving it is such that the goods must be delivered to the collector at the entrance of the building and if necessary to see the contents of the consignment. It is possible to visit it',
          t16: 'I undertake that if I refuse to include the signature in the customer\'s signature section of the review (which was automatically downloaded and provided to me after placing the order), I will waive the right of any objection to receive compensation due to damage or loss of the shipment. These items have once again been confirmed by me at the time of payment of the sending fee electronically (at the time of payment, I confirmed that I read and accept the rules)',
          t17: 'I promise that if the postal company refuses to carry my package for any reason, I will waive the right to protest and will not be allowed to complain in this regard.',
          t18: 'For information about the process of paying the headquarters fee, refer to the instruction section on the site',
          t19: 'If you use an invalid barcode (cancelled) or a barcode that has already been shipped. You will be fined up to 5 times the cost of the barcode used',
          t20: 'The collected shipment will not be returned under any circumstances unless it has a legal problem',
        },
        s2: {
          t1: 'Financial rules',
          t2: 'Order cancellation',
          t3: 'I accept that if I place an order through Postex, if I request to cancel the order, no amount will be refunded.',
          t4: 'I accept that if a package is not delivered at the time of delivery, the package will be canceled.',
          t5: 'I undertake and accept that if the shipment is from a non-postal system, it can be canceled before collection, and if collection is requested or collection is done, no money will be returned for cancellation.',
          t6: 'The duration of sending the package is specified in the description of each postal operator according to the SLA. Shipments that are sent and delivered after the delivery time exceeds the time specified in the SLA table will be subject to compensation for the delay in delivery, which must be registered through eop.post.ir.',
          t7: 'To use COD service, the amount of 1,500,000 riyals will be blocked in the wallet. In case of request to cancel the post-rental account, if the number of registered post-rental orders is less than 10 orders, the amount will be returned, and if more than 10 orders are registered, the amount will not be returned, and the blocked amount can be used instead of the cost of the pre-rental order.',
          t8: 'Dear customer, if you have a request to return the wallet, this is possible by sending a ticket and requesting the return of the wallet. 72 hours after sending the ticket and announcing the Shaba number, the remaining amount of your wallet will be returned.',
        },
        s3: {
          t1: 'Insurance obligations',
          t2: 'All parcels are insured up to the recipient\'s door, and no compensation will be paid after being delivered to the recipient and receiving the recipient\'s signature, so the recipient should refrain from receiving the damaged parcel.',
          t3: 'The company pays the compensation for the damage of the shipment only if it has packed the goods itself. Also, the selected insurance will not cover products that do not have standard packaging',
          t4: 'Customers who request damages more than 2 times in 100 shipments, no damages will be paid even if the above conditions are met.',
          t5: 'If the product is second-hand, the price of a similar new product will be paid after estimating 50% of the price of the new product up to the requested insurance limit.',
          t6: 'When requesting compensation for mails registered with the service, the national card details of the compensation applicant (national card image), address and account number must be entered in the details section of the compensation applicant in the eop.post.ir link.',
        }
      },
      paymentStatus: {
        t1: 'Your payment has been successfully completed',
        t2: 'Your payment was unsuccessful',
        t3: 'Total Amount',
        t4: 'dollar',
        t5: 'Order code',
        t6: 'Tracking Code',
        t7: 'order date',
        t8: 'Add a new order',
        t9: 'Back to the main page',
        t10: 'Return to the orders page',
        t11: 'Print review',
        t12: 'System survey',
        t13: 'Back to chat divar',
      },
      about: {
        t1: 'Send with easy Postex!',
        t2: 'Postex, the first comprehensive transportation service system in the country.',
        t3: 'This system provides unique services by using all types of domestic and foreign express postal services door to door and with special prices.\n' +
           'provides to its customers. Another prominent and important point of this system is the use of strong and excellent support systems\n' +
           'Its customers benefit from 24-hour support services.',
        t4: 'Postex services',
        t5: 'In the Postex system, business owners and industries will be able to use the cooperation of postal operators, including the various services of the First Post operator.\n' +
           '  Chapar, Snapbox, DPE, DTS, TPG, TAPAG service, from a variety of urban and intercity mail services in the country and foreign mail with\n' +
           'Using the service of DPE and TPG companies and in the heavy transportation department of the Obar system service and with the possibility of comparing the price, speed and quality.\n' +
           'to use',
        t6: 'Door to door service and barcode production',
        t7: 'One of the highlights of the Postex system is the possibility of using all services door-to-door and receiving a postal barcode immediately after registration.\n' +
           'The order can be mentioned. At the same time, the foreign mail service of this system has two export and import sections for 180 countries in the world\n' +
           'can be mentioned. You can benefit from safe and secure delivery by reading Postex rules before using it. forget\n' +
           'Do not think that if you are active in the postal service, you can be our representative with a good income.',

        t8: 'Ways of communication',
        t9: 'Order'
      },
      loginEDU: {
        t1: 'http and training to enter the site',
        t2: 'The http protocol or the Hyper Text Transfer Protocol is actually the connection port of users\' systems with all kinds of sites, and the https protocol, which is abbreviated as Hypertext Transfer Protocol Secure means the secure hypertext transfer protocol, is actually the same secured version of http. be\n' +
           '\n' +
           'It is not possible to enter some internal sites through http, or it is associated with interference, or vice versa, some sites need to be loaded only with http addresses, in such cases, the problem will be solved by performing a few simple steps below. .',
        t3: '1. Clicking and copying the URL is the first step you take',
        t4: 'The first step is to copy the site address in the browser',
        t5: '2. Enter the copied link in the new tab and you will undoubtedly see the https or http address',
        t6: '3. By editing the https address in this example and changing it to http, you can easily have internal sites, especially Postex.',
        t7: '4. At the end, you can have the Postbar and Postex site or any other internal site without problems and with http.',
        t8: 'Thank you for accompanying us.\n' +
           'Please read our frequently asked questions and help yourself in serving you as well as possible. Postex is a provider of all kinds of domestic and foreign postal services in a door-to-door express service.\n' +
           'If you are also a postal worker, you can be our representative with a good income.',
        t9: 'Telegram',
        t10: 'Instagram',
        t11: 'site',
        t12: 'Phone Call',
      },
      representation: {
        t1: 'Conditions for obtaining Postex representation',
        t2: 'If you are one of the postal workers in your city and province and you want to get a Postex representative, we invite you to read the rest of this page as well as other rules of this system. Please keep in mind that after reading these items, you must Complete the Postex representative request',
        t3: 'Postex agent prerequisites',
        t4: 'office at least 20 meters (not residential)',
        t5: 'Telephone line, independent water, gas and electricity and suitable internet platform',
        t6: 'Necessary capital to run the branch',
        t7: 'Lack of simultaneous cooperation with competing companies',
        t8: 'Valid warranty',
        t9: 'At least a bachelor\'s degree or 10 years of effective experience in a related business field',
        t10: 'required documents',
        t11: 'Copy of birth certificate equal to the original',
        t12: 'Copy of national card equal to the original',
        t13: 'Two pieces of 4x3 photos',
        t14: 'Copy of educational certificate equal to the original',
        t15: 'Guarantees and bank documents are according to the contract (100 million).',
        t16: 'Certificate of no bad background in the name of behtarh Memaran company',
        t17: 'Signed agency agreement and signature certificate',
        t18: 'duties',
        t19: 'Marketing',
        t20: 'Coordinate with the post office to collect',
        t21: 'Follow-up of delay in collection of shipping and delivery and compensations for breakage and delay and possible collection of loads that the post has not collected.',
        t22: 'Regional advertising',
        t23: 'The download link for the agency contract',
        t24: 'Completed promissory note sample',
        t25: 'Receive the commissions file',
      },
      cartoon: {
        t1: 'carton and wrapper',
        t2: 'What are standard postal cartons and wrappers? Answering this question and complying with it is one of the important rules of using postal services. Basically, the carton, wrapper and standard postal box should be 3 to 5 layers so that the box does not fall apart during the postal movement.',
        t3: 'buy packaging',
        t4: 'Now you can enjoy this service by any postal operator by using the option of buying a box and carton of a standard postal package. Nowadays, the importance of packaging is essential due to the limitations of postal spaces, the need for standard dimensions and standard boxes to carry out the shipment process',
        t5: 'standard sizes of cartons and envelopes of postal boxes',
        t6: 'pack size',
        t7: 'length:',
        t8: 'width:',
        t9: 'height:',
      },
      msg: {
        t1: 'The address has been successfully registered',
        t2: 'The address has been successfully updated',
        t3: 'Please enter one of the postal barcode or order number fields',
        t4: 'Loading information',
        t5: "Your request has been successfully registered",
        t6: "Check items",
        t7: "mission accomplished",
        t8: "Not Found",
        t9: "Your request encountered a problem",
        t10: "Passwords must be the same",
        t11: "error network",
        t12: "There was a problem executing the request"
      },
      rate: {
        t1: 'Thank you for choosing Postex service.',
        t2: 'To record your experience after using the Postex service and also to help improve this service, please participate in the following survey.',
        t3: '1- From 1 to 10, what score would you give to your overall experience of placing an order with Postex?',
        t4: 'bad',
        t5: 'OK',
        t6: 'very good',
        t7: '2- How do you evaluate the process of using the Postex website?',
        t8: 'hard',
        t9: 'normal',
        t10: 'Easy',
        t11: '3- What made you choose the Postex service for placing an order?',
        t12: 'fair pricing',
        t13: 'Opinions of others',
        t14: 'The convenience of the order registration process',
        t15: 'Variety of postal services',
        t16: 'suitable tracking system',
        t17: '4- What was your experience of working with the Postex tracking system?',
        t18: 'I was not satisfied at all',
        t19: 'I was somewhat satisfied',
        t20: 'I was completely satisfied',
        t21: '5- If you have contacted the support team while using the Postex service, please indicate your level of satisfaction with the quality of the support.',
        t22: 'My problem was not solved',
        t23: 'partially solved my problem',
        t24: 'My problem is completely solved',
        t25: '6- How do you evaluate Postex service in terms of pricing.',
        t26: 'too expensive',
        t27: 'normal',
        t28: 'absolutely cheap and affordable',
        t29: '7- How likely are you to recommend the Postex service to your friends?',
        t30: 'I do not suggest at all',
        t31: 'Maybe I will offer',
        t32: 'I definitely recommend',
        t33: '8- Do you have any comments about different parts of Postex service that will help to improve this service?',
        t34: 'end of survey',
      },
      orderCancellation: {
        t1: "order cancellation form",
        t2: "",
        t3: "name and surname",
        t4: "mobile phone",
        t5: "order number",
        t6: "cancellation reason",
        t7: "failure to collect mail on time",
        t8: "Actual weight mismatch with stated weight",
        t9: "improper packaging",
        t10: "cancellation at the customer's request",
        t11: "address does not match the postal code declared for the sender or receiver",
        t12: "Contents do not match the type of shipment declared",
        t13: "Non-delivery of the shipment by the sender",
        t14: "No presence of the sender in the place",
        t15: "postal prohibitions",
        t16: "Other",
        t17: "description",
        t18: "return of postal service amount",
        t19: "Refund for technical and support services",
        t20: "Carton and packaging refund",
        t21: "return of collection amount",
        t22: "Agreement percentage of refund",
        t23: "choosing the method of deposit",
        t24: "wallet",
        t25: "bank card",
        t26: "register request",
      },
      withdrawalRequest: {
        t1: "Withdrawal request from wallet",
        t2: "Deposits will be on Saturday, Monday and Wednesday.",
        t3: "The amount of 500 thousand Tomans will be blocked in the account.",
        t4: "The daily withdrawal limit for each deposit is 5 million tomans.",
        t5: "The monthly withdrawal limit is 80 million tomans.",
        t6: "name and surname",
        t7: "mobile phone - username",
        t8: "Sheba Number",
        t9: "requested amount (riyal)",
        t10: "register request",
      },
      agencyRequest: {
        t1: "representation and store request form",
        t2: "You can cooperate with us easily and bear costs close to zero. Fill out an online agency or store request form. Our technical colleagues will contact you after confirming and checking the qualifications.",
        t3: "name and surname",
        t4: "City / Province",
        t5: "address",
        t6: "Field of study",
        t7: "landline",
        t8: "mobile phone",
        t9: "email",
        t10: "marital status",
        t11: "single",
        t12: "Married",
        t13: "age",
        t14: "access to office space",
        t15: "none",
        t16: "I have",
        t17: "I don't have",
        t18: "Do you have postal records? Explain.",
        t19: "Are you able to equip the agency up to 35 million tomans?",
        t20: "Yes",
        t21: "No",
        t22: "Can you afford to pay your employees' salaries and insurance premiums?",
        t23: "how to meet",
        t24: "wall site",
        t25: "representative finder",
        t26: "via Postex site",
        t27: "Introducing Friends",
        t28: "Instagram",
        t29: "My Irancell application",
        t30: "other",
        t31: "Are you able to introduce a guarantor?",
        t32: "Is your office space on the ground floor?",
        t33: "How many points per day is the capacity of your fleet to distribute and collect?",
        t34: "point",
        t35: "Which of the following do you have in your office?",
        t36: "Computer",
        t37: "barcode scanner",
        t38: "shelving",
        t39: "CCTV camera",
        t40: "Enter the location (lat and long) of the shop address",
        t41: "Select the end date of the lease",
        t42: "select date",
        t43: "Do you have another job?",
        t44: "I have read and accept the rules and regulations",
        t45: "description",
        t46: "Please do not leave the page after registering your application and read the annexes and regulations page",
        t47: "Registration of representation request",
        t48: "Agent request",
        t49: "Shop request",
        t50: "store name",
        t51: "surname",
        t52: "identity information",
        t53: "father's name",
        t54: "ID number",
        t55: "Birth Certificate Series",
        t56: "Birth Certificate Series",
        t57: "place of birth certificate",
        t58: "Date of Birth",
        t59: "national code",
        t60: "National Card Series",
        t61: "gender",
        t62: "man",
        t63: "woman",
        t64: "Residence Information",
        t65: "postal code",
        t66: "Representative location information",
        t67: "bank information",
        t68: "Sheba Number",
        t69: "account number",
        t70: "bank",
        t71: "branch name",
      },
      codRequest: {
        t1: "first name",
        t2: "last name",
        t3: "phone number (with city code)",
        t4: "zip code",
        t5: "National Code/National ID",
        t6: "national card serial number",
        t7: "Date of Birth",
        t8: "mobile number",
        t9: "email",
        t10: "account number",
        t11: "iban Number",
        t12: "Bank branch name",
        t13: "province/city",
        t14: "city",
        t15: "address",
        t16: "Payment type",
        t17: "Request registration",
        t18: "COD request form",
      },
      myRequests: {
        t1: "my requests",
        t2: "search for the desired word...",
        t3: "Request of the Minister of Finance",
        t4: "cancel order",
        t5: "Delegation request",
        t6: "Store request",
        t7: "ticket number",
        t8: "date",
        t9: "view",
        t10: "request number",
        t11: "order number",
      },
      employment: {
        t1: "Employment application form",
        t2: "quantitative assessment",
        t3: "name",
        t4: "surname",
        t5: "landline",
        t6: "mobile phone",
        t7: "email",
        t8: "Please specify the section you want",
        t9: "province/city",
        t10: "address",
        t11: "The last degree",
        t12: "Diploma",
        t13: "associate",
        t14: "Bachelor",
        t15: "Master",
        t16: "PhD",
        t17: "University of the place of study",
        t18: "Field of study",
        t19: "status of duty system",
        t20: "end of service",
        t21: "Education exemption (Student)",
        t22: "other",
        t23: "marital status",
        t24: "single",
        t25: "Married",
        t26: "Date of Birth",
        t27: "The amount of work experience",
        t28: "requested salary amount",
        t29: "The level of familiarity with English",
        t30: "low",
        t31: "Medium",
        t32: "much",
        t33: "Advanced",
        t34: "register request",
        t35: "resume selection",
      }
    },
    amnito: {
      navBar: {
        t1: 'Sign In / Sign Up',
        t2: 'Home',
        t3: 'Single Order',
        t4: 'Multi Order',
        t5: 'Wallet',
        t6: 'Dashboard',
        t7: 'my account',
        t8: 'user',
        t9: 'Coordinator Registration',
        t10: 'Contact the head office',
        t11: 'multi send box'
      },
      bottomNavigation: {
        t1: 'Home',
        t2: 'Support',
        t3: 'Order',
        t4: 'wallet',
        t5: 'Dashboard',
        t6: 'My Orders',
      },
      footer: {
        t1: 'General site information',
        t2: 'Postex system rules',
        t3: 'About Postex',
        t4: 'News',
        t5: 'Forums',
        t6: 'blog',
        t7: 'Customer guide',
        t8: 'API documentation',
        t9: 'Received money from recipient by mistake',
        t10: 'http and training to enter the site',
        t11: 'Conditions for obtaining Postex representation',
        t12: 'Carton and wrapper',
        t13: 'Academy of Education',
        t14: 'Frequently Asked Questions',
        t15: 'my account',
        t16: 'Dashboard',
        t17: 'List of orders',
        t18: 'Edit user account',
        t19: 'Services',
        t20: 'Accounting',
        t21: 'ticket',
        t22: 'Communication with Postex',
        t23: 'Download Our Apps',
        t24: 'Haft Municipal District, Shariati Street, Masjid Alley, No. 18, 2nd Floor',
        t25: 'Phone number',
        t26: ' All Rights Are Reserved for Memaran Beh Tarh | 2023'
      },
      drawer: {
        t1: 'Postal service',
        t2: 'Courier hub (courier within the city)',
        t3: 'PME (Foreign Post)',
        t4: 'Shapex (store maker)',
        t5: 'Ludex (heavy transport)',
        t6: 'biopost (cold post)',
        t7: 'Cadox (send a gift)',
        t8: 'My Orders',
        t9: 'Modify the package size',
        t10: 'Download the application',
        t11: 'Support',
        t12: 'Submit a ticket to support',
        t13: 'My ticket list',
        t14: 'Representation',
        t15: 'User comments',
        t16: 'Plugin / API',
        t17: 'Transportation magazine',
        t18: 'about us',
        t19: 'Postex Yar (frequently asked questions)',
        t20: 'User account settings',
        t21: 'Sign out of the user account',
        t22: 'orders of Others for me',
        t23: "home",
        t24: "Cooperation with us"
      },
      login: {
        t1: 'Postex is Iran first postal hub with a door-to-door online mail service provider',
        t2: 'Login to account',
        t3: 'phone number',
        t4: 'password',
        t5: 'remember me',
        t6: 'forget password?',
        t7: 'Login to account',
        t8: 'Are you a new user in Postex?',
        t9: 'Sign Up',
        t10: 'Return to main page',
      },
      register: {
        t1: 'You can easily use the various services of the Postex system by comparing the price, speed and quality of services',
        t2: 'Register in Postex',
        t3: 'Mobile number with zero',
        t4: 'National Code',
        t5: 'password',
        t6: 'Confirm password',
        t7: 'Register in Postex',
        t8: 'Registering in Postex means agreeing to the rules.',
        t9: 'rules',
        t10: 'Already registered in Postex?',
        t11: 'log in',
        t12: 'Return to main page',
        t13: 'The passwords are not the same',
        t14: 'First Name',
        t15: 'Last Name',
        t16: 'Accept'
      },
      newPassword: {
        t1: 'You can easily use the various services of the Postex system by comparing the price, speed and quality of services',
        t2: 'Please enter a new password',
        t3: 'New password',
        t4: 'confirm the new password',
        t5: 'Register password',
        t6: 'Return to main page',
        t7: 'phone number',
        t8: 'Send',
      },
      forgetPassword: {
        t1: 'You can easily use the various services of the Postex system by comparing the price, speed and quality of services',
        t2: 'Please enter the received code',
        t3: 'submit code',
        t4: 'Have not received a code?',
        t5: 'Modify the contact number',
        t6: 'Return to main page',
        t7: 'Resend Code',
        t8: 'verify code',
        t9: 'new password',
        t10: 'confirm new password',
        t11: 'save',
      },
      homeDesktop: {
        s1: {
          t1: "Online Door-to-Door Postal Services",
          t2: 'Postex is a smart postal hub with door-to-door delivery services',
          t3: {
            tt1: 'Order Tracking',
            tt2: 'Enter the postal barcode (tracking code), order number or mobile number of the sender/receiver:',
            tt3: 'Postal BarCode',
            tt4: 'Order Number',
            tt5: 'Mobile Number',
            tt6: 'Find It',
            tt7: 'Postal barcode or Order number',
            tt8: "tracking and price calculation",
          },
          t4: {
            tt1: 'Estimate Rates',
            tt2: 'Please enter the information below to calculate the postage price',
            tt3: 'Domestic',
            tt4: 'International',
            tt5: 'sender',
            tt6: 'City and State of Origin',
            tt7: 'Receiver',
            tt8: 'City and State of Destination',
            tt9: 'size',
            tt10: 'Select',
            tt11: 'Shipment Value ($)',
            tt12: 'weight (gram)',
            tt13: 'Distribution',
            tt14: 'Need collecting?',
            tt15: 'packing',
            tt16: 'Get Rates',
            tt17: 'Post Payment',
            tt18: 'Cash on Delivery? (COD)',
            tt19: 'Destination',
            tt20: 'Is it fragile?',
            tt21: 'Does it contain liquids?',
            tt22: "Size bigger than 9",
            tt23: "The value of goods to determine the limit of obligations"
          },
          t5: 'Send your package',
          t6: 'The result of tracking your shipment',
          t7: 'Tracking code/order number/mobile',
          t8: 'Postal service name',
          t9: 'Shipment type',
          t10: 'Date of collection',
          t11: 'sent date',
          t12: 'Delivery Date',
          t13: 'sender name',
          t14: 'sender address',
          t15: 'Recipient\'s name',
          t16: 'receiver address',
          t17: 'The result of quick price calculation',
          t18: 'Safe buying and selling',
          t19: 'do',
          t20: 'with',
          t21: 'amnito',
          t22: 'shapex',
          t23: 'eCommerce Website Builder',
          t24: 'We Cover You for International Shipping!',
          t25: 'PeykHub Handles Your Local Courier Needs',
          t26: 'Tracking Number',
          t27: 'send box',
          t28: "Postex's presence at the Gitex exhibition",
          t29: "",
          t30: "The only event to connect with 250 government entities",
          t31: "The largest government presence among technology events, unveiling national digital projects and public-private partnerships",
          t32: "The most innovative companies in the world",
          t33: "Experience the undeniable power of innovation in a comprehensive display of global products and solutions with diverse industrial applications",
          t34: "Gitex, inspiring and improving life",
          t35: "The press conference of the world GITEX exhibition, which will be opened on Monday next week, was held with the presence of the minister of the United Arab Emirates government in the field of artificial intelligence",
          t36: "For the first time, GITEX Global will be held in two large places this year",
          t37: "This exhibition is the place to present the latest technologies and developments in the field of artificial intelligence, cloud computing, Web 3.0 and sustainable digital economy.",
        },
        s2: {
          t1: 'Why should I send my parcels with Postex?',
          t2: 'Postex services',
          t3: '',

          t4: 'amnito service',
          t5: '<h2>Amnito: Secure and Convenient <b>Online Shopping Experience</b></h2>',
          t6: 'One of the challenges of eCommerce is to establish trust and security between buyers and sellers. Postex has addressed this issue with a secure payment service called Amnito, which offers a reliable solution for both parties. Amnito ensures that both buyers and sellers are protected from fraud and disputes, and enjoy a smooth and pleasant online shopping experience.',
          t7: 'With Amnito, the buyer deposits the payment for the product in a secure escrow account managed by Postex until the product is delivered and inspected. The payment is then released to the seller if the product meets the buyer’s expectations and the delivery status is confirmed. If the product is not satisfactory or the delivery status is not confirmed, the payment is refunded to the buyer.',
          t8: 'Safe buying and selling in online stores',
          t9: 'Explore',

          t10: 'Bio post service',
          t11: '<h2>Bio Post: A Safe and Fast <b>Delivery Service for Sensitive Goods</b></h2>',
          t12: 'Do you need to transport laboratory samples, vaccines, or chemicals that require cold storage? If so, Bio Post is the service for you. Bio Post is a new service from Postex that specializes in delivering sensitive goods that need to be kept at low temperatures. ' +
             'Bio Post ensures that your goods are delivered safely and securely to any part of the world within 24 to 48 hours. Bio Post also provides you with special containers and parcels that are designed to protect your goods from contamination and damage. Bio Post is the best choice for moving sensitive goods with confidence and convenience.',
          t13: 'A Safe and Fast Delivery Service for Sensitive Goods',

          t14: 'Subex',
          t15: '<h2> Subex: A Smart and Simple Solution for <b>Instagram Shops</b></h2>',
          t16: 'Are you tired of Instagram’s restrictions and limitations? Do you want to grow your online store and reach more customers? If so, Subex is the service for you. Subex allows you to create your own personalized webpage with a point-of-sale portal for your Instagram shop.',
          t17: 'You can upload all your products to your Subex dashboard and get a unique link to share with your customers or put in your bio. When your customers click on your link, they will see a complete list of your products and prices. They can easily select the product they want, add their address, choose the shipping method, and pay securely with their preferred payment service.',
          t18: 'A Smart and Simple Solution for Instagram Shops',

          t19: 'Shipito Plus',
          t20: '<h2>Shipito: Using AI for  <b> Efficient and Cost-effective Delivery </b></h2>',
          t21: 'If you run a store that has a fleet of vehicles for collecting and distributing your parcels, one of the most important challenges you face is how to optimize your fleet routes based on the shortest and least congested routes. You may think that this is possible for a small number of parcels based on your knowledge of the area, but human calculation is impossible for a large number of parcels. ',
          t22: 'Moreover, your knowledge of the traffic conditions may not be up to date or accurate. That’s why you need Shipito, a VRP (Vehicle Routing Problem) solution that uses advanced AI algorithms and real-time data to calculate the best routes for your fleet. Shipito helps you save time, money, and fuel by finding the most efficient and cost-effective routes for your delivery needs. Shipito is the smart way to manage your fleet and satisfy your customers.',
          t23: 'Using AI for Efficient and Cost-effective Delivery ',

          t24: 'Shapex store builder',
          t25: '<h2> Shapex: A Professional Website Builder for  <b>Social Media Shops</b></h2>',
          t26: 'Do you want to take your online sales and marketing to the next level? Do you want to create your own eCommerce website without any hassle or coding? If so, Shapex is the service for you. Shapex is a website builder that allows you to create a stunning and functional eCommerce website for your Instagram, Facebook, or Pinterest shop.',
          t27: 'You can upload all your products to your Shapex dashboard and customize your website with your own logo, colors, and layout. You can also offer your customers various options and features, such as free shipping, on-site payment, cash payment, secure buying and selling, and leasing the amount of the sold goods based on the return percentage. Shapex also provides you with valuable information and analytics, such as customer feedback, sales reports, inventory management, and more.',
          t28: 'A Professional Website Builder for Social Media Shops',

          t29: 'Internal post',
          t30: '<h2> Send your package with a variety of <b> domestic mail </b> services! </h2>',
          t31: 'With the ever-increasing expansion of sales and advertising methods, one of the oldest sales methods, telemarketing using call centers, is still one of the most effective methods in sales.',
          t32: 'Now you can upload all your products in your personal panel and use 4 methods of free shipping, on-site payment, cash payment, safe buying and selling, and facilities such as leasing the amount of the sold goods based on the return percentage, such as a permanent credit line from Shopex. and with this method you can get great facilities and information',
          t33: 'Don\'t worry about sending your package by post bar',

          t34: 'kadox',
          t35: '<h2>Kadox: A <b>Gift Delivery Service</b> that Makes Your Loved Ones Happy</h2>',
          t36: 'Have you ever wanted to surprise someone with a gift on their birthday, but couldn’t be there in person? Have you ever ordered a gift online, but it arrived late or damaged? If so, you need Kadox, a gift delivery service that guarantees your satisfaction and happiness.' +
             'Kadox is a gift express system that allows you to send wrapped gifts, flowers, and even cakes to your loved ones in any city. You can choose from a variety of gifts and customize them according to your preferences. You can also add a personal message or a card to make your gift more special. Kadox delivers your gift on time and in perfect condition, so you can make your loved ones feel appreciated and loved. Kadox is the best way to send gifts and spread joy.',
          t37: 'Gift Delivery Service that Makes Your Loved Ones Happy',

          t38: 'Postex yar',
          t39: '<h2> Postex Yar: A <b>Postal Service</b> for Everyone',
          t40: 'Do you have a disability or a limitation that makes it hard for you to use a smartphone or the internet? Do you want to send or receive parcels without any hassle or delay? If so, Postex Yar is the service for you. Postex Yar is a new postal service that caters to the needs of people with disabilities, veterans, or anyone who prefers a more personal and convenient way of sending and receiving parcels.' +
             'With Postex Yar, you don’t need to register your order online or use an app. You just need to call Postex Yar and request a collector to come to your door. The collector will pick up your parcel, fill out the necessary information, and deliver it to the destination in the shortest possible time. Postex Yar is a postal service that respects your privacy, dignity, and comfort.',
          t41: 'Postal Service for Everyone',
          t42: 'Coming Soon'
        },
        s3: {
          t1: 'How to Become a Postex Representative',
          t2: '<h2>Do you want to earn money by working as a <b>cargo handler</b> and <b>representative for Postex? </b></h2>',
          t3: 'If so, you can apply for a Postex agency and start your cooperation with us. Postex agency is a great opportunity for anyone who wants to work independently and flexibly, with minimal costs and maximum benefits. To become a Postex representative, you need to follow these steps:',
          t4: ' More Info',
          t5: 'Your agency request has been approved!',
          t6: 'Fill out an online agency request form on our website.',
          t7: 'Wait for our technical team to contact you and confirm your eligibility.',
          t8: 'Provide the required documents, such as checks, promissory notes, contracts, car and motorcycle papers, business lease, etc.',
          t9: 'Receive your Postex agency certificate and start your work.'
        },
        s4: {
          t1: 'Postex Apps',
          t2: '<h2>Now you can enjoy <b>Postex</b> on your <b>Android</b> smartphone</h2>',
          t3: '',
          t4: 'You can use the Postex app on your Android smartphone to create and track your shipments, find a Postex location, get cost estimates, choose from different postal options, and more. You can also use the Postex Tracking app to track the status of your parcels and get notifications. The Postex apps are free, easy, and secure.',
          t5: 'Google Play',
          t6: 'cafe bazaar',
          t7: 'Track your order. Anytime, anywhere!',
          t8: 'postex',
          t9: 'memaran behtarh',
          t10: 'Postex system (www.postex.ir) is Iran\'s first comprehensive door-to-door postal online transportation system.',
          t11: '',
          t12: ''

        },
        s5: {
          t1: 'Postex colleagues',
          t2: '<h2>Services that we are <b>honored to cooperate</b> with</h2>',
          t3: 'Snapbox',
          t4: 'Speed Co',
          t5: 'Ganja Co',
          t6: 'bio post (cold post)',
          t7: 'Sky Post',
          t8: 'blue sky way',
          t9: 'Foreign post',
          t10: 'Aramex',
          t11: 'chapar',
          t12: 'leading post',
          t13: 'Mahex',
          t14: 'National post of Iran',
          t15: 'box Yar',
          t16: 'Nedex',
          t17: 'kala resan',
        },
        s6: {
          t1: 'Postex newsletter',
          t2: '<h2> <b>Latest News</b>!</h2>',
          t3: 'Please enter your email...',
          t4: 'Subscribe',
        }

      },
      homeMobile: {
        t1: 'Tracking of shipments',
        t2: 'Please enter your information',
        t3: 'Postal barcode',
        t4: 'Shipment interception',
        t5: 'Quick calculation of postage',
        t6: 'Send your package',
        t7: 'Quick calculation of postage',
        t8: 'Internal mail',
        t9: 'Foreign post',
        t10: 'sender',
        t11: 'City - Province',
        t12: 'Receiver',
        t13: 'size',
        t14: 'Select',
        t15: 'product price ($)',
        t16: 'Shipment weight (grams)',
        t17: 'Distribution',
        t18: 'Collect',
        t19: 'packing',
        t20: 'sender',
        t21: 'Country',
        t22: 'Call for price',
        t23: 'My packages',
        t24: 'Post delivery given',
        t25: 'Last update: 3 hours ago',
        t26: 'Order number',
        t27: 'Mobile sender/receiver',
        t28: 'Postal barcode or Order number',
        t29: 'Send your first package',
        t30: 'start order',
        t31: 'Shipment tracking or price inquiry'
      },
      dashboard: {
        sideBar: {
          t1: 'Address book',
          t2: 'Messages',
          t3: 'My Order',
          t4: 'Invoice request',
          t5: 'Introduction points',
          t6: 'Settings',
          t7: 'Sign out',
          t8: 'List of addresses',
          t9: 'Orders Of Others for me',
          t10: 'my requests',
        },
        address: {
          t1: 'Address book',
          t2: 'Add new address',
          t3: 'Search in previous addresses',
          t4: 'first name',
          t5: 'last name',
          t6: 'phone number',
          t7: 'company name',
          t8: 'Add province',
          t9: 'city - province',
          t10: 'Address text',
          t11: 'Text address',
          t12: 'save',
          t13: 'Type part of the address',
          t14: 'Tehran - Akbatan town - ...',
          t15: 'list address',
          t16: 'address',
          t17: 'Receiver',
          t18: 'select city',
          t19: 'Sender',
          t20: 'address for',
          t21: 'Do you want to delete the address?',
          t22: 'accept',
          t23: 'cancel',
          t24: 'Select address as default',
          t25: 'default address',
          t26: 'Address Edit'
        },
        message: {
          t1: 'messages'
        },
        order: {
          t1: 'my orders',
          t2: 'all',
          t3: 'Paid',
          t4: 'suspended',
          t5: 'print',
          t6: 'order number',
          t7: 'Payment status',
          t8: 'order status',
          t9: 'Shipping status',
          t10: 'sender',
          t11: 'Receiver',
          t12: 'price',
          t13: 'dollar',
          t14: 'payment',
          t15: 'Payment Method',
          t16: 'cancel',
          t17: 'Orders Of Others for me',
          t18: 'order search',
          t19: 'from date',
          t20: 'to date',
          t21: 'search',
          t22: 'close',
          t23: "cancel",
          t24: "Collect",
          t25: "edit",
          t26: "details",
          t27: "order number",
          t28: "Consignment Number",
          t29: "order status",
          t30: "payment status",
          t31: "tracking number",
          t32: "date",
          t33: "province/City of origin",
          t34: "City of origin",
          t35: "source address",
          t36: "Sender full Name",
          t37: "Last Name of Sender",
          t38: "sender's mobile number",
          t39: "destination province/City",
          t40: "Destination City",
          t41: "destination address",
          t42: "recipient full name",
          t43: "recipient's last name",
          t44: "Contents of shipment",
          t45: "shipment weight",
          t46: "insurance cost",
          t47: "requires a printer",
          t48: "shipment value",
          t49: "electronic registration rights",
          t50: "need cartoon",
          t51: "package length",
          t52: "wrap width",
          t53: "package height",
          t54: "need to print logo",
          t55: "need to collect",
          t56: "need to distribute",
          t57: "Yes",
          t58: "No",
          t59: "details order",
          t60: "shipment info",
          t61: "Services",
          t62: " not available ",
        },
        affiliate: {
          t1: 'Introduction points',
          t2: 'Receive invitation code',
          t3: 'Get a gift by inviting your friends to Postex',
          t4: 'copied',
        },
        setting: {
          t1: 'setting',
          t2: 'Service to receive order information email',
          t3: 'Access to the printer',
          t4: 'Access to the postal package',
          t5: 'upload brand',
          t6: 'Changing theme',
          t7: 'Changing language',
          t8: 'save',
        },
        requestFactor: {
          t1: 'factor list',
          t2: 'request factor',
          t3: 'first name',
          t4: 'last name',
          t5: 'national code',
          t6: 'economic Code',
          t7: 'foriegn Code',
          t8: 'postal Code',
          t9: 'address',
          t10: 'request',
          t11: 'Pending'
        }
      },
      wallet: {
        t1: 'Increase credit',
        t2: 'Choose the amount',
        t3: 'Select',
        t4: 'desired amount (riyals)',
        t5: 'Choose a payment method',
        t6: 'Mellat Bank',
        t7: 'Payment and credit increase',
        t8: 'financial report',
        t9: 'weekly',
        t10: 'monthly',
        t11: 'yearly',
        t12: 'dollar',
        t13: 'deposit',
        t14: 'harvest',
        t15: 'financial report',
        t16: 'Row',
        t17: 'Transaction type',
        t18: 'Amount',
        t19: 'Transaction date',
        t20: 'Transaction number',
        t21: 'pocket',
        t22: 'Which order',
        t23: 'confirm and pay',
        t24: 'credit transfer',
        t25: 'phone number',
        t26: 'desired amount (riyals)',
        t27: 'Choose the amount',
        t28: 'Current Balance',
        t29: 'List of wallet',
        t30: 'Clear transaction list',
        t31: 'Checkout'

      },
      singleOrder: {
        t1: 'previous level',
        t2: 'next level',
        t3: 'Order completion',
        t4: 'Payment',
        t5: 'cancel',
        t6: 'Factor',
        step: {
          t1: 'sender',
          t2: 'Receiver',
          t3: 'Package info',
          t4: 'Service type',
          t5: 'Review',
        },
        sender: {
          t1: 'Register the address of the sender',
          t2: 'bulk order',
          t3: 'Select previous addresses',
          t4: 'Add new address',
          t5: 'Register sender information',
          t6: 'first name',
          t7: 'last name',
          t8: 'mobile number',
          t9: 'email',
          t10: 'company name',
          t11: 'address',
          t12: 'Need to collect',
          t13: 'If you choose the need to collect, your shipment will be collected from the sender\'s door' +
             'If the order is placed before 8:00 am, it will be collected today by 6:00 pm and after 8:00 a.m. tomorrow (if there is no holiday) it will be collected by 6:00 pm',
          t14: 'Select previous addresses',
          t15: 'Choose a address',
          t16: 'Enter a part of the profile or mobile phone or previous address',
          t17: 'Add new address',
          t18: 'Add address',
          t19: 'Province / city of origin',
          t20: 'Address text',
          t21: 'Text address',
          t22: 'add',
          t23: 'If you do not choose to collect the parcel, you must deliver it to the Postex representative office or the chosen postal service.',
          t24: 'Select city',
          t25: 'phone number (with city code)',
          t26: 'national code',
          t27: 'Postal code',
          t28: 'Search for your city',
          t29: 'select sender Coordinate ',
          t30: 'more',
          t31: 'close',
          t32: "Select the address from the map (optional)"
        },
        receiver: {
          t1: 'Register the address of the Receiver',
          t2: 'bulk order',
          t3: 'Select previous addresses',
          t4: 'Add new address',
          t5: 'Register Receiver information',
          t6: 'first name',
          t7: 'last name',
          t8: 'mobile number',
          t9: 'email',
          t10: 'company name',
          t11: 'address',
          t12: 'Need to distribute',
          t13: 'If you choose the need for distribution, your shipment will be distributed at the recipient\'s location',
          t14: 'Select previous addresses',
          t15: 'Choose a address',
          t16: 'Enter a part of the profile or mobile phone or previous address',
          t17: 'Add new address',
          t18: 'Add address',
          t19: 'Province / city of destination',
          t20: 'Address text',
          t21: 'Text address',
          t22: 'add',
          t23: 'If you do not select the need for distribution, the parcel will be delivered to the representative office of the postal company',
          t24: 'Select city',
          t25: 'phone number (with city code)',
          t26: 'national code',
          t27: 'Postal code',
          t28: 'Search for your city',
          t29: 'select Receiver Coordinate'
        },
        packageInfo: {
          t1: 'Package information',
          t2: 'The contents of the shipment',
          t3: 'dollar value of the shipment',
          t4: 'Shipment weight (grams)',
          t5: 'Postal package size',
          t6: 'I want packaging',
          t7: 'Print receipt',
          t8: 'SMS notification',
          t9: 'SMS notification has been activated',
          t10: 'Lorem Epsom is a mock text produced with incomprehensible simplicity from the printing industry, and used by graphic designers.',
          t11: 'confirmation',
          t12: 'Your brand',
          t13: 'payment type',
          t14: 'Pay shipping - normal',
          t15: 'Payment on site (COD)',
          t16: 'Payment of shipping and goods-amnito',
          t17: 'free delivery',
          t18: 'So rent',
          t19: 'Add package',
          t20: 'Package added successfully',
          t21: 'You can see your package information from the package details section',
          t22: 'breakable',
          t23: 'Contains liquids',
          t24: 'If you choose the need for packaging, your shipment will be packed and the bill of lading label will be installed on it after collection and at the Postex warehouse.',
          t25: 'If you do not select the need for packaging, deliver the parcel to the Postex collector with standard packaging.',
          t26: 'If you choose the need to print a bill of lading label, your shipment will be labeled and a bill of lading label will be installed on it after collection and at the Postex warehouse.' +
             'When delivering the parcel to the Postex collector, write your order number on the parcel in such a way that it cannot be torn off or erased.',
          t27: 'If you do not select the need to print the bill of lading label, print the label and install it on the shipment and deliver it to the Postex collector.',
          t28: 'The postal review must be printed and affixed to the package',
          t29: 'If you select the SMS notification option in all sending stages, the status of the shipment will be notified to the recipient and the sender via SMS.',
          t30: 'If you do not have access to a printer to print your waybill label, select the option to print an review. After collecting the cargo at the Postex warehouse, the label will be attached to the shipment, and at the time of delivery to the Postex collector, you must enter the shipment number on the shipment.',
          t31: 'You select the option of needing to print the review, print the bill of lading label and attach it to the bill of lading',
          t32: 'If your shipment contains breakable goods, select the breakable option.',
          t33: 'If your shipment contains liquids, select the liquids option.',
          t34: "The cost of shipping + the cost of goods at the door of the recipient is the responsibility of the recipient",
          t35: "The shipping fee is paid by the sender or recipient",
          t36: "All shipping costs and the value of the goods are received from the recipient and the total amount received is deposited into the sender's account after deducting the costs specified in the rules.",
          t37: "The cost of goods and shipping is paid by the recipient and the deposit remains with Postex until the goods are received from the sender",
          t38: "The cost of sending the parcel at the time of delivery to the recipient will be collected from them",
          t39: 'Agency services',
          t40: 'Agent services',
          t41: "dollar value of the consignment to determine the limit of obligations",
          t42: "Register store request to activate more payment methods",
          t43: "store request",
          t44: "Payment methods",
        },
        serviceType: {
          t1: 'Choose a server',
          t2: 'cheapest',
          t3: 'fastest',
          t4: 'Most Popular',
          t5: 'Available services',
          t6: 'Unavailable services',
          t7: 'Service type',
          t8: 'shipping time',
          t9: 'Post price and technical services',
          t10: 'Description',
          t11: 'dollar',
          t12: 'Collect',
          t13: 'Distribution',
          t14: 'Insurance up to the limit',
          t15: 'Service selection is required',
          t16: 'Choose one of the agencies below',
          t17: "approximate price",
          t18: "Collecting the shipment from the sender's door",
          t19: "<p>collection <b>today</b>, order before 12 noon<br/>" +
              "Collection <b>tomorrow</b>, order after 12 noon</p>",
          t20: "Collection price",
          t21: "Centers near you for package delivery",
          t22: "Due to the fact that the need to collect tick has not been selected by you, you are responsible for the delivery of the goods.",
          t23: "change status",
          t24: "Address of centers near you for package delivery",
          t25: "No service found for your selected origin",
          t26: "Choose one of the centers on the map",
          t27: "This service is not active for your entered information",
          t28: "The center of your choice",
          t29: "Your chosen service"
        },
        review: {
          t1: 'Package details',
          t2: 'pack',
          t3: 'The contents of the shipment',
          t4: 'Number of postal packages',
          t5: 'dollar value of the shipment',
          t6: 'dollar',
          t7: 'Shipment weight (gram)',
          t8: 'gram',
          t9: 'Postal package size',
          t10: 'size',
          t11: 'Invoice printing',
          t12: 'Receiver information',
          t13: 'Service type',
          t14: 'shipping time',
          t15: 'shipping cost',
          t16: 'packing',
          t17: 'Label printing',
          t18: 'Logo insertion',
          t19: 'technical and engineering service',
          t20: 'Collection at home',
          t21: 'Distribution',
          t22: 'Add a new order',
        },
        invoice: {
          t1: 'date and time',
          t2: 'Order number',
          t3: 'Proforma postal review and technical services',
          t4: 'Postal service',
          t5: 'Row',
          t6: 'Description',
          t7: 'Number',
          t8: 'Price (dollar)',
          t9: 'Total',
          t10: 'dollar including tax',
          t11: 'Technical services and support',
          t12: 'payment',
          t13: 'Order total',
          t14: 'dollar',
          t15: 'Pay with wallet',
          t16: 'Your inventory',
          t17: 'Mellat Bank',
          t18: 'Register a new order',
          t19: 'Technical services, insurance and collection of goods from the place and...',
          t20: 'Value added tax',

          t21: 'printing and pasting the invoice',
          t22: 'added value of agency',
          t23: 'Cost of cartons and wrappers',
          t24: 'Fees and finance charges',
          t25: 'shipping cost',
          t26: 'Amount of goods',
          t27: 'Insurance amount',
          t28: 'technical engineering services',
          t29: 'print trade mark',
          t30: 'electronic registration',
          t31: 'cost of SMS and interception',
          t32: 'collection fee',
          t33: 'discount code',
        }
      },
      multiOrder: {
        t1: 'previous level',
        t2: 'next level',
        t3: 'Order completion',
        s1: {
          t1: 'Sender information',
          t2: 'Select previous addresses',
          t3: 'Add new address',
          t4: 'Service information',
          t5: 'Service type',
          t6: 'Select',
          t7: 'Affixing the trademark on the review',
          t8: 'Postal envelope / carton',
          t9: 'SMS notification',
          t10: 'SMS notification has been activated',
          t11: 'Lorem Epsom is a mock text produced with incomprehensible simplicity from the printing industry, and used by graphic designers.',
          t12: 'confirmation',
          t13: 'Download the Excel file',
          t14: 'Upload Excel file',
          t15: 'Choose an address',
          t16: 'Enter a part of the profile or mobile phone or previous address',
          t17: 'Add address',
          t18: 'Select city',
          t19: 'Address text',
          t20: 'Text address',
          t21: 'add',
          t22: 'Row',
          t23: 'operations',
          t24: 'Is it breakable?',
          t25: 'Does it contain liquids?',
          t26: 'Receive the raw Excel file for pre-rental orders',
          t27: 'Receive the raw Excel file for COD orders.',
          t28: 'Search for your city',

        },
        s2: {
          t1: 'Shipment information',
          t2: 'New line',
          t3: 'consignment',
          t4: 'contents of the shipment',
          t5: 'Postal package size',
          t6: 'Select',
          t7: 'length',
          t8: 'width',
          t9: 'Height',
          t10: 'dollar value of the shipment',
          t11: 'Shipment weight (grams)',
          t12: 'Insurance',
          t13: 'Add recipient information',
          t14: 'Receiver information',
          t15: 'Select recipient address',
          t16: 'first name',
          t17: 'last name',
          t18: 'phone number (with city code)',
          t19: 'company name',
          t20: 'address',
          t21: 'Enter a part of the profile or mobile phone or previous address',
          t22: 'Select city - province',
          t23: 'Text address',
          t24: 'add',
          t25: 'Search for your city',
          t26: "Rial value of the consignment to determine the limit of obligations"
        }
      },
      packing: {
        t1: 'Shipment information',
        t2: 'contents shipment',
        t3: 'dollar value',
        t4: 'dollar',
        t5: 'weight shipment',
        t6: 'grams',
        t7: 'Postal package size',
        t8: 'Number of postal packages',
        t9: 'Current order details',
        t10: 'Receiver',
        t11: 'Phone number (with city code)',
        t12: 'receiver address',
        t13: 'Service type',
        t14: 'Need to collect',
        t15: 'Label printing',
        t16: 'Logo insertion',
        t17: 'Edit the information sent',
        t18: 'contents shipment',
        t19: 'dollar value',
        t20: 'Shipment weight (grams)',
        t21: 'Package size',
        t22: 'Number of postal packages',
        t23: 'Invoice printing',
        t24: 'add',
        t25: 'Unit price',
        t26: 'Save changes',
        t27: 'yes',
        t28: 'no',
        t29: 'length',
        t30: 'width',
        t31: 'height',
      },
      sendTicket: {
        t1: 'support',
        t2: 'Please first before submitting a support ticket ',
        t3: 'common questions',
        t4: 'see that',
        t5: 'subject ticket',
        t6: 'Select the topic',
        t7: 'first name and last name',
        t8: 'mobile or email',
        t9: 'order code',
        t10: 'Tracking Code',
        t11: 'Priority',
        t12: 'Message text',
        t13: 'Product Type',
        t14: 'Select the type of product',
        t15: 'New product',
        t16: 'Category two goods',
        t17: 'Product Name',
        t18: 'Purchase price',
        t19: 'Product brand name',
        t20: 'Shaba number',
        t21: 'Description',
        t22: 'Phone',
        t23: 'Postal code',
        t24: 'National Code',
        t25: 'National card serial number',
        t26: 'Date of birth',
        t27: 'account number',
        t28: 'Name of the bank branch',
        t29: 'Province - city',
        t30: 'address',
        t31: 'select picture',
        t32: 'Up to 3 JPEG images, up to 1 MB',
        t33: 'Register and send',
        t34: 'Request for damages',
        t35: 'Rent request',
        t36: 'other',
        t37: 'Department Name',
        t38: 'ticket type',
      },
      listTicker: {
        t1: 'My ticket list',
        t2: 'All tickets',
        t3: 'In the turn of sending to support',
        t4: 'has been answered',
        t5: 'Message text',
        t6: 'Answer support',
        t7: 'close',
        t8: 'Reply to support',
        t9: 'save and send',
      },
      faq: {
        t1: 'FAQ',
        t2: 'Search for the desired word...',
        t3: 'Fees and services',
        t4: 'Delivery schedule',
        t5: 'Postal and financial compensation and damages',
        t6: 'Postal prohibitions',
        t7: 'Submission limits',
        t8: 'Questions about obtaining representation',

        t9: 'Can I use post-rental or pay-on-the-spot services?',
        t10: 'By paying an annual fee, you can use post-rental services, free shipping and on-site payment (cod) of the Postex platform to register your application by referring to the Post-rental link, register your application in Postex and get informed about the prerequisites of your application. It should be noted that the cost of financial services for using free shipping and cash on delivery (cod) services is equivalent to 1-3% of the product value.',
        t11: 'Where can I send goods from or where are the cities covered by Postex?',
        t12: 'Study this page',
        t13: 'What are the rules for using Postex services?',
        t14: 'Study this page',
        t15: 'Does Postex also have foreign mail?',
        t16: 'Yes, refer to the page below to inquire about the postal price online',
        t17: 'How can I get a discount?',
        t18: 'The Postex smart system provides discounts by calculating the number of your shipments per month, but if you need to negotiate more, you can register your ticket by referring to the link below.',
        t19: 'I have an online store, what are the terms of cooperation with Postex?',
        t20: 'By registering on the Postex website and if you have a standard, non-trafficked and non-prohibited product, you can use Postex services in the form of prepaid, postpaid, free shipping and payment on site (cod).',
        t21: 'My shipment is not packed and how can I receive service from you?',
        t22: 'Dear customer, if in the city where you are placing your order, Postex has a warehouse representative, you can select the option "I do not need packaging" or "I do not have access to printing" when placing the order, after the shipment is collected by the Postex representative at the warehouse of the Postex representative. The pistachio packing and label will be barcoded, so please note that the representative will not be able to pack at your place.',
        t23: 'Do you have phone order registration and can you guide me through the website, how is it done?',
        t24: 'Unfortunately, it is not possible to place an order by phone in Postex, so you can place an order by referring to the link below and after registering.',
        t25: 'Does Postex also collect?',
        t26: 'Dear customer, in all places where Postex has a representative, Postex can collect it upon your request, and if there is no representative, you can personally deliver the cargo to the postal company after registering with Postex, which will include a discount.',
        t27: 'How much will it cost to send my parcel?',
        t28: 'Dear customer, you can compare the cost of various postal services by referring to the link below',

        t29: 'where is my bar',
        t30: 'Dear customer, various postal services have different schedules as follows:\n' +
           '          Postbar express service 24 to 48 hours\n' +
           '          Vantaz post service within the province 4 to 6 hours\n' +
           '          Interprovincial vanguard post service 7 to 9 hours\n' +
           '          Mahex service 24 to 48 hours\n' +
           '          Chapar service 36 to 72 hours\n' +
           '          Chapar Express service 36 to 48 hours\n' +
           '          Skypost service 24 to 48 hours\n' +
           '          Delivery service 36 to 48 hours\n' +
           '          Pik Hub inner city service 18 to 24 hours\n' +
           '          Please note that all the above schedules are working days and hours, and the calculation does not include holidays and is calculated from the time of delivery of the parcel to the Postex representative.\n' +
           'Therefore, if you want to know about the process of sending the parcel, please refer to the tracking link',
        t31: 'My shipment has not been collected. When will my shipment be collected?',
        t32: 'If you register before 8:00 am today, it will be collected until 19:00, and if you register after 8:00, it will be collected until 19:00 tomorrow. If you are not satisfied with the result of the interception, please let us know in the ticket so that our colleagues at Postex can handle it\n' +
           'If you placed your order before 8:00 AM today and your shipment has not been collected by 7:00 PM today, please notify us of your ticket by referring to the link below.',
        t33: 'They sent me several packages together, but I didn\'t receive the complete packages?',
        t34: 'Dear customer, please note that if several parcels are sent to you from the same source on the same day, they will not all reach you on the same day, because they may have been loaded on different machines for sending, so based on the time specified in the time Place an order for delivery, wait for the shipment to arrive, and if it takes longer than the scheduled time, contact us through a support ticket.',
        t35: 'The movement of my shipment has been stopped for several days and there is no progress, how can I follow up?',
        t36: 'Dear customer, please refer to the ticket link and wait for the call of our colleagues at Postex by registering your bill of lading number',
        t37: 'When will my shipment or package arrive?',
        t38: 'Dear customer, various postal services have different schedules as follows:\n' +
           '          Postbar express service 24 to 48 hours\n' +
           '          Vantaz post service within the province 4 to 6 hours\n' +
           '          Interprovincial vanguard post service 7 to 9 hours\n' +
           '          Mahex service 24 to 48 hours\n' +
           '          Chapar service 36 to 72 hours\n' +
           '          Chapar Express service 36 to 48 hours\n' +
           '          Skypost service 24 to 48 hours\n' +
           '          Delivery service 36 to 48 hours\n' +
           '          Pik Hub inner city service 18 to 24 hours\n' +
           '          Please note that all the above schedules are working days and hours, and the calculation does not include holidays and is calculated from the time of delivery of the parcel to the Postex representative.',
        t39: 'My shipment is pending, what should I do?',
        t40: 'If the tracking shows your shipment at the pending counter, you can go to the pending counter of your city\'s postal company and pick up the shipment within 5 days, and if the tracking shows the postman\'s visit twice and you have an appointment on the same day, you can go to the postal company. Receive the shipment.',

        t41: 'What should I do to receive compensation for the damaged parcel that I received?',
        t42: 'The responsibility for guaranteeing the compensation of postal items is up to the recipient\'s door, so if you have received the item, it does not include any type of damage guarantee, because you have the opportunity to ask the postman at the time of delivery to allow the content of the item to be checked for health or compliance with the order. control\n' +
           '          Now, if you did not manage to do this and your shipment was sent through the National Post Company and if a maximum of 24 hours has passed since the delivery time, try your luck to receive compensation by referring to the postal compensation system.\n' +
           '          If your shipment is other than postal bans, we do not provide any service to track the parcel (postal bans link).\n' +
           '          If you are not satisfied with the result of the interception, please let us know in the ticket so that our colleagues at Postex can handle it',
        t43: 'Why hasn\'t the payment been made for my goods that have reached their destination?',
        t44: 'Dear customer, basically, the status of distribution does not mean the settlement of the value of the shipment, and if you see the status of confirmation or financial settlement, your money will be paid after 48 hours.\n' +
           'If you are not satisfied with the result of the answer and more than 48 hours have passed since the change of status to confirmation and financial settlement, please indicate in the ticket so that our colleagues at Postex can handle it.',
        t45: 'I requested the cancellation of the shipment, but my money has not been deposited or has been deposited less',
        t46: 'Dear customer, if you have a request to cancel the order before visiting the collector, the refund will be paid to you without deducting any money after 48 hours of delivery.\n' +
           '  But if you have a request to cancel the order after sending the collector, after deducting the collection costs, the remaining amount will be returned.\n' +
           'Now, if you have a request to cancel your order after complete collection, no money will be returned and you will be charged a fee of 50,000 Tomans to return the shipment to the origin. Please register your request by referring to the link below to cancel the order.',
        t47: 'Do you have phone order registration and can you guide me through the website, how is it done?',
        t48: 'Unfortunately, it is not possible to place an order by phone in Postex, so you can place an order by referring to the link below and after registering.',
        t49: 'The address and information were registered incorrectly and my shipment was sent. Can you help me?',
        t50: 'If you have registered an address in Postex, it is not possible to change the address after receiving the barcode.',
        t51: 'My shipment is not packed and how can I receive service from you?',
        t52: 'Dear customer, if in the city where you are placing your order, Postex has a warehouse representative, you can select the option "I do not need packaging" or "I do not have access to printing" when placing the order, after the shipment is collected by the Postex representative at the warehouse of the Postex representative. The pistachio packing and label will be barcoded, so please note that the representative will not be able to pack at your place.\n' +
           '  At the same time, please note that if you need packaging service at the time of delivery, you should write the barcode number and your order on the package in such a way that it will not be erased until the end of the shipment.',
        t53: 'How can I get a discount?',
        t54: 'The Postex smart system provides discounts by calculating the number of your shipments per month, but if you need to negotiate more, you can register your ticket by referring to the link below.',
        t55: 'When I check the tracking code, it says that the package has been delivered to the recipient, but I, who am the recipient, did not receive the package! what should I do?',
        t56: 'Dear customer, please refer to the ticket link and wait for the call of our colleagues at Postex by registering your bill of lading number',

        t57: 'Can I send gold or silver?',
        t58: 'You cannot send gold and silver through postal companies, because this type of shipment is prohibited by the postal service, and the responsibility for sending this type of shipment is the responsibility of the sender, and it does not include any guarantee of compensation.',
        t59: 'Can I send a check or cash or official documents?',
        t60: 'You are not able to send checks or cash or administrative documents through postal companies, because these types of mails are prohibited by mail and the responsibility of sending these types of mails is the responsibility of the sender and does not include any guarantee of compensation.',
        t61: 'What are postal restrictions?',
        t62: '-',

        t63: 'Can I ship fragile cargo or liquids?',
        t64: 'You can send liquids and breakables if you choose breakables or liquids when placing the order and make sure to use the appropriate packaging for this, otherwise you are responsible for the freight.',
        t65: 'What is the maximum weight I can send?',
        t66: 'The maximum weight in postal services is equal to 30 kg\n' +
           '          The maximum weight in Mahex services is equal to 30 kg\n' +
           '          The maximum weight in Chapar services is 35 kg\n' +
           '          The maximum weight in Sky Post is equal to 50 kg\n' +
           '          The maximum weight in the carrier is equal to 50 kg\n' +
           '          The maximum weight in podo is equal to 50 kg\n' +
           '          The maximum weight in the courier hub is equal to 50 kg',
        t67: 'What is the maximum size that I can send?',
        t68: '-',
        t69: 'I don\'t know what is the size of my package?',
        t70: 'Dear customer, please refer to the link below to familiarize yourself with the size of postal packages and make the right choice when choosing the size of the shipment.',
        t71: 'The address and information were registered incorrectly and my shipment was sent. Can you help me?',
        t72: 'If you have registered an address in Postex, it is not possible to change the address after receiving the barcode.',


        t73: 'How to get a Postex representative?',
        t74: 'You can register your application by referring to the link to get representation in Postex and get informed about the prerequisites of your application',
        t75: 'How is the income of the agency?',
        t76: 'The answer to this question lies in the regional effort of the representative to attract postal items from the same region, which means that by obtaining a Postex representative, you have access to all kinds of postal services and you can guarantee your income by marketing from that region.\n' +
           'Reference to the page for getting representation in Postex',

        t77: 'If you have not found the answer to your question\n' +
           '   Contact support.',
        t78: 'Postex support team will answer you as soon as possible\n' +
           '  It will be and will answer you.',
        t79: 'Contact support',
        t80: 'page link'
      },
      profile: {
        t1: 'User account settings',
        t2: 'first name',
        t3: 'last name',
        t4: 'phone number (with city code)',
        t5: 'Contact support to edit the phone number',
        t6: 'Identification code',
        t7: 'Change password',
        t8: 'Current password',
        t9: 'New password',
        t10: 'Repeat password',
        t11: 'save',
        t12: 'Get Code',
        t13: 'change Password',
        t14: 'One time code',
        t15: 'cart number',
        t16: 'sheba number',
        t17: 'national code'
      },
      myPackage: {
        t1: 'my package',
        t2: 'Order number',
        t3: 'sender name',
        t4: 'receiver address',
        t5: 'Service type',
        t6: 'remaining time',
        t7: 'Delivery history',
        t8: 'received',
        t9: 'Warehouse delivery',
        t10: 'courier delivery',
        t11: 'Delivery of the parcel',
      },
      map: {
        t1: 'search...'
      },
      error: {
        t1: 'Log in first',
        t2: 'Nothing found',
        t3: "According to the entered items, including the size or Rial value, the service is not available. Please go back to the previous step and change the items.",
        t4: "Entering the name is required",
        t5: "Entering the last name is required",
        t6: "Entering the mobile number is required",
        t7: "The mobile number entered is invalid",
        t8: "Entering the address is required",
        t9: "Your address is not correct",
        t10: "Your address should not be more than 150 characters",
        t11: "Your name should not be more than 50 characters",
        t12: "Your last name should not be more than 50 characters",
        t13: "Your address does not have a location",
        t14: "The entered postal code is invalid",
        t15: "The entered mobile number is invalid",
        t16: "The entered phone number is invalid",
        t17: "The email entered is invalid",
        t18: "Company name should not be more than 50 characters",
        t19: "The sender's mobile number and the recipient's mobile number should not be the same",
        t20: "Selecting the city and province of the sender is mandatory",
        t21: "Selecting the recipient's city and province is mandatory",
        t22: "It is required to enter the size of the postal package",
        t23: "It is mandatory to enter the weight of the shipment",
        t24: "The weight of the shipment should not be less than 50 grams",
        t25: "It is mandatory to enter the Riyal value of the shipment",
        t26: "It is mandatory to enter the contents of the shipment",
        t27: "Choosing the type of payment is required",
        t28: "Choosing the receiving country is mandatory",
        t29: "Selecting or entering the amount is required",
        t30: "Select a port",
        t31: "Entering the national code is required",
        t32: "Password is required",
        t33: "Re-enter your password",
        t34: "Passwords must be the same",
        t35: "Entering a one-time code is required",
        t36: "It is mandatory to enter the topic",
        t37: "Priority entry is required",
        t38: "Entering the section name is required",
        t39: "It is mandatory to enter the ticket type",
        t40: "Entering the order code is required",
        t41: "Entering tracking code is required",
        t42: "Entering the text of the message is required",
        t43: "It is mandatory to enter Shaba number",
        t44: "Entering the amount is required",
        t45: "Selected file must be less than 2 MB",
      },
      autoComplete: {
        t1: 'No Option'
      },
      rules: {
        t1: 'Postex rules',
        t2: 'The timing of collection of orders whose request is from 8:00 am to 8:00 am the next day will be collected by 7:00 pm and in the case of force majeure, the collection will be done with a 24-hour delay without any objection.',
        s1: {
          t1: 'Implementation rules',
          t2: 'I undertake to declare the weight and content of the package accurately and honestly. If the declared weight is inconsistent with the actual weight (which is specified in the analysis and exchanges unit), the order will be canceled and the responsibility for the delay in sending I will be responsible for the cost of reordering or any damage caused by this',
          t3: 'I undertake to declare the recipient\'s address correctly in the system so that the order will not be returned or the maintenance costs at the counter will not be delayed.',
          t4: 'I undertake to coordinate with the recipient to receive the shipment that is pending at the counter',
          t5: 'I undertake to choose the correct address of the sender, including the province, city and region, and if this is not done correctly, I will be responsible for the delay in collecting or canceling the order.',
          t6: 'I undertake to be present from Saturday to Thursday in order to deliver the parcel to the collector until 19:00 at the stated place of order registration (sender\'s address) will not be returned and I also promise that I will not have any claim in this regard. Also, in rainy or snowy weather conditions, or tropical areas (temperature above 45 degrees) and cold areas (temperature below zero degrees), there is a possibility that the collection process will be delayed.',
          t7: 'I declare again that I agree that all orders placed on Fridays and holidays will be collected on the first working day after placing the order, and I will not have any objection in this regard.',
          t8: 'I promise that I will report any complaints regarding the damage caused to any shipment within 24 hours after the order from and non-acceptance of that shipment, and otherwise I will not have any objection. In addition, the obligation of insurance of the shipment until the moment of its delivery to the credit recipient. Will have',
          t9: 'I undertake not to put perishable goods, postal prohibitions and smuggling, weight more than 30 kilos, liquids and dimensions more than 1 meter in the mail and to observe the contents of the postal prohibitions clause.',
          t10: 'I undertake not to send breakable goods unless I have complied with all the packaging regulations, that in case of non-compliance with the above regulations and damage occurs, I will not have any objection and the responsibility for the content of all the goods included in the package is my responsibility, as well as the company\'s It has no responsibility for informing about the packaging of the shipment, and if the shipment is sent with any kind of packaging, the consequences are the responsibility of the sender.',
          t11: 'I undertake to print the PDF file of my order that contains the tracking code and paste it on the package and sign it, and then sign the other copy and keep it with me as a receipt. I must respect the contents of the postal package and if I do otherwise, all the responsibilities for damages etc. will be my responsibility and if I do not have access to the printer, I will write the address of the sender, receiver and order number on the package sent with Insert magic',
          t12: 'I promise that my username and password will not be used by anyone else, otherwise all the responsibilities and obligations contained in the clauses of this commitment letter will be my responsibility.',
          t13: 'I undertake to do all the necessary things regarding correct packaging and baling at my own expense so that the package does not break during transportation, and if my shipment needs repackaging, I will pay for it according to the expert\'s opinion or the packaging amount from the bag account. My money will be deducted automatically',
          t14: 'The working process of the system is such that the orders that are registered before 12 o\'clock in pre-fare and 7 o\'clock in post-fare and COD are referred to the postal operator or courier for collection on the same day and collected from the registered place by 6 p.m. to be collected for the sender, that I undertake that in case of 24 hours delay in collection, I have waived the right to object to the collection of the goods.',
          t15: 'I am committed and informed that the collection of goods is done from the door of the home or workplace and the process of receiving it is such that the goods must be delivered to the collector at the entrance of the building and if necessary to see the contents of the consignment. It is possible to visit it',
          t16: 'I undertake that if I refuse to include the signature in the customer\'s signature section of the review (which was automatically downloaded and provided to me after placing the order), I will waive the right of any objection to receive compensation due to damage or loss of the shipment. These items have once again been confirmed by me at the time of payment of the sending fee electronically (at the time of payment, I confirmed that I read and accept the rules)',
          t17: 'I promise that if the postal company refuses to carry my package for any reason, I will waive the right to protest and will not be allowed to complain in this regard.',
          t18: 'For information about the process of paying the headquarters fee, refer to the instruction section on the site',
          t19: 'If you use an invalid barcode (cancelled) or a barcode that has already been shipped. You will be fined up to 5 times the cost of the barcode used',
          t20: 'The collected shipment will not be returned under any circumstances unless it has a legal problem',
        },
        s2: {
          t1: 'Financial rules',
          t2: 'Order cancellation',
          t3: 'I accept that if I place an order through Postex, if I request to cancel the order, no amount will be refunded.',
          t4: 'I accept that if a package is not delivered at the time of delivery, the package will be canceled.',
          t5: 'I undertake and accept that if the shipment is from a non-postal system, it can be canceled before collection, and if collection is requested or collection is done, no money will be returned for cancellation.',
          t6: 'The duration of sending the package is specified in the description of each postal operator according to the SLA. Shipments that are sent and delivered after the delivery time exceeds the time specified in the SLA table will be subject to compensation for the delay in delivery, which must be registered through eop.post.ir.',
          t7: 'To use COD service, the amount of 1,500,000 riyals will be blocked in the wallet. In case of request to cancel the post-rental account, if the number of registered post-rental orders is less than 10 orders, the amount will be returned, and if more than 10 orders are registered, the amount will not be returned, and the blocked amount can be used instead of the cost of the pre-rental order.',
          t8: 'Dear customer, if you have a request to return the wallet, this is possible by sending a ticket and requesting the return of the wallet. 72 hours after sending the ticket and announcing the Shaba number, the remaining amount of your wallet will be returned.',
        },
        s3: {
          t1: 'Insurance obligations',
          t2: 'All parcels are insured up to the recipient\'s door, and no compensation will be paid after being delivered to the recipient and receiving the recipient\'s signature, so the recipient should refrain from receiving the damaged parcel.',
          t3: 'The company pays the compensation for the damage of the shipment only if it has packed the goods itself. Also, the selected insurance will not cover products that do not have standard packaging',
          t4: 'Customers who request damages more than 2 times in 100 shipments, no damages will be paid even if the above conditions are met.',
          t5: 'If the product is second-hand, the price of a similar new product will be paid after estimating 50% of the price of the new product up to the requested insurance limit.',
          t6: 'When requesting compensation for mails registered with the service, the national card details of the compensation applicant (national card image), address and account number must be entered in the details section of the compensation applicant in the eop.post.ir link.',
        }
      },
      paymentStatus: {
        t1: 'Your payment has been successfully completed',
        t2: 'Your payment was unsuccessful',
        t3: 'Total Amount',
        t4: 'dollar',
        t5: 'Order code',
        t6: 'Tracking Code',
        t7: 'order date',
        t8: 'Add a new order',
        t9: 'Back to the main page',
        t10: 'Return to the orders page',
        t11: 'Print review',
        t12: 'System survey',
        t13: 'Back to chat divar',
      },
      about: {
        t1: 'Send with easy Postex!',
        t2: 'Postex, the first comprehensive transportation service system in the country.',
        t3: 'This system provides unique services by using all types of domestic and foreign express postal services door to door and with special prices.\n' +
           'provides to its customers. Another prominent and important point of this system is the use of strong and excellent support systems\n' +
           'Its customers benefit from 24-hour support services.',
        t4: 'Postex services',
        t5: 'In the Postex system, business owners and industries will be able to use the cooperation of postal operators, including the various services of the First Post operator.\n' +
           '  Chapar, Snapbox, DPE, DTS, TPG, TAPAG service, from a variety of urban and intercity mail services in the country and foreign mail with\n' +
           'Using the service of DPE and TPG companies and in the heavy transportation department of the Obar system service and with the possibility of comparing the price, speed and quality.\n' +
           'to use',
        t6: 'Door to door service and barcode production',
        t7: 'One of the highlights of the Postex system is the possibility of using all services door-to-door and receiving a postal barcode immediately after registration.\n' +
           'The order can be mentioned. At the same time, the foreign mail service of this system has two export and import sections for 180 countries in the world\n' +
           'can be mentioned. You can benefit from safe and secure delivery by reading Postex rules before using it. forget\n' +
           'Do not think that if you are active in the postal service, you can be our representative with a good income.',

        t8: 'Ways of communication',
        t9: 'Order'
      },
      loginEDU: {
        t1: 'http and training to enter the site',
        t2: 'The http protocol or the Hyper Text Transfer Protocol is actually the connection port of users\' systems with all kinds of sites, and the https protocol, which is abbreviated as Hypertext Transfer Protocol Secure means the secure hypertext transfer protocol, is actually the same secured version of http. be\n' +
           '\n' +
           'It is not possible to enter some internal sites through http, or it is associated with interference, or vice versa, some sites need to be loaded only with http addresses, in such cases, the problem will be solved by performing a few simple steps below. .',
        t3: '1. Clicking and copying the URL is the first step you take',
        t4: 'The first step is to copy the site address in the browser',
        t5: '2. Enter the copied link in the new tab and you will undoubtedly see the https or http address',
        t6: '3. By editing the https address in this example and changing it to http, you can easily have internal sites, especially Postex.',
        t7: '4. At the end, you can have the Postbar and Postex site or any other internal site without problems and with http.',
        t8: 'Thank you for accompanying us.\n' +
           'Please read our frequently asked questions and help yourself in serving you as well as possible. Postex is a provider of all kinds of domestic and foreign postal services in a door-to-door express service.\n' +
           'If you are also a postal worker, you can be our representative with a good income.',
        t9: 'Telegram',
        t10: 'Instagram',
        t11: 'site',
        t12: 'Phone Call',
      },
      representation: {
        t1: 'Conditions for obtaining Postex representation',
        t2: 'If you are one of the postal workers in your city and province and you want to get a Postex representative, we invite you to read the rest of this page as well as other rules of this system. Please keep in mind that after reading these items, you must Complete the Postex representative request',
        t3: 'Postex agent prerequisites',
        t4: 'office at least 20 meters (not residential)',
        t5: 'Telephone line, independent water, gas and electricity and suitable internet platform',
        t6: 'Necessary capital to run the branch',
        t7: 'Lack of simultaneous cooperation with competing companies',
        t8: 'Valid warranty',
        t9: 'At least a bachelor\'s degree or 10 years of effective experience in a related business field',
        t10: 'required documents',
        t11: 'Copy of birth certificate equal to the original',
        t12: 'Copy of national card equal to the original',
        t13: 'Two pieces of 4x3 photos',
        t14: 'Copy of educational certificate equal to the original',
        t15: 'Guarantees and bank documents are according to the contract (100 million).',
        t16: 'Certificate of no bad background in the name of behtarh Memaran company',
        t17: 'Signed agency agreement and signature certificate',
        t18: 'duties',
        t19: 'Marketing',
        t20: 'Coordinate with the post office to collect',
        t21: 'Follow-up of delay in collection of shipping and delivery and compensations for breakage and delay and possible collection of loads that the post has not collected.',
        t22: 'Regional advertising',
        t23: 'The download link for the agency contract',
        t24: 'Completed promissory note sample',
        t25: 'Receive the commissions file',
      },
      cartoon: {
        t1: 'carton and wrapper',
        t2: 'What are standard postal cartons and wrappers? Answering this question and complying with it is one of the important rules of using postal services. Basically, the carton, wrapper and standard postal box should be 3 to 5 layers so that the box does not fall apart during the postal movement.',
        t3: 'buy packaging',
        t4: 'Now you can enjoy this service by any postal operator by using the option of buying a box and carton of a standard postal package. Nowadays, the importance of packaging is essential due to the limitations of postal spaces, the need for standard dimensions and standard boxes to carry out the shipment process',
        t5: 'standard sizes of cartons and envelopes of postal boxes',
        t6: 'pack size',
        t7: 'length:',
        t8: 'width:',
        t9: 'height:',
      },
      msg: {
        t1: 'The address has been successfully registered',
        t2: 'The address has been successfully updated',
        t3: 'Please enter one of the postal barcode or order number fields',
        t4: 'Loading information',
        t5: "Your request has been successfully registered",
        t6: "Check items",
        t7: "mission accomplished",
        t8: "Not Found",
        t9: "Your request encountered a problem",
        t10: "Passwords must be the same",
        t11: "error network",
        t12: "There was a problem executing the request"
      },
      rate: {
        t1: 'Thank you for choosing our amnito service.',
        t2: 'To record your experience after using the amnito service and also to help improve this service, please participate in the survey below.',
        t3: '1- What was your overall experience of choosing a amnito service?',
        t4: 'Bad',
        t5: 'Good',
        t6: 'very good',
        t7: '2- How do you evaluate the process of using the amnito service?',
        t8: 'hard',
        t9: 'Normal',
        t10: 'easy',
        t11: '3- How confident were you about making a purchase with the amnito service?',
        t12: 'I wasn\'t sure',
        t13: 'I was somewhat sure',
        t14: 'I was absolutely sure',
        t15: '4- How satisfied were you with the quality of your product delivery?',
        t16: 'I was not satisfied at all',
        t17: 'I was somewhat satisfied',
        t18: 'I was completely satisfied',
        t19: '5- If you have contacted the support team while using the amnito service, please express your satisfaction with the quality of the support.',
        t20: 'My problem was not solved',
        t21: 'My problem was solved to some extent',
        t22: 'My problem is completely solved',
        t23: '6- How do you evaluate your amnito service in terms of pricing?',
        t24: 'very expensive',
        t25: 'Normal',
        t26: 'Quite cheap and affordable',
        t27: '7- How likely are you to recommend your amnito service to your friends?',
        t28: 'I do not suggest at all',
        t29: 'I may suggest',
        t30: 'I will definitely suggest',
        t31: '8- Do you have an opinion about the different parts of the amnito service that will help to improve this service?',
        t32: 'End of survey',
      },
      orderCancellation: {
        t1: "order cancellation form",
        t2: "",
        t3: "name and surname",
        t4: "mobile phone",
        t5: "order number",
        t6: "cancellation reason",
        t7: "failure to collect mail on time",
        t8: "Actual weight mismatch with stated weight",
        t9: "improper packaging",
        t10: "cancellation at the customer's request",
        t11: "address does not match the postal code declared for the sender or receiver",
        t12: "Contents do not match the type of shipment declared",
        t13: "Non-delivery of the shipment by the sender",
        t14: "No presence of the sender in the place",
        t15: "postal prohibitions",
        t16: "Other",
        t17: "description",
        t18: "return of postal service amount",
        t19: "Refund for technical and support services",
        t20: "Carton and packaging refund",
        t21: "return of collection amount",
        t22: "Agreement percentage of refund",
        t23: "choosing the method of deposit",
        t24: "wallet",
        t25: "bank card",
        t26: "register request",
      },
      withdrawalRequest: {
        t1: "Withdrawal request from wallet",
        t2: "Deposits will be on Saturday, Monday and Wednesday.",
        t3: "The amount of 500 thousand Tomans will be blocked in the account.",
        t4: "The daily withdrawal limit for each deposit is 5 million tomans.",
        t5: "The monthly withdrawal limit is 80 million tomans.",
        t6: "name and surname",
        t7: "mobile phone - username",
        t8: "Sheba Number",
        t9: "requested amount (riyal)",
        t10: "register request",
      },
      agencyRequest: {
        t1: "representation and store request form",
        t2: "You can cooperate with us easily and bear costs close to zero. Fill out an online agency or store request form. Our technical colleagues will contact you after confirming and checking the qualifications.",
        t3: "name and surname",
        t4: "City / Province",
        t5: "address",
        t6: "Field of study",
        t7: "landline",
        t8: "mobile phone",
        t9: "email",
        t10: "marital status",
        t11: "single",
        t12: "Married",
        t13: "age",
        t14: "access to office space",
        t15: "none",
        t16: "I have",
        t17: "I don't have",
        t18: "Do you have postal records? Explain.",
        t19: "Are you able to equip the agency up to 35 million tomans?",
        t20: "Yes",
        t21: "No",
        t22: "Can you afford to pay your employees' salaries and insurance premiums?",
        t23: "how to meet",
        t24: "wall site",
        t25: "representative finder",
        t26: "via Postex site",
        t27: "Introducing Friends",
        t28: "Instagram",
        t29: "My Irancell application",
        t30: "other",
        t31: "Are you able to introduce a guarantor?",
        t32: "Is your office space on the ground floor?",
        t33: "How many points per day is the capacity of your fleet to distribute and collect?",
        t34: "point",
        t35: "Which of the following do you have in your office?",
        t36: "Computer",
        t37: "barcode scanner",
        t38: "shelving",
        t39: "CCTV camera",
        t40: "Enter the location (lat and long) of the shop address",
        t41: "Select the end date of the lease",
        t42: "select date",
        t43: "Do you have another job?",
        t44: "I have read and accept the rules and regulations",
        t45: "description",
        t46: "Please do not leave the page after registering your application and read the annexes and regulations page",
        t47: "Registration of representation request",
        t48: "Agent request",
        t49: "Shop request",
        t50: "store name",
        t51: "surname",
        t52: "identity information",
        t53: "father's name",
        t54: "ID number",
        t55: "Birth Certificate Series",
        t56: "Birth Certificate Series",
        t57: "place of birth certificate",
        t58: "Date of Birth",
        t59: "national code",
        t60: "National Card Series",
        t61: "gender",
        t62: "man",
        t63: "woman",
        t64: "Residence Information",
        t65: "postal code",
        t66: "Representative location information",
        t67: "bank information",
        t68: "Sheba Number",
        t69: "account number",
        t70: "bank",
        t71: "branch name",
      },
      codRequest: {
        t1: "first name",
        t2: "last name",
        t3: "phone number (with city code)",
        t4: "zip code",
        t5: "National Code/National ID",
        t6: "national card serial number",
        t7: "Date of Birth",
        t8: "mobile number",
        t9: "email",
        t10: "account number",
        t11: "iban Number",
        t12: "Bank branch name",
        t13: "province/city",
        t14: "city",
        t15: "address",
        t16: "Payment type",
        t17: "Request registration",
        t18: "COD request form",
      },
      myRequests: {
        t1: "my requests",
        t2: "search for the desired word...",
        t3: "Request of the Minister of Finance",
        t4: "cancel order",
        t5: "Delegation request",
        t6: "Store request",
        t7: "ticket number",
        t8: "date",
        t9: "view",
        t10: "request number",
        t11: "order number",
      },
      employment: {
        t1: "Employment application form",
        t2: "quantitative assessment",
        t3: "name",
        t4: "surname",
        t5: "landline",
        t6: "mobile phone",
        t7: "email",
        t8: "Please specify the section you want",
        t9: "province/city",
        t10: "address",
        t11: "The last degree",
        t12: "Diploma",
        t13: "associate",
        t14: "Bachelor",
        t15: "Master",
        t16: "PhD",
        t17: "University of the place of study",
        t18: "Field of study",
        t19: "status of duty system",
        t20: "end of service",
        t21: "Education exemption (Student)",
        t22: "other",
        t23: "marital status",
        t24: "single",
        t25: "Married",
        t26: "Date of Birth",
        t27: "The amount of work experience",
        t28: "requested salary amount",
        t29: "The level of familiarity with English",
        t30: "low",
        t31: "Medium",
        t32: "much",
        t33: "Advanced",
        t34: "register request",
        t35: "resume selection",
        t36: "Student",
      }
    }
  },

  fa: {
    postex: {
      navBar: {
        t1: 'ورود / ثبت نام',
        t2: 'خانه',
        t3: 'سفارش تکی',
        t4: 'سفارش انبوه',
        t5: 'کیف پول',
        t6: 'پیشخوان',
        t7: 'حساب من',
        t8: 'کاربر',
        t9: 'فرم نمایندگی',
        t10: 'تماس با دفتر مرکزی',
        t11: 'ارسال بسته انبوه'
      },
      bottomNavigation: {
        t1: 'خانه',
        t2: 'پشتیبانی',
        t3: 'سفارش',
        t4: 'کیف پول',
        t5: 'پیشخوان',
        t6: 'سفارشات من',
      },
      footer: {
        t1: 'اطلاعات کلی سایت',
        t2: 'قوانین سامانه پستِکس',
        t3: 'درباره پستِکس',
        t4: 'اخبار',
        t5: 'انجمن ها',
        t6: 'بلاگ',
        t7: 'راهنمای مشتریان',
        t8: 'مستندات وب سرویس',
        t9: 'وجه دریافتی از گیرنده به اشتباه',
        t10: 'http و آموزش ورود به سایت',
        t11: 'شرایط اخذ نمایندگی پستِکس',
        t12: 'کارتن و لفاف',
        t13: 'آکادمی آموزش',
        t14: 'سوالات متداول',
        t15: 'حساب من',
        t16: 'پیشخوان',
        t17: 'لیست سفارشات',
        t18: 'ویرایش حساب کاربری',
        t19: 'خدمات',
        t20: 'حسابداری',
        t21: 'تیکت',
        t22: 'ارتباط با پستِکس',
        t23: 'دریافت اپلیکیشن',
        t24: 'منطقه شهرداری هفت، خیابان شریعتی، کوچه مسجد، پلاک ۱۸، طبقه دوم',
        t25: 'شماره تماس',
        t26: 'تمام حقوق این سایت متعلق به معماران بهطرح میباشد | 2023'
      },
      drawer: {
        t1: 'خدمات پستی',
        t2: 'پیک هاب (پیک درون شهری)',
        t3: 'PME (پست خارجی)',
        t4: 'شاپکس (فروشگاه ساز)',
        t5: 'لودکس (حمل و نقل سنگین)',
        t6: 'بیوپست (پست سرد)',
        t7: 'کادوکس (ارسال کادو)',
        t8: 'سفارشات من',
        t9: 'اصلاح سایز بسته بندی',
        t10: 'دانلود اپلیکیشن',
        t11: 'پشتیبانی',
        t12: 'ارسال تیکت به پشتیبانی',
        t13: 'لیست تیکت های من',
        t14: 'اخذ نمایندگی',
        t15: 'نظرات کاربران',
        t16: 'افزونه / API',
        t17: 'نشریه حمل و نقل',
        t18: 'درباره ما',
        t19: 'پستِکس یار ( سوالات متداول )',
        t20: 'تنظیمات حساب کاربری',
        t21: 'خروج از حساب کاربری',
        t22: 'سفارشات دیگران برای من',
        t23: "خانه",
        t24: "همکاری با ما"
      },
      login: {
        t1: 'پستِکس اولین هاب پستی ایران با ارائه دهنده خدمات آنلاین پست به صورت درب تا درب',
        t2: 'ورود به حساب کاربری',
        t3: 'شماره موبایل',
        t4: 'رمز عبور',
        t5: 'مرا به خاطر داشته باش',
        t6: 'فراموشی رمز عبور؟',
        t7: 'ورود به حساب کاربری',
        t8: 'کاربر جدید هستید در پستِکس؟',
        t9: 'ثبت نام',
        t10: 'بازگشت به صفحه اصلی',
      },
      register: {
        t1: 'شما میتوانید به راحتی با مقایسه قیمت، سرعت و کیفیت خدمات، از سرویس های متنوع سامانه پستِکس استفاده کنید',
        t2: 'ثبت نام در پستِکس',
        t3: 'شماره موبایل همراه با صفر',
        t4: 'کد ملی',
        t5: 'رمز عبور',
        t6: 'تایید رمز عبور',
        t7: 'ثبت نام در پستِکس',
        t8: 'ثبت نام در پستِکس به منزله موافقت با قوانین است.',
        t9: 'قوانین',
        t10: 'قبلا در پستِکس ثبت نام کرده اید؟',
        t11: 'ورود',
        t12: 'بازگشت به صفحه اصلی',
        t13: 'پسوردها یکی نمیباشند',
        t14: 'نام',
        t15: 'نام خانوادگی',
        t16: 'موافقم'
      },
      newPassword: {
        t1: 'شما میتوانید به راحتی با مقایسه قیمت، سرعت و کیفیت خدمات، از سرویس های متنوع سامانه پستِکس استفاده کنید',
        t2: 'لطفا رمز عبور جدید را وارد کنید',
        t3: 'رمز عبور جدید',
        t4: 'تایید رمز عبور جدید',
        t5: 'ثبت رمز عبور',
        t6: 'بازگشت به صفحه اصلی',
        t7: 'شماره موبایل',
        t8: 'ارسال',
      },
      forgetPassword: {
        t1: 'شما میتوانید به راحتی با مقایسه قیمت، سرعت و کیفیت خدمات، از سرویس های متنوع سامانه پستِکس استفاده کنید',
        t2: 'لطفا کد دریافتی را وارد کنید',
        t3: 'تایید کد',
        t4: 'کد دریافت نکرده اید؟',
        t5: 'اصلاح شماره تماس',
        t6: 'بازگشت به صفحه اصلی',
        t7: 'ارسال مجدد کد',
        t8: 'کد تایید',
        t9: 'پسورد جدید',
        t10: 'تکرار پسورد جدید',
        t11: 'ثبت',
      },
      homeDesktop: {
        s1: {
          t1: "خدمات آنلاین پستی از درب منزل",
          t2: 'پستِکس اولین هاب پستی ایران با ارائه دهنده خدمات آنلاین پست به صورت درب تا درب است',
          t3: {
            tt1: 'رهگیری مرسولات پستی',
            tt2: 'بارکد پستی (کد رهگیری)، شماره سفارش یا موبایل فرستنده/گیرنده را وارد کنید:',
            tt3: 'بارکد پستی',
            tt4: 'شماره سفارش',
            tt5: 'موبایل فرستنده/گیرنده',
            tt6: 'رهگیری مرسوله',
            tt7: 'بارکد پستی یا شماره سفارش',
            tt8: 'رهگیری بسته و محاسبه قیمت بسته',
          },
          t4: {
            tt1: 'محاسبه سریع قیمت پستی',
            tt2: 'لطفا برای محاسبه قیمت پستی، اطلاعات زیر را وارد کنید',
            tt3: 'پست داخلی',
            tt4: 'پست خارجی',
            tt5: 'فرستنده',
            tt6: 'شهر - استان',
            tt7: 'گیرنده',
            tt8: 'شهر - استان',
            tt9: 'سایز',
            tt10: 'انتخاب کنید',
            tt11: 'ارزش کالا (ریال)',
            tt12: 'وزن ( گرم )',
            tt13: 'توزیع',
            tt14: 'نیاز به جمع آوری',
            tt15: 'بسته بندی',
            tt16: 'استعلام قیمت',
            tt17: 'پس کرایه',
            tt18: 'پرداخت در محل(COD)',
            tt19: 'کشور',
            tt20: 'آیا شکستنی است؟',
            tt21: 'آیا حاوی مایعات است؟',
            tt22: "سایز بزرگتراز 9",
            tt23: "ارزش کالا جهت تعیین سقف تعهدات"
          },
          t5: 'بسته تو ارسال کن',
          t6: 'نتیجه رهگیری مرسوله شما',
          t7: 'کد رهیگری/شماره سفارش/موبایل',
          t8: 'نام سرویس پستی',
          t9: 'نوع مرسوله',
          t10: 'تاریخ جمع آوری',
          t11: 'تاریخ ارسال',
          t12: 'تاریخ تحویل',
          t13: 'نام فرستنده',
          t14: 'آدرس فرستنده',
          t15: 'نام گیرنده',
          t16: 'آدرس گیرنده',
          t17: 'نتیجه محاسبه سریع قیمت',
          t18: 'با',
          t19: 'پستِکس',
          t20: 'آسون',
          t21: 'بفرست',
          t22: 'شاپکس',
          t23: 'فروشگاه ساز آنلاین',
          t24: 'با پستِکس امکان ارسال بسته به خارج از کشور رو هم داری',
          t25: 'با پیک هاب کسب و کارت رو به راهه',
          t26: 'کد رهیگری',
          t27: 'ارسال بسته',
          t28: "حضور پستِکس در نمایشگاه Gitex",
          t29: "",
          t30: "تنها رویداد برای ارتباط با 250 نهاد دولتی",
          t31: "بزرگترین حضور دولت در میان رویدادهای فناوری، پرده برداری از پروژه های دیجیتال ملی و مشارکت خصوصی و دولتی",
          t32: "نو آورترین شرکت های جهان",
          t33: "قدرت انکارناپذیر نوآوری را در نمایشی جامع از محصولات و راه حل های جهانی با کاربردهای صنعتی متنوع تجربه کنید",
          t34: "جیتکس، الهام بخش و بهبود دهنده زندگی",
          t35: "نشست خبری نمایشگاه جیتکس جهانی که دوشنبه هفته آینده افتتاح می‌شود با حضور وزیر دولت امارات متحده عربی در حوزه هوش مصنوعی برگزار شد",
          t36: "برای نخستین بار جیتکس گلوبال امسال در دو محل وسیع برگزار می‌شود",
          t37: "این نمایشگاه محل عرضه تازه‌ترین فناوری‌ها و پیشرفت‌ها در حوزه هوش مصنوعی، رایانش ابری، وب ۳.۰ و اقتصاد پایدار دیجیتال است",
        },
        s2: {
          t1: 'چرا مرسولاتم رو باید با پستِکس بفرستم؟',
          t2: 'سرویس های پستِکس',
          t3: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع ',

          t4: 'سرویس امنیتو',
          t5: '<h2>با امنیتو، لذت <b>خرید اینترنتی</b> را به مشتری هدیه بدهید</h2>',
          t6: 'یکی از مشکلات خرید فروش اینترنتی، اعتماد کاربر و پرداخت هزینه هست که پستِکس با سرویس پرداخت امن به نام امنیتو این مشکل را حل کرده است و میرسد به نظر راهکاری مناسب، برای جلب اعتماد خریدار و فروشنده است',
          t7: 'در سرویس امنیتو، در زمان فروش کالا، خریدار وجه کالا ر تا زمان تحویل و رویت مرسوله، وجه کالا را در حساب واسط و امانی امنیتو قرار میدهد که در صورت تایید مرسوله و دریافت وضعیت تحویل مبلغ مرسوله به نفع فروشنده آزاد خواهد شد و در صورت عدم تایید مرسوله و دریافت وضعیت عدم تایید،',
          t8: 'خرید و فروش امن در فروشگاه های اینترنتی',
          t9: 'شروع به کار',

          t10: 'سرویس بیو پست',
          t11: '<h2>دیگه نگران جابه جایی <b>نمونه های آزمایشگاهی</b> نباش!</h2>',
          t12: 'پست بیولوژیک و پست سرد خدمتی جدید از پستِکس که با نام با نام بیو پستِکس که مخصوص حمل نمونه های عفونی-آزمایشگاهی و مواد شیمیایی است در۲۴ الی ۳۶ ساعت در تمامی نقاط کشورتوزیع میشود و جمع آوران، مرسولات همراه و موقعیت پستی در سلامت خواهند بود',
          t13: 'جا به جایی نمونه های آزمایشگاهی',

          t14: 'سابکس',
          t15: '<h2> دیگه نگران فیلترینگ اینستاگرام نباش! <b>با سابکس فروشگاهت رو گسترش بده.</b></h2>',
          t16: '  با استفاده از سرویس سابکس میتوانید کلیه محصولات خود را در پنل شخصی خود بارگذاری کرده و با دریافت یک لینک اختصاصی و عرضه آن به مشتری یا قرار دادن در بیوگرافی، خریدار با مراجعه به کلیک کردن لینک شما، لیست کاملی از محصولات فروشگاه شما را خواهد داشت',
          t17: '  پس لذا به راحتی میتواند با ئارد کردن آدرس؛ نوع کالای منتخب، روش ارسال و حتی نوع سرویس پرداخت از مجموعه شما خرید بنماید که با این روش شما میتوانید به امکانات و اطلاعات فوق العاده ای دست پیدا کنید',
          t18: 'سرویس سابکس جایگزین اینستاگرام',

          t19: 'شیپیتو پلاس',
          t20: '<h2>محاسبه مسیر ها  <b> ارزانترین و سریعترین </b> برای ارسال بسته ها!</h2>',
          t21: 'اگر فروشگاهی دارای ناوگانی برای عرضه خدمت در حوزه جمع آوری و توزیع مرسولات خود باشد یکی از مهمترین چالش ها، محاسبه بهینه مسیرهای ناوگان، بر اساس کوتاه ترین و کم ترافیک ترین مسیرها است',
          t22: 'اگر فرض بر این باشد که این امر در تعداد کم و با توجه به شناخت مسیرها مقدور باشد ولی محاسبه انسانی در تعداد بالای امریست غیر ممکن و ثانیا دانش ترافیک های منطقه ای بصورت آنلاین و یا تقویمی، خود امریست موثر در این محاسبه',
          t23: 'پست هوشمند با هوش مصنوعی',

          t24: 'فروشگاه ساز شاپکس',
          t25: '<h2>ساخت <b>فروشگاه آنلاین با پنل اختصاصی </b>و کلی امکانات دیگه با شاپکس! </h2>',
          t26: 'با گسترش روزافزون روش های فروش و تبلیغات، یکی از قدیمی ترین روشهای فروش یعنی تله مارکتینگ با استفاده از کال سنتر همچنان یکی از روشهای موثر در امر فروش است',
          t27: 'حال شما میتوانید کلیه محصولات خود را در پنل شخصی خود بارگذاری کرده و 4 روش ارسال رایگان، پرداخت در محل، پرداخت نقدی، خرید و فروش امن و امکاناتی نظیر لیزینگ مبلغ کالای فروخته شده بر اساس درصد برگشتی به مانند خط اعتباری دایمی از شاپکس استفاده نمایید و با این روش شما میتوانید به امکانات و اطلاعات فوق العاده ای دست پیدا کنید',
          t28: 'با شاپکس همه چیز رو با هم بفروش',

          t29: 'پست داخلی',
          t30: '<h2> بسته خود را با انواع سرویس های <b> پست داخلی </b> ارسال کنید! </h2>',
          t31: 'با گسترش روزافزون روش های فروش و تبلیغات، یکی از قدیمی ترین روشهای فروش یعنی تله مارکتینگ با استفاده از کال سنتر همچنان یکی از روشهای موثر در امر فروش است',
          t32: 'حال شما میتوانید کلیه محصولات خود را در پنل شخصی خود بارگذاری کرده و 4 روش ارسال رایگان، پرداخت در محل، پرداخت نقدی، خرید و فروش امن و امکاناتی نظیر لیزینگ مبلغ کالای فروخته شده بر اساس درصد برگشتی به مانند خط اعتباری دایمی از شاپکس استفاده نمایید و با این روش شما میتوانید به امکانات و اطلاعات فوق العاده ای دست پیدا کنید',
          t33: 'با پست بار نگران ارسال بسته هات نباش',

          t34: 'کادوکس',
          t35: '<h2>دیگه نگران فرستادن <b>کادو</b>برای عزیزانتان نباشید!</h2>',
          t36: ' بزارید جواب این سوال رو با یک سوال شروع کنیم!\n' +
             'تا به حال در شرایطی قرار گرفتید که برای فردی برای روز تولدش بخواهید کنارش باشید و به هر علتی این شرایط فراهم نشده است و احتمالا کادوی مورد نظر ایشون رو هم آماه کردید و با شرکتهای پستی فرستادید و سر موقع نرسیده باشد.\n' +
             'کادوکس سامانه کادو اکسپرسی است که شما با ثبت شهر مقصد خود، نیاز به کادوپیچی، گل و حتی کیک مد نظرتان میتوانید کادوی مورد مورد نظرتان رو به موقع و با شرایط مورد نظرتان به دست فردی که در نظر دارید برسانید',
          t37: 'با کادوکس فاصله ها کم میشه',

          t38: 'پستِکس یار',
          t39: '<h2><b>پستِکس یار،</b> همراه افراد معلول و کسانی که محدودیت داردند!</h2>',
          t40: 'خدمت نوین پستی برای روشن دلان، معلولان، جانبازان و یا اونهایی که به گوشی هوشمند دسترسی ندارن یا بلد نیستن بخوبی ازش استفاده کنه این امکان رو میده با تماس در کوتاه ترین زمان جمع آور پستِکس رو درب محل زندگی یا کارش ببینه و مرسولات رو بدون انجام روند ثبت سفارش اینترنتی رهسپاری کنه',
          t41: 'پستِکس یار - یار و غم خوار',
          t42: 'بزودی...'
        },
        s3: {
          t1: 'چگونه نمایندگی پستِکس را دریافت کنید',
          t2: '<h2>آیا می‌خواهید به عنوان <b>جمع‌آور</b> یا <b>نماینده‌ی پستِکس</b> با ما همکاری کنید؟</h2>',
          t3: 'اگر چنین است، می‌توانید درخواست نمایندگی خود را برای ما ارسال کنید. دریافت نمایندگی پستِکس هر فردی که می‌خواهد به صورت مستقل و منعطف، با حداقل هزینه و بیشترین میزان سود فعالیت کند، یک فرصت به حساب می‌آید. مراحل دریافت نمایندگی به صورت زیر است:',
          t4: 'درخواست نمایندگی',
          t5: 'درخواست نمایندگی شما تایید شد!',
          t6: 'پر کردن فرم مربوط به درخواست نمایندگی',
          t7: 'تماس تیم پشتیبانی برای تأیید صلاحیت',
          t8: 'ارائه‌ی مدارک درخواستی اعم از چک بانکی، سفته، قرارداد امضا شده، مدارک مالکیت وسیله نقلیه، اجاره‌نامه محل کسب و غیره.',
          t9: 'دریافت حق نمایندگی پستِکس'
        },
        s4: {
          t1: 'نرم افزار پستِکس',
          t2: '<h2>هم اکنون می‌توانید از <b>اپ پستِکس</b> روی <b>گوشی اندرویدی</b> خود استفاده کنید</h2>',
          t3: 'معرفی برنامه',
          t4: 'سامانه پستِکس (www.postex.ir) اولین سامانه جامع حمل و نقل آنلاین پستی ایران از درب تا درب می باشد که روزانه هزاران مرسوله توسط این هاب پستی و باسبک های مختلف و گوناگون پستی جابجا می شود.',
          t5: 'گوگل پلی',
          t6: 'کافه بازار',
          t7: 'رهگیری مرسوله، در هر لحظه در هرجا!',
          t8: 'پستِکس',
          t9: 'معماران بهطرح',
          t10: ' سامانه پستِکس (www.postex.ir) اولین سامانه جامع حمل و نقل آنلاین پستی ایران از درب تا درب می باشد',
          t11: 'خدمات و ویژگی های پستِکس:',
          t12: 'پست ملی ایران ، چاپار، یارباکس و پست پیشتاز ، پست سفارشی ، پست سریع ، پست ویژه ، پست شهری'
        },
        s5: {
          t1: 'همکاران پستِکس',
          t2: '<h2>سرویس هایی که ما <b>افتخار همکاری</b> با آنها را داریم</h2>',
          t3: 'اسنپ باکس',
          t4: 'شرکت اسپید',
          t5: 'شرکت گنجه',
          t6: 'بیو پست ( پست سرد )',
          t7: 'اسکای پست',
          t8: 'راه آسمان آبی',
          t9: 'پست خارجی',
          t10: 'آرامکس',
          t11: 'چاپار',
          t12: 'پست پیشرو',
          t13: 'ماهکس',
          t14: 'پست ملی ایران',
          t15: 'یار باکس',
          t16: 'ندکس',
          t17: 'کالا رسان',
        },
        s6: {
          t1: 'خبرنامه پستِکس',
          t2: '<h2>از آخرین <b>اخبار و تخفیف ها</b> با خبر شو!</h2>',
          t3: 'لطفا ایمیل خودتون رو وارد کنید ...',
          t4: 'عضویت',
        }
      },
      // <div dangerouslySetInnerHTML={{ __html: t("homeDesktop.s2.t5") }} />
      // {t("homeDesktop.s5.t6")}
      homeMobile: {
        t1: 'رهگیری مرسولات',
        t2: 'لطفا اطلاعات خود را وارد کنید',
        t3: 'بارکد پستی',
        t4: 'رهگیری مرسوله',
        t5: 'محاسبه سریع قیمت پستی',
        t6: 'بسته تو ارسال کن',
        t7: 'محاسبه سریع قیمت پستی',
        t8: 'پست داخلی',
        t9: 'پست خارجی',
        t10: 'فرستنده',
        t11: 'شهر - استان',
        t12: 'گیرنده',
        t13: 'سایز',
        t14: 'انتخاب کنید',
        t15: 'ارزش کالا (ریال)',
        t16: 'وزن مرسوله ( گرم )',
        t17: 'توزیع',
        t18: ' نیاز به جمع آوری',
        t19: 'بسته بندی',
        t20: 'فرستنده',
        t21: 'کشور',
        t22: 'استعلام قیمت',
        t23: 'بسته های من',
        t24: 'تحویل پست داده شده',
        t25: 'آخرین به روز رسانی: 3 ساعت پیش',
        t26: 'شماره سفارش',
        t27: 'موبایل فرستنده/گیرنده',
        t28: 'بارکد پستی یا شماره سفارش',
        t29: 'اولین بستتو ارسال کن',
        t30: 'شروع ثبت سفارش',
        t31: 'رهگیری مرسوله یا استعلام قیمت',
        t32: "ارزش کالا جهت تعیین سقف تعهدات"
      },
      dashboard: {
        sideBar: {
          t1: 'دفترچه آدرس ها',
          t2: 'پیام ها',
          t3: 'سفارشات من',
          t4: 'درخواست فاکتور',
          t5: 'امتیاز معرفی',
          t6: 'تنظیمات',
          t7: 'خروج از حساب کاربری',
          t8: 'لیست آدرس ها',
          t9: 'سفارشات دیگران برای من',
          t10: 'درخواست های من',
        },
        address: {
          t1: 'دفترچه آدرس ها',
          t2: 'افزودن آدرس جدید',
          t3: 'جستجو در آدرس های قبلی',
          t4: 'نام',
          t5: 'نام خانوادگی',
          t6: 'تلفن همراه',
          t7: 'نام شرکت',
          t8: 'اضافه کردن استان',
          t9: 'شهر - استان',
          t10: 'متن آدرس',
          t11: 'آدرس بصورت متنی',
          t12: 'ذخیره',
          t13: 'قسمتی از آدرس را تایپ کنید',
          t14: 'تهران - شهرک اکباتان - ...',
          t15: 'لیست آدرس ها',
          t16: 'آدرس',
          t17: 'گیرنده',
          t18: 'انتخاب شهر',
          t19: 'فرستنده',
          t20: 'آدرس برای',
          t21: 'آیا میخواهید آدرس راحذف کنید؟',
          t22: 'تایید',
          t23: 'انصراف',
          t24: 'انتخاب آدرس به عنوان پیش فرض',
          t25: 'آدرس پیش فرض',
          t26: 'ویرایش آدرس',

        },
        message: {
          t1: 'پیام ها'
        },
        order: {
          t1: 'سفارشات من',
          t2: 'همه',
          t3: 'پرداخت شده',
          t4: 'معلق',
          t5: 'چاپ',
          t6: 'شماره سفارش',
          t7: 'وضعیت پرداخت',
          t8: 'وضعیت سفارش',
          t9: 'وضعیت ارسال',
          t10: 'فرستنده',
          t11: 'گیرنده',
          t12: 'قیمت',
          t13: 'ریال',
          t14: 'پرداخت',
          t15: 'روش پرداخت',
          t16: 'لغو',
          t17: 'سفارشات دیگران برای من',
          t18: 'جستجو سفارش',
          t19: 'از تاریخ',
          t20: 'تا تاریخ',
          t21: 'جستجو',
          t22: 'بستن',
          t23: "لغو",
          t24: "جمع آوری",
          t25: "ویرایش",
          t26: "جزئیات",
          t27: "شماره سفارش",
          t28: "شماره محموله",
          t29: "وضعیت سفارش",
          t30: "وضعیت پرداخت",
          t31: "شماره رهگیری",
          t32: "تاریخ",
          t33: "استان/شهر مبدا",
          t34: "شهر مبدا",
          t35: "آدرس مبدا",
          t36: "نام کامل فرستنده",
          t37: "نام خانوادگی فرستنده",
          t38: "شماره موبایل فرستنده",
          t39: "استان/شهر مقصد",
          t40: "شهر مقصد",
          t41: "آدرس مقصد",
          t42: "نام کامل گیرنده",
          t43: "نام خانوادگی گیرنده",
          t44: "محتویات مرسوله",
          t45: "وزن مرسوله",
          t46: "هزینه بیمه",
          t47: "نیاز به پرینتر دارد؟",
          t48: "ارزش مرسوله",
          t49: "حق ثبت الکترونیکی",
          t50: "نیاز به کارتون دارد؟",
          t51: "طول بسته",
          t52: "عرض بسته",
          t53: "ارتفاع بسته",
          t54: "نیاز به چاپ لوگو دارد؟",
          t55: "نیاز به جمع آوری دارد؟",
          t56: "نیاز به توزیع دارد؟",
          t57: "بله",
          t58: "خیر",
          t59: "جزئیات سفارش",
          t60: "اطلاعات مرسوله",
          t61: "خدمات",
          t62: " موجود نیست ",
        },
        affiliate: {
          t1: 'امتیاز معرفی',
          t2: 'دریافت کد دعوت',
          t3: 'با دعوت از دوستان خود به پستِکس هدیه دریافت کنید',
          t4: 'کپی شد',
        },
        setting: {
          t1: 'تنظیمات',
          t2: 'سرویس دریافت ایمیل اطلاعات ثبت سفارش',
          t3: 'دسترسی به پرینتر',
          t4: 'دسترسی به بسته پستی',
          t5: 'بارگذاری نشان تجاری',
          t6: 'تغییر تم سایت',
          t7: 'تغییر زبان سایت',
          t8: 'ذخیره',
        },
        requestFactor: {
          t1: 'لیست فاکتور',
          t2: 'درخواست فاکتور',
          t3: 'نام',
          t4: 'نام خانوادگی',
          t5: 'کد ملی',
          t6: 'کد اقتصادی',
          t7: 'کد اتباع خارجی',
          t8: 'کد پستی',
          t9: 'آدرس',
          t10: 'درخواست',
          t11: 'درحال بررسی'
        }
      },
      wallet: {
        t1: 'افزایش اعتبار',
        t2: 'انتخاب مبلغ',
        t3: 'انتخاب کنید',
        t4: 'مبلغ دلخواه ( ریال )',
        t5: 'انتخاب روش پرداخت',
        t6: 'بانک ملت',
        t7: 'پرداخت و افزایش اعتبار',
        t8: 'گزارش مالی',
        t9: 'هفتگی',
        t10: 'ماهانه',
        t11: 'سالانه',
        t12: 'ریال',
        t13: 'واریز',
        t14: 'برداشت',
        t15: 'گزارش مالی',
        t16: 'ردیف',
        t17: 'نوع تراکنش',
        t18: 'مبلغ',
        t19: 'تاریخ تراکنش',
        t20: 'شماره تراکنش',
        t21: 'جیب',
        t22: 'کدام سفارش',
        t23: 'تایید و پرداخت',
        t24: 'انتقال اعتبار',
        t25: 'شماره تلفن',
        t26: 'مبلغ دلخواه ( ریال )',
        t27: 'انتخاب مبلغ',
        t28: 'موجودی فعلی',
        t29: 'لیست تراکنش ها',
        t30: 'پاک کردن لیست تراکنش ها',
        t31: 'تسویه حساب'
      },
      singleOrder: {
        t1: 'مرحله قبل',
        t2: 'مرحله بعد',
        t3: 'تکمیل سفارش',
        t4: 'پرداخت',
        t5: 'لغو',
        t6: 'فاکتور',
        step: {
          t1: 'فرستنده',
          t2: 'گیرنده',
          t3: 'اطلاعات بسته',
          t4: 'نوع سرویس',
          t5: 'بازبینی',
        },
        sender: {
          t1: 'ثبت آدرس فرستنده',
          t2: 'سفارش انبوه',
          t3: 'انتخاب آدرس های قبلی',
          t4: 'اضافه کردن آدرس جدید',
          t5: 'ثبت اطلاعات فرستنده',
          t6: 'نام',
          t7: 'نام خانوادگی',
          t8: 'تلفن همراه',
          t9: 'پست الکترونیک',
          t10: 'نام شرکت',
          t11: 'آدرس',
          t12: 'نیاز به جمع آوری',
          t13: 'در صورت انتخاب نیاز به جمع آوری، مرسوله شما از درب محل فرستنده جمع آوری خواهد شد' +
             'درصورتی که سفارش پیش از ساعت ۸ صبح ثبت شده باشد امروز تا ساعت ۱۸ جمع آوری خواهد شد و پس از ساعت ۸ فردا (در صورت نبودن تعطیلی)تا ساعت ۱۸ جمع آوری خواهد شد.',
          t14: 'انتخاب آدرس های قبلی',
          t15: 'انتخاب آدرس',
          t16: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t17: 'اضافه کردن آدرس جدید',
          t18: 'اضافه کردن آدرس',
          t19: 'استان / شهر مبدا',
          t20: 'آدرس فرستنده',
          t21: 'آدرس بصورت متنی',
          t22: 'اضافه کردن',
          t23: 'در صورت عدم انتخاب جمع آوری مرسوله را باید در دفتر نمایندگی پستِکس و یا سرویس پستی انتخاب شده تحویل فرمایید .',
          t24: 'شهر را انتخاب کنید',
          t25: 'تلفن ثابت (به همراه کد شهر)',
          t26: 'کد ملی',
          t27: 'کد پستی',
          t28: 'شهر خود را جستجو کنید',
          t29: 'انتخاب موقعیت مکانی فرستنده',
          t30: 'سایر موارد',
          t31: 'بستن',
          t32: "انتخاب آدرس از روی نقشه (اختیاری)",
          t33: "(اختیاری)"

        },
        receiver: {
          t1: 'ثبت آدرس گیرنده',
          t2: 'سفارش انبوه',
          t3: 'انتخاب آدرس های قبلی',
          t4: 'اضافه کردن آدرس جدید',
          t5: 'ثبت اطلاعات گیرنده',
          t6: 'نام',
          t7: 'نام خانوادگی',
          t8: 'تلفن همراه',
          t9: 'پست الکترونیک',
          t10: 'نام شرکت',
          t11: 'آدرس',
          t12: 'نیاز به توزیع',
          t13: 'در صورت انتخاب نیاز به توزیع، مرسوله شما درب محل گیرنده توزیع خواهد شد',
          t14: 'انتخاب آدرس های قبلی',
          t15: 'انتخاب آدرس',
          t16: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t17: 'اضافه کردن آدرس جدید',
          t18: 'اضافه کردن آدرس',
          t19: 'استان / شهر مقصد',
          t20: 'آدرس گیرنده',
          t21: 'آدرس بصورت متنی',
          t22: 'اضافه کردن',
          t23: 'در صورت عدم انتخاب نیاز به توزیع، مرسوله در محل دفتر نمایندگی شرکت پستی تحویل گیرنده خواهد شد',
          t24: 'شهر را انتخاب کنید',
          t25: 'تلفن ثابت (به همراه کد شهر)',
          t26: 'کد ملی',
          t27: 'کد پستی',
          t28: 'شهر خود را جستجو کنید',
          t29: 'انتخاب موقعیت مکانی گیرنده'
        },
        packageInfo: {
          t1: 'اطلاعات بسته',
          t2: 'محتویات مرسوله',
          t3: 'ارزش ریالی مرسوله',
          t4: 'وزن مرسوله ( گرم )',
          t5: 'اندازه بسته پستی',
          t6: 'بسته‌بندی می‌خواهم',
          t7: ' چاپ رسید',
          t8: 'اطلاع رسانی پیامکی',
          t9: 'اطلاع رسانی پیامکی فعال شد',
          t10: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است،',
          t11: 'تایید',
          t12: ' نشان تجاری شما',
          t13: 'نوع پرداخت',
          t14: 'پرداخت هزینه ارسال-عادی',
          t15: 'پرداخت درمحل(COD)',
          t16: 'پرداخت هزینه ارسال و کالا-امنیتو',
          t17: 'ارسال رایگان',
          t18: 'پس کرایه',
          t19: 'اضافه کردن بسته',
          t20: 'بسته با موفقیت اضافه شد',
          t21: 'شما میتوانید اطلاعات بسته های خود را از قسمت جزئیات بسته ها مشاهده کنید',
          t22: 'شکستنی',
          t23: 'حاوی مایعات',
          t24: 'در صورت انتخاب نیاز به بسته بندی، مرسوله شما پس از جمع آوری و در محل انبار پستِکس، بسته بندی شده و لیبل بارنامه بروی آن نصب خواهد شد.',
          t25: 'در صورت عدم انتخاب نیاز به بسته بندی، مرسوله را با بسته بندی استاندارد به جمع آور پستِکس تحویل دهید.',
          t26: 'در صورت انتخاب نیاز به چاپ لیبل بارنامه، مرسوله شما پس از جمع آوری و در محل انبار پستِکس، لیبل شده و لیبل بارنامه بروی آن نصب خواهد شد.' +
             'در زمان تحویل مرسوله به جمع آور پستِکس شماره سفارش خود را بروی مرسوله بنویسید به نحوی که کنده یا پاک نشود.',
          t27: 'در صورت عدم انتخاب نیاز به چاپ لیبل بارنامه، لیبل را چاپ و بروی مرسوله نصب نمایید و به جمع آور پستِکس تحویل دهید.',
          t28: 'فاکتور پستی باید چاپ و روی بسته چسبانده شود',
          t29: 'در صورت انتخاب گزینه اطلاع رسانی پیامکی در تمامی مراحل ارسال، وضعیت مرسوله از طریق پیامک به گیرنده و فرستنده اطلاع رسانی خواهد شد',
          t30: 'چنانچه شما به چاپگر جهت چاپ لیبل بارنامه خود دسترسی ندارید گزینه نیاز به چاپ فاکتور را انتخاب نمایید که پس از جمع آوری بار در انبار پستِکس لیبل بروی مرسوله الصاق میشود و در زمان تحویل مرسوله به جمع آور پستِکس می‌بایستی شماره محموله را بروی مرسوله درج فرمایید',
          t31: 'شما گزینه انتخاب نیاز به چاپ فاکتور، لیبل بارنامه را چاپ و بروی بارنامه الصاق فرمایید',
          t32: 'چنانچه مرسوله شما حاوی کالای شکستنی می‌باشد گزینه شکستنی را انتخاب کنید.',
          t33: 'چنانچه مرسوله شما حاوی مایعات می‌باشد گزینه مایعات را انتخاب کنید.',
          t34: "هزینه کالا + هزینه ارسال درب محل برعهده گیرنده میباشد",
          t35: "هزینه ارسال توسط فرستنده یا گیرنده پرداخت می‌شود",
          t36: "کلیه هزینه های ارسال و ارزش کالا از گیرنده دریافت میگردد و مجموع مبلغ دریافت شده، پس از کسر هزینه های مندرج در قوانین به حساب فرستنده واریز میشود.",
          t37: "هزینه کالا و ارسال توسط گیرنده پرداخت و امانی نزد پستِکس تا دریافت کالا از فرستنده می‌ماند",
          t38: "هزینه ارسال مرسوله در زمان تحویل به گیرنده، از ایشان اخذ میگردد",
          t39: 'خدمات نمایندگی',
          t40: 'خدمات نماینده',
          t41: "ارزش ریالی مرسوله جهت تعیین سقف تعهدات",
          t42: "برای فعالسازی روش های پرداخت بیشتر درخواست فروشگاه ثبت نمایید",
          t43: "درخواست فروشگاه",
          t44: "روش های پرداخت",
        },
        serviceType: {
          t1: 'انتخاب سرویس دهنده',
          t2: 'ارزان ترین',
          t3: 'سریع ترین',
          t4: 'محبوب ترین',
          t5: 'سرویس های موجود',
          t6: 'سرویس های نا موجود',
          t7: 'نوع سرویس',
          t8: 'زمان ارسال',
          t9: 'هزینه پستی و خدمات فنی',
          t10: 'توضیحات',
          t11: 'ریال',
          t12: 'جمع آوری',
          t13: 'توزیع',
          t14: 'بیمه تا سقف',
          t15: 'انتخاب سرویس الزامی میباشد',
          t16: 'یکی از نمایندگی های زیر را انتخاب کنید',
          t17: "قیمت تقریبی",
          t18: "جمع آوری مرسوله از درب محل فرستنده",
          t19: "<p>جمع آوری  <b>امروز</b> ، سفارش تا قبل از ۱۲ ظهر<br/>" +
             "جمع آوری  <b>فردا</b> ، سفارش بعد از ۱۲ ظهر</p>",
          t20: "هزینه جمع آوری",
          t21: "مراکز نزدیک به شما جهت تحویل بسته",
          t22: "با توجه به اینکه تیک نیاز به جمع آوری توسط شما انتخاب نشده است، مسئولیت تحویل کالا بر عهده شما میباشد.",
          t23: "تغییر وضعیت",
          t24: "آدرس مراکز نزدیک به شما جهت تحویل بسته",
          t25: "برای مبدا انتخابی شما سرویسی یافت نشد",
          t26: "یکی ار مراکز روی نقشه را انتخاب کنید",
          t27: "این سرویس برای مشخصات وارد شده شما فعال نمی باشد",
          t28: "مرکز انتخابی شما",
          t29: "سرویس انتخابی شما"
        },
        review: {
          t1: 'جزئیات بسته ها',
          t2: 'بسته',
          t3: 'محتویات مرسوله',
          t4: 'تعداد بسته پستی',
          t5: 'ارزش ریالی مرسوله',
          t6: 'ریال',
          t7: 'وزن مرسوله ( گرم )',
          t8: 'گرم',
          t9: 'اندازه بسته پستی',
          t10: 'سایز',
          t11: 'چاپ فاکتور',
          t12: 'اطلاعات گیرنده',
          t13: 'نوع سرویس',
          t14: 'زمان ارسال',
          t15: 'هزینه ارسال',
          t16: 'بسته بندی',
          t17: 'چاپ لیبل',
          t18: 'درج لوگو',
          t19: 'خدمات فنی مهندسی',
          t20: 'جمع آوری درب منزل',
          t21: 'توزیع',
          t22: 'اضافه کردن سفارش جدید',
        },
        invoice: {
          t1: 'تاریخ و زمان',
          t2: 'شماره سفارش',
          t3: 'پیش فاکتور پستی و خدمات فنی ',
          t4: 'خدمات پستی',
          t5: 'ردیف',
          t6: 'شرح',
          t7: 'تعداد',
          t8: 'قیمت(ريال)',
          t9: 'جمع',
          t10: 'ريال شامل مالیات',
          t11: 'خدمات فنی و پشتیبانی',
          t12: 'پرداخت',
          t13: 'مجموع سفارش',
          t14: 'ریال',
          t15: 'پرداخت با کیف پول',
          t16: 'موجودی شما',
          t17: 'بانک ملت',
          t18: 'ثبت سفارش جدید',
          t19: 'خدمات فنی، بیمه و جمع آوری کالا از محل و...',
          t20: 'مالیات بر ارزش افزوده',

          t21: 'چاپ و الصاق فاکتور',
          t22: 'ارزش افزوده نمایندگی',
          t23: 'هزینه کارتن و لفاف',
          t24: 'کارمزد و هزینه مالی',
          t25: 'هزینه توضیع مرسوله',
          t26: 'مبلغ کالا',
          t27: 'مبلغ بیمه',
          t28: 'خدمات فنی مهندسی',
          t29: 'چاپ نماد تجاری',
          t30: 'حق ثبت الکترونیکی',
          t31: 'هزینه پیامک و رهگیری',
          t32: 'هزینه جمع آوری',
          t33: 'کد تخفیف',

        }
      },
      multiOrder: {
        t1: 'مرحله قبل',
        t2: 'مرحله بعد',
        t3: 'تکمیل سفارش',
        s1: {
          t1: 'اطلاعات فرستنده',
          t2: 'انتخاب آدرس های قبلی',
          t3: 'اضافه کردن آدرس جدید',
          t4: 'اطلاعات سرویس',
          t5: 'نوع سرویس',
          t6: 'انتخاب کنید',
          t7: 'الصاق نشان تجاری روی فاکتور',
          t8: 'پاکت / کارتن پستی',
          t9: 'اطلاع رسانی پیامکی',
          t10: 'اطلاع رسانی پیامکی فعال شد',
          t11: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است،',
          t12: 'تایید',
          t13: 'دانلود فایل اکسل',
          t14: 'آپلود فایل اکسل',
          t15: 'انتخاب آدرس',
          t16: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t17: 'اضافه کردن آدرس',
          t18: 'استان را انتخاب کنید',
          t19: 'متن آدرس',
          t20: 'آدرس بصورت متنی',
          t21: 'اضافه کردن',
          t22: 'ردیف',
          t23: 'عملیات',
          t24: 'آیا شکستنی است؟',
          t25: 'آیا حاوی مایعات است؟',
          t26: 'دریافت فایل اکسل خام، برای سفارشات پیش کرایه',
          t27: 'دریافت فایل اکسل خام، برای سفارشات پرداخت توسط گیرنده(COD)',
          t28: 'شهر خود را جستجو کنید'
        },
        s2: {
          t1: 'اطلاعات مرسوله',
          t2: 'سطر جدید',
          t3: 'مرسوله',
          t4: 'محتویات مرسوله',
          t5: 'اندازه بسته پستی',
          t6: 'انتخاب کنید',
          t7: 'طول',
          t8: 'عرض',
          t9: 'ارتفاع',
          t10: 'ارزش ریالی مرسوله',
          t11: 'وزن مرسوله ( گرم)',
          t12: 'بیمه',
          t13: 'اضافه کردن اطلاعات گیرنده',
          t14: 'اطلاعات گیرنده',
          t15: 'انتخاب آدرس گیرنده',
          t16: 'نام',
          t17: 'نام خانوادگی',
          t18: 'تلفن همراه',
          t19: 'نام شرکت',
          t20: 'آدرس',
          t21: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t22: 'استان را انتخاب کنید',
          t23: 'آدرس بصورت متنی',
          t24: 'اضافه کردن',
          t28: 'شهر خود را جستجو کنید',
          t29: "ارزش ریالی مرسوله جهت تعیین سقف تعهدات"

        }
      },
      packing: {
        t1: 'اطلاعات مرسوله',
        t2: 'محتویات مرسوله',
        t3: 'ارزش ریالی',
        t4: 'ریال',
        t5: 'وزن مرسوله',
        t6: 'گرم',
        t7: 'اندازه بسته پستی',
        t8: 'تعداد بسته پستی',
        t9: 'جزئیات سفارش فعلی',
        t10: 'گیرنده',
        t11: 'شماره تماس',
        t12: 'آدرس گیرنده',
        t13: 'نوع سرویس',
        t14: 'نیاز به جمع آوری',
        t15: 'چاپ لیبل',
        t16: 'درج لوگو',
        t17: 'ویرایش اطلاعات مرسوله',
        t18: 'محتویات مرسوله',
        t19: 'ارزش ریالی',
        t20: 'وزن مرسوله (گرم)',
        t21: 'سایز بسته بندی',
        t22: 'تعداد بسته پستی',
        t23: 'چاپ فاکتور',
        t24: 'اضافه کردن',
        t25: 'قیمت واحد',
        t26: 'ذخیره تغییرات',
        t27: 'بله',
        t28: 'خیر',
        t29: 'طول',
        t30: 'عرض',
        t31: 'ارتفاع',
      },
      sendTicket: {
        t1: 'پشتیبانی',
        t2: 'لطفا پیش از ارسال تیکت پشتیبانی، ابتدا ',
        t3: 'پرسش های متداول',
        t4: 'را مشاهده کنید',
        t5: 'موضوع تیکت',
        t6: 'موضوع را انتخاب کنید',
        t7: 'نام و نام خانوادگی',
        t8: 'تلفن تماس یا ایمیل',
        t9: 'کد سفارش',
        t10: 'کد پیگیری',
        t11: 'اولویت',
        t12: 'متن پیام',
        t13: 'نوع کالا',
        t14: 'نوع کالا را انتخاب کنید',
        t15: 'کالای نو',
        t16: 'کالای دسته دو',
        t17: 'نام کالا',
        t18: 'قیمت خرید',
        t19: 'نام برند کالا',
        t20: 'شماره شبا',
        t21: 'توضیحات',
        t22: 'تلفن ثابت (به همراه کد شهر)',
        t23: 'کد پستی',
        t24: 'کد ملی',
        t25: 'شماره سریال کارت ملی',
        t26: 'تاریخ تولد',
        t27: 'شماره حساب',
        t28: 'نام شعبه بانک',
        t29: 'استان - شهرستان',
        t30: 'آدرس',
        t31: 'انتخاب تصویر',
        t32: 'حداکثر 3 تصویر JPEG، حداکثر 1 مگابایت',
        t33: 'ثبت و ارسال',
        t34: 'درخواست خسارت',
        t35: 'درخواست پس کرایه',
        t36: 'سایر',
        t37: 'نام بخش',
        t38: 'نوع تیکت',
      },
      listTicker: {
        t1: 'لیست تیکت های من',
        t2: 'همه تیکت ها',
        t3: 'در نوبت ارسال به پشتیبانی',
        t4: 'پاسخ داده شده',
        t5: 'متن پیام',
        t6: 'پاسخ پشتیبانی',
        t7: 'بستن',
        t8: 'پاسخ به پشتیبانی',
        t9: 'ثبت و ارسال',
      },
      faq: {
        t1: 'سوالات متداول',
        t2: 'جستجوی کلمه مورد نظر...',
        t3: 'هزینه و سرویس ها',
        t4: 'زمانبندی ارسال',
        t5: 'غرامت و خسارت پستی و مالی',
        t6: 'ممنوعات پستی',
        t7: 'محدودیتهای ارسال',
        t8: 'سوالات اخذ نمایندگی',

        t9: 'آیا میتوانم از خدمات پسکرایه یا پرداخت در محل استفاده کنم؟',
        t10: 'شما میتوانید با پرداخت هزینه سالیانه ای از خدمات پسکرایه٬ ارسال رایگان و پرداخت در محل ( cod ) پلتفرم پستِکس استفاده نمایید جهت ثبت درخواست خود با مراجعه به لینک پسکرایه در پستِکس درخواست خود را ثبت نمایید و از پیش نیازهای درخواست خود مطلع گردید. لازم به ذکر است هزینه خدمات مالی برای استفاده از خدمات ارسال رایگان و پرداخت در محل ( cod ) معادل ۱ الی ۳ درصد ارزش کالا میباشد.\n' +
           'ارجاع به صفحه پسکرایه\n',
        t11: 'از کجا به کجا میتوانم بار ارسال کنم یا شهرهای تحت پوشش پستِکس کجاست؟',
        t12: 'مطالعه این صفحه',
        t13: 'قوانین استفاده از خدمات پستِکس چیست؟',
        t14: 'مطالعه این صفحه',
        t15: 'آیا پستِکس پست خارجی نیز دارد؟',
        t16: 'بله جهت استعلام آنلاین قیمت پستی به صفحه ذیل مراجعه کنید',
        t17: 'چطور میتوانم تخفیف بگیرم؟',
        t18: 'سامانه هوشمند پستِکس با محاسبه ماهیانه تعداد مرسولات شما اقدام به ارایه تخفیف مینماید ولی چنانچه نیاز به مذاکره بیشتر دارید میتوانبد با مراجعه به لینک زیر تیکت خود را ثبت نمایید',
        t19: 'فروشگاه اینترنتی دارم شرایط همکاری با پستِکس به چیست؟',
        t20: 'شما با ثبت نام در سایت پستِکس و در صورت داشتن کالای استاندارد٬ غیر قاچاق و ممنوعه نبودن میتوانید از خدمات پستِکس بصورت پیشکرایه٬ پسکرایه٬ ارسال رایگان و پرداخت در محل ( cod) استفاده نمایید.',
        t21: 'مرسوله ام بسته بندی نشده و چطور میتونم از شما خدمات دریافت کنم؟',
        t22: 'مشتری گرامی چنانچه در شهری که شما در حال ثبت سفارش هستید پستِکس دارای نماینده انبارش میباشد شما میتوانید در زمان ثبت سفارش گزینه نیاز به بسته بندی یا دسترسی به پرینت ندارم را انتخاب نمایید که پس از جمع آوری مرسوله توسط نماینده پستِکس در محل انبار نماینده پستِکس بار پسته بندی و لیبل بارکد خواهد شد لذدا توجه داشته باشید نماینده امکان بسته بندی در محل شما را نخواهد داشت.',
        t23: 'ثبت سفارش تلفنی هم دارین و از طریق سایت ممکنه راهنمایی کنید به چه صورت هست ؟',
        t24: 'متاسفانه در پستِکس امکان ثبت سفارش تلفنی مقدور نمیباشد و لذا شما با مراجعه به لینک ذیل و پس از ثبت نام میتوانید ثبت سفارش بنمایید',
        t25: 'آیا پستِکس جمع آوری نیز دارد؟',
        t26: 'مشتری گرامی در تمامی نقاطی که پستِکس نمایندگی دارد پستِکس در صورت درخواست شما امکان جمع آوری دارد و در صورتی که نمایندگی نداشته باشد شما میتوانید پس از ثبت در پستِکس که شامل تخفیف خواهد بود بار را شخصا به شرکت پستی تحویل بدهید.',
        t27: 'هزینه ارسال مرسوله من چقدر خواهد بود؟',
        t28: 'مشتری گرامی با مراجعه به لینک زیر میتوانید هزینه سرویس های متنوع پستی را با یکدیگر مقایسه بنمایید',

        t29: 'بارم من کجاست؟',
        t30: 'مشتری گرامی سرویس های متنوع پستی دارای زمانبندی متنوعی میباشد که شرح ذیل میباشد:\n' +
           'سرویس پستبار اکسپرس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس پست پیشتاز درون استانی  ۴ الی ۶ ساعت\n' +
           'سرویس پست پیشتاز بین استانی  ۷ الی ۹ ساعت\n' +
           'سرویس ماهکس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس چاپار ۳۶ الی ۷۲ ساعت\n' +
           'سرویس چاپار اکسپرس ۳۶ الی ۴۸ ساعت\n' +
           'سرویس اسکای پست ۲۴ الی ۴۸ ساعت\n' +
           'سرویس کالارسان ۳۶ الی ۴۸ ساعت\n' +
           'سرویس درون شهری پیک هاب ۱۸ الی ۲۴ ساعت\n' +
           'توجه داشته باشید تمام زمانبدی های فوق روز و ساعت کاری است و محاسبه مشمول ایام تعطیل نمیباشد و از زمان تحویل مرسوله به نماینده پستِکس محاسبه میگردد. \n' +
           '\n' +
           'لذا چنانچه از روند ارسال مرسوله میخواهید با خبر شوید به لینک رهگیری مراجعه فرمایید\n',
        t31: 'مرسوله من جمع آوری نشده چه زمانی مرسوله من جمع آوری خواهد شد؟',
        t32: 'اگر قبل از ساعت ۸ صبح امروز ثبت کردید تا ساعت ۱۹ جمع میشود و اگر بعد از ساعت ۸ ثبت کردید فردا تا ۱۹ جمع میگردد. چنانچه از نتیجه رهگیری راضی نیستید لطفا در تیکیت اعلام فرمایید تا همکاران ما در پستِکس رسیدگی بنمایند\n' +
           ' اگر قبل از ۸ صبح امروز ثبت  سفارش نمودید و تا ساعت ۱۹ امروز بار شما جمع آوری نگردیده  است لطفا با مراجعه به لینک زیر تیکت خود را اعلام فرمایید.\n',
        t33: 'چند بسته باهم برام ارسال کردن اما بسته ها کامل به دستم نرسیدند؟',
        t34: 'مشتری گرامی توجه داشته باشید لزوما اگر چند مرسوله از یک مبدا و در یک روز برای شما ارسال شده حتما همگی در یک روز به دست شما نخواهد رسید زیرا ممکن است در ماشین هاتی متفاوتی جهت ارسال بارگیری شده باشد لذا بر اساس زمان مکشخص شده در زمان ثبت سفارش برای تحویل منتظر وصول مرسوله باشید و اگر چنانچه بیش از زمان مقرر بود از طریق تیکت پشتیبانی با ما در ارتباط باشید.',
        t35: 'حرکت مرسوله من چندین روز است که متوقف شده و هیچ روندی نداره چطوری پیگیری کنم ؟',
        t36: 'مشتری گرامی لطفا به لینک تیکت مراجعه نمایید و با ثبت شماره بارنامه خود منتظر تماس همکاران ما در پستِکس باشید',
        t37: 'بار یا بسته من چه زمانی خواهد رسید؟',
        t38: 'مشتری گرامی سرویس های متنوع پستی دارای زمانبندی متنوعی میباشد که شرح ذیل میباشد:\n' +
           'سرویس پستبار اکسپرس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس پست پیشتاز درون استانی  ۴ الی ۶ ساعت\n' +
           'سرویس پست پیشتاز بین استانی  ۷ الی ۹ ساعت\n' +
           'سرویس ماهکس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس چاپار ۳۶ الی ۷۲ ساعت\n' +
           'سرویس چاپار اکسپرس ۳۶ الی ۴۸ ساعت\n' +
           'سرویس اسکای پست ۲۴ الی ۴۸ ساعت\n' +
           'سرویس کالارسان ۳۶ الی ۴۸ ساعت\n' +
           'سرویس درون شهری پیک هاب ۱۸ الی ۲۴ ساعت\n' +
           'توجه داشته باشید تمام زمانبدی های فوق روز و ساعت کاری است و محاسبه مشمول ایام تعطیل نمیباشد و از زمان تحویل مرسوله به نماینده پستِکس محاسبه میگردد. \n',
        t39: 'مرسوله من باجه معطله است چه باید بکنم؟',
        t40: 'چنانچه رهگیری مرسوله شما را در باجه معطله نشان بدهد میتوانید با مراجعه به باجه معطله شرکت پستی شهر خود تا ۵ روز مرسوله را تحویل بگیرید و چنانچه رهگیری دو بار مراجعه پستچی را نشان دهد و در همان روز قرار داشته باشید میتوانید با مراجعه به شرکت پستی مرسوله را تحویل بگیرید.',

        t41: 'مرسوله ای که به دستم رسیده آسیب دیده برای دریافت غرامت چه بکنم؟',
        t42: 'مسئولیت تضمین غرامت مرسولات پستی تا درب محل گیرنده میباشد لذا اگر مرسوله را تحویل گرفته باشید شامل هیچ نوع تضمین خسارتی نیست زیرا شما این فرصت را دارید تا در زمان تحویل مرسوله از پستچی بخواهید اجازه بدهد تا محتوای مرسوله را از جهت سلامت یا مطابقت با سفارش٬ کنترل نمایید.\n' +
           'حال اگر چنانچه موفق به انجام این امر نگردید و مرسوله شما از طرق شرکت ملی پست ارسال شده یود و چنانچه حداکثر ۲۴ ساعت از زمان تحویل گذشته باشد با مراجعه به سامانه غرامات پستی شانس خود را برای دریافت غرامت امتحان نمایید.\n' +
           'چنانچه مرسوله شما جز ممنوعات پستی باشد ما هیچگونه خدمتی برای پیگیری حرسوله ارايه نمیکنیم( لینک ممنوعات پستی)\n' +
           '\n' +
           'چنانچه از نتیجه رهگیری راضی نیستید لطفا در تیکیت اعلام فرمایید تا همکاران ما در پستِکس رسیدگی بنمایند\n',
        t43: 'چرا وجه کالای من که مقصد رسیده تسویه نگردیده است؟',
        t44: 'مشتری گرامی اصولا وضعیت توزیع به منزله تسویه حساب ارزش مرسوله نمیباشد و در صورت مشاهد وضعیت تایید یا تسویه مالی پس از ۴۸ ساعت وجه شما پرداخت میگردد.\n' +
           '\n' +
           'چنانچه از نتیجه پاسخ راضی نیستید و بیش از ۴۸ ساعت از تغییر وضعیت به حالت تایید و تسویه مالی میگذرد لطفا در تیکیت اعلام فرمایید تا همکاران ما در پستِکس رسیدگی بنمایند\n',
        t45: 'من در خواست کنسلی مرسوله رو کردم ولی وجه من واریز نشده یا کمتر واریز شده است',
        t46: 'مشتری گرامی اگر چنانچه قبل از مراجعه جمع آور٬ درخواست لغو سفارش  داشته باشید عودت وجه بدون کسر هیچگونه وجه پس از ۴۸ ساعت مرسوله به شما پرداخت میگردد\n' +
           ' اما چنانچه پس اعزام جمع آور درخواستی کنسلی سفارش را داشته باشید پس از کسر هزینه های جمع آوری الباقی مبلغ عودت خواهد شد\n' +
           'حال اگر چنانچه پس از جمع آوری کامل درخواستی کنسلی سفارش ار داشته باشید هیچگونه وجهی عودت نخواهد شد و جهت عودت مرسوله به مبدا ۵۰ هزار تومان هزینه از شما اخذ خواهد شد. لطفا جهت کنسلی سفارش با مراجعه به لینک زیر درخواست خود را ثبت نمایید.\n',
        t47: 'ثبت سفارش تلفنی هم دارین و از طریق سایت ممکنه راهنمایی کنید به چه صورت هست ؟ ',
        t48: 'متاسفانه در پستِکس امکان ثبت سفارش تلفنی مقدور نمیباشد و لذا شما با مراجعه به لینک ذیل و پس از ثبت نام میتوانید ثبت سفارش بنمایید.',
        t49: 'آدرس و اطلاعات به اشتباه ثبت شده و مرسوله من ارسال شده ممکنه راهنمایی کنید ؟',
        t50: 'چنانچه آدرسی را در پستِکس ثبت کرده باشید پس از دریافت بارکد امکان تغییر آدرس وجود ندارد.',
        t51: 'مرسوله ام بسته بندی نشده و چطور میتونم از شما خدمات دریافت کنم؟',
        t52: 'مشتری گرامی چنانچه در شهری که شما در حال ثبت سفارش هستید پستِکس دارای نماینده انبارش میباشد شما میتوانید در زمان ثبت سفارش گزینه نیاز به بسته بندی یا دسترسی به پرینت ندارم را انتخاب نمایید که پس از جمع آوری مرسوله توسط نماینده پستِکس در محل انبار نماینده پستِکس بار پسته بندی و لیبل بارکد خواهد شد لذدا توجه داشته باشید نماینده امکان بسته بندی در محل شما را نخواهد داشت.\n' +
           '\n' +
           'در عین حال توجه داشته باشید در صورت نیاز به سرویس بسته بندی در زمان تحویل مرسوله میبایستی بروی بسته شماره بارکد و سفارش خود را به نحوی بنویسید که تا پایان ارسیال پاک نشود.\n',
        t53: 'چطور میتوانم تخفیف بگیرم؟',
        t54: 'سامانه هوشمند پستِکس با محاسبه ماهیانه تعداد مرسولات شما اقدام به ارایه تخفیف مینماید ولی چنانچه نیاز به مذاکره بیشتر دارید میتوانبد با مراجعه به لینک زیر تیکت خود را ثبت نمایید',
        t55: 'وقتی کدرهگیری رو چک میکنم زده بسته تحویل گیرنده شده اما بنده که گیرنده هستم بسته ای رو تحویل نگرفت!  چه باید بکنم؟',
        t56: 'مشتری گرامی لطفا به لینک تیکت مراجعه نمایید و با ثبت شماره بارنامه خود منتظر تماس همکاران ما در پستِکس باشید',

        t57: ' آیا طلا یا نقره میتوانم ارسال کنم؟',
        t58: 'شما امکان ارسال طلا و نقره از طریق شرکتهای پستی ندارید زیرا این دست مرسولات جز ممنوعات پستی است و مسئولیت ارسال این دست مرسولات به عهده فرستنده میباشد و شامل هیچ تضمین غرامتی نیست.',
        t59: 'آیا چک یا پول نقد یا اسناد اداری میتوانم ارسال کنم؟',
        t60: 'شما امکان ارسال چک یا پول نقد یا اسناد اداری از طریق شرکتهای پستی ندارید زیرا این دست مرسولات جز ممنوعات پستی و مسئولیت ارسال این دست مرسولات به عهده فرستنده میباشد و شامل هیچ تضمین غرامتی نمی باشد.',
        t61: 'ممنوعات پستی چیست؟',
        t62: '-',

        t63: ' آیا بار شکستنی یا مایعات می توانم ارسال کنم؟',
        t64: 'شما در صورتی مایعات و شکستنی میتوانید ارسال نمایید که در زمان ثبت سفارش٬ گزینه شکستنی یا مایعات را انتخاب کرده و حتما از بسته بندی مناسب برای این امر استفاده نمایید در غیر اینصورت مسئولیت بار به عهده شماست.',
        t65: 'حداکثر وزنی که میتوانم ارسال کنم چیست؟',
        t66: 'حداکثر وزن در سرویس های پست معادل ۳۰ کیلوگرم است\n' +
           'حداکثر وزن در سرویس های ماهکس معادل ۳۰ کیلوگرم است\n' +
           'حداکثر وزن در سرویس های چاپار معادل ۳۵ کیلوگرم است\n' +
           'حداکثر وزن در اسکای پست معادل ۵۰ کیلوگرم است\n' +
           'حداکثر وزن در کالارسان معادل ۵۰ کیلوگرم است\n' +
           'حداکثر وزن در پودو معادل ۵۰ کیلوگرم است\n' +
           'حداکثر وزن در پیک هاب معادل ۵۰ کیلوگرم است\n',
        t67: 'حداکثر سایزی که میتونم ارسال چقدر است؟',
        t68: '-',
        t69: 'من نمیدانم سایز مرسوله من چند است؟',
        t70: 'مشتری محترم لطفا با مراجعه به لینک زیر با سایز بسته های پستی آسنا شوید و در زمان انتخاب سایز مرسوله٬ انتخاب درستی را به انجام برسانید',
        t71: 'آدرس و اطلاعات به اشتباه ثبت شده و مرسوله من ارسال شده ممکنه راهنمایی کنید ؟',
        t72: 'چنانچه آدرسی را در پستِکس ثبت کرده باشید پس از دریافت بارکد امکان تغییر آدرس وجود ندارد.',


        t73: 'چطور نمایندگی پستِکس را بگیرم؟',
        t74: 'شما میتوانید به مراجعه به لینک اخذ نمایندگی در پستِکس درخواست خود را ثبت نمایید و از پیش نیازهای درخواست خود مطلع گردید',
        t75: 'در آمد نمایندگی چگونه است؟',
        t76: 'پاسخ این سوال دقیقا در میزان تلاش منطقه ای نماینده برای جذب مرسولات پستی از همان منطقه مستتر میباشد بدین معنی که شما با اخذ نمایندگی پستِکس به انواع سرویس های پستی دسترسی دارید و بازاریابی از آن منطقه میتوانید میزان درآمد خود را تضمین بفرمایید.\n' +
           'ارجاع به صفحه اخذ نمایندگی در پستِکس\n',

        t77: 'اگر جواب سوالتون رو پیدا نکرده اید\n' +
           'با پشتیبانی ارتباط بگیرید.',
        t78: 'تیم پشتیبانی پستِکس، در اسرع وقت پاسخگو شما\n' +
           'خواهد بود و جواب شما را میدهد.',
        t79: 'ارتباط با پشتیبانی',
        t80: 'لینک صفحه'
      },
      profile: {
        t1: 'تنظیمات حساب کاربری',
        t2: 'نام',
        t3: 'نام خانوادگی',
        t4: 'تلفن همراه',
        t5: 'برای ویرایش شماره تلفن با پشتیبانی تماس بگیرید',
        t6: 'کد معرف',
        t7: 'تغییر کلمه عبور',
        t8: 'کلمه عبور فعلی',
        t9: 'کلمه عبور جدید',
        t10: 'تکرار کلمه عبور',
        t11: 'ذخیره',
        t12: 'دریافت کد',
        t13: 'تغییر گذرواژه',
        t14: 'کد یکبار مصرف',
        t15: 'شماره کارت',
        t16: 'شماره شبا',
        t17: 'کد ملی'
      },
      myPackage: {
        t1: 'مرسوله من',
        t2: 'شماره سفارش',
        t3: 'نام فرستنده',
        t4: 'آدرس گیرنده',
        t5: 'نوع سرویس',
        t6: 'زمان باقی مانده',
        t7: 'تاریخچه مرسوله',
        t8: 'دریافت شده',
        t9: 'تحویل انبار',
        t10: 'تحویل پیک',
        t11: 'تحویل مرسوله',
      },
      map: {
        t1: 'جستجو...'
      },
      error: {
        t1: 'ابتدا وارد شوید',
        t2: 'موردی یافت نشد',
        t3: "با توجه به موارد وارد شده از جمله سایز یا ارزش ریالی سرویسی در دسترس نیست لطفا به مرحله قبل برگردید و موارد را تغییر دهید",
        t4: "وارد کردن نام الزامی میباشد",
        t5: "وارد کردن نام خانوادگی الزامی میباشد",
        t6: "وارد کردن شماره موبایل الزامی میباشد",
        t7: "شماره موبایل وارد شده نامعتبر میباشد",
        t8: "وارد کردن آدرس الزامی میباشد",
        t9: "آدرس شما صحیح نمیباشد",
        t10: "آدرس شما نباید بیشتر از 150 کارکتر باشد",
        t11: "نام شما نباید بیشتر از 50 کارکتر باشد",
        t12: "نام خانوادگی شما نباید بیشتر از 50 کارکتر باشد",
        t13: "آدرس  شما فاقد موقعیت مکانی میباشد",
        t14: "کدپستی وارد شده نامعتبر میباشد",
        t15: "شماره موبایل وارد شده نامعتبر میباشد",
        t16: "شماره تلفن وارد شده نامعتبر میباشد",
        t17: "ایمیل وارد شده نامعتبر میباشد",
        t18: "نام شرکت نباید بیشتر از 50 کارکتر باشد",
        t19: "شماره موبایل فرستنده با شماره موبایل گیرنده نباید یکی باشد",
        t20: "انتخاب شهر و استان فرستنده الزامی میباشد",
        t21: "انتخاب شهر و استان گیرنده الزامی میباشد",
        t22: "وارد کردن اندازه بسته پستی الزامی میباشد",
        t23: "وارد کردن وزن مرسوله الزامی میباشد",
        t24: "وزن مرسوله نباید کمتراز 50 گرم باشد",
        t25: "وارد کردن ارزش ریالی مرسوله الزامی میباشد",
        t26: "وارد کردن محتویات مرسوله الزامی میباشد",
        t27: "انتخاب نوع پرداخت الزامی میباشد",
        t28: "انتخاب کشور گیرنده الزامی میباشد",
        t29: "انتخاب یا وارد کردن مبلغ الزامی میباشد",
        t30: "یک درگاه را انتخاب کنید",
        t31: "وارد کردن کد ملی الزامی میباشد",
        t32: "وارد کردن گذرواژه الزامی میباشد",
        t33: "گذرواژه خود را مجدد وارد کنید",
        t34: "گذرواژه ها باید یکسان باشند",
        t35: "وارد کردن کد یکبارمصرف الزامی میباشد",
        t36: "وارد کردن موضوع الزامی میباشد",
        t37: "وارد کردن اولویت الزامی میباشد",
        t38: "وارد کردن نام بخش الزامی میباشد",
        t39: "وارد کردن نوع تیکت الزامی میباشد",
        t40: "وارد کردن کد سفارش الزامی میباشد",
        t41: "وارد کردن کد پیگیری الزامی میباشد",
        t42: "وارد کردن متن پیام الزامی میباشد",
        t43: "وارد کردن شماره شبا الزامی میباشد",
        t44: "وارد کردن مبلغ الزامی میباشد",
        t45: "فایل انتخاب شده باید کمتر از 2 مگابایت باشد",
      },
      autoComplete: {
        t1: 'موردی یافت نشد'
      },
      rules: {
        t1: 'قوانین پستِکس',
        t2: 'زمان بندی جمع آوری سفارش هایی که درخواست آنها از 8 صبح تا ساعت 8 صبح روز بعد باشد تا ساعت 19 جمع آوری می گردد و در شرایط فورس ماژور بدون هیچگونه اعتراض با 24 ساعت تاخیر جمع آوری انجام می گیرد',
        s1: {
          t1: 'قوانین اجرایی',
          t2: 'تعهد می نمایم که  وزن و محتوای بسته را بدرستی  به دقت و صداقت اعلام نمایم.اگر  چنانچه وزن اعلام شده مغایر با وزن واقعی باشد (که این مورد در واحد تجزیه و مبادلات مشخص می گردد)، سفارش کنسل خواهد شد و مسئولیت تاخیر در ارسال، هزینه سفارش مجدد و یا هرگونه خسارت ناشی از این امر به عهده اینجانب خواهد بود',
          t3: 'تعهد می نمایم که آدرس گیرنده را  در سیستم به درستی اعلام نمایم تا موجب برگشتی سفارش و یا هزینه های نگهداری در باجه معطله نگردد',
          t4: 'تعهد می نمایم هماهنگی لازم را با گیرنده برای اخذ مرسوله ای که در باجه معطله می باشد  بنمایم',
          t5: 'تعهد می نمایم آدرس فرستنده اعم از استان، شهر و منطقه را صحیح انتخاب نمایم و چنانچه این امر به درستی صورت نگیرد مسئولیت ناشی از تاخیر در جمع آوری و یا کنسلی سفارش به عهده اینجانب خواهد بود',
          t6: 'تعهد می نمایم از شنبه تا پنجشنبه، جهت تحویل مرسوله به جمع آور تا ساعت 19 در محل اظهار شده ثبت سفارش (آدرس فرستنده) حضور داشته باشم و در صورت عدم حضور، این امر به منزله لغو سفارش است و هیچ مبلغی از بابت سفارش لغو شده  مسترد نخواهد شد و همچنین تعهد می نمایم هیچ گونه ادعایی در این خصوص نخواهم داشت. همچنین در شرایط آب و هوایی بارانی یا برفی و یا مناطق گرمسیر (درجه حرارت بالای ۴۵ درجه) و مناطق سرد سیر (درجه حرارت زیر صفر درجه) این امکان وجود دارد که فرایند جمع آوری با تاخیر انجام پذیرد',
          t7: 'مجددا اعلام میدارم که قبول دارم کلیه سفارشات ثبت شده در روزجمعه و ایام تعطیل در اولین روز کاری بعد از ثبت سفارش  جمع آوری خواهد شد و در این خصوص هیچ اعتراضی نخواهم داشت',
          t8: 'تعهد می نمایم هر گونه شکایت در خصوص خسارت وارده به هر مرسوله ای  را صرفا ظرف 24ساعت پس از سفارش از و عدم پذیرش آن مرسوله اعلام دارم و در غیر این صورت هیچ گونه اعتراضی نخواهم داشت  ضمنا تعهد بیمه مرسوله تا لحظه تحویل آن به گیرنده اعتبار خواهد داشت',
          t9: 'تعهد می نمایم که کالای فاسد شدنی ، ممنوعات پستی و قاچاق، وزن بیش از 30کیلو، مایعات و ابعاد بیش  از 1 متر  در مرسوله پستی قرار ندهم و مندرجات بند ممنوعات پستی رارعایت نمایم',
          t10: 'تعهد می نمایم که کالای شکستنی  ارسال ننمایم مگر آنکه کلیه ضوابط بسته بندی را رعایت نموده باشم، که در صورت عدم رعایت ضابطه فوق و بروز خسارت، هیچ اعتراضی نخواهم داشت و مسئولیت محتوای کلیه کالاهای مندرج در بسته به عهده اینجانب می باشد، همچنین شرکت هیچ گونه مسئولیتی در قبال اطلاع رسانی بسته بندی مرسوله ندارد و در صورت ارسال مرسوله با هرنوع بسته بندی تبعات آن به عهده فرستنده می باشد',
          t11: 'تعهد می نمایم فایلPDF  سفارش خود را که حاوی کد رهگیری می باشد  را پرینت و بر روی  بسته الصاق نمایم وحتما آنرا امضا کنم و سپس  نسخه دیگر را به امضای جمع آور برسانم و به عنوان رسید نزد خود نگهدارم.. ضمنا کلیه قوانین پستی را در خصوص محتوای بسته پستی رعایت نمایم و اگر خلاف این امر را انجام دهم کلیه مسئولیت های ناشی از خسارت و غیره به عهده اینجانب می باشد و اگر چنانچه به پرینتر دسترسی نداشته باشم، آدرس فرستنده، گیرنده و شماره سفارش را بر روی بسته بندی مرسوله با ماژیک درج بنمایم',
          t12: 'تعهد می نمایم کلمه کاربری و رمز عبورم فرد دیگری استفاده نخواهد کرد که در غیر این صورت کلیه مسئولیت ها و تعهدات مندرج در بند های این تعهدنامه  به عهده اینجانب خواهد بود',
          t13: 'تعهد می نمایم کلیه موارد لازم در مورد بسته بندی صحیح و عدل بندی را با هزینه خودم انجام دهم تا بسته در زمان حمل پاره نشود و چنانچه مرسوله ام به بسته بندی مجدد نیاز داشت هزینه آن را طبق نظرکارشناس بپردازم یا مبلغ بسته بندی از حساب کیف پول اینجانب  اتوماتیک کسر گردد',
          t14: 'روند کاری سامانه  بدین گونه است که سفارش هایی که تا قبل از ساعت 12  در پیش کرایه و ساعت7 در پس کرایه و COD  ثبت می گردند همان روز به فعال پستی یا کالارسان، جهت جمع آوری ارجاع  و تا ساعت 18 جمع آوری از محل ثبت شده برای فرستنده جمع آوری گردد که اینجانب تعهد می نمایم در صورت 24 ساعت تاخیر در جمع آوری حق هرگونه اعتراض نسبت به جمع آوری کالا را از خود سلب نموده ام',
          t15: 'متعهد و مطلع هستم که جمع آوری بارها، از درب منزل یا محل کار انجام می شود و روند دریافت آن به گونه ای است که بار باید  به جمع آور  محترم، در محل درب ورودی ساختمان تحویل داده شود و در صورت نیاز به رویت محتویات مرسوله امکان \n' +
             '\n' +
             'بازدید آن فراهم گردد',
          t16: 'تعهد مینمایم چنانچه از درج  امضا در بخش امضای مشتری  در فاکتور خودداری نمایم (که بصورت اتوماتیک پس از ثبت سفارش دانلود و در اختیارم قرار گرفت) حق هرگونه اعتراضی را نسبت به دریافت غرامت ناشی از خسارت یا فقدان مرسوله را از خود سلب می نمایم. این موارد یکبار دیگر در زمان پرداخت مبلغ هزینه ارسال بصورت الکترونیک به تایید اینجانب رسیده است (در زمان پرداخت، تایید نمودم که قوانین را خواندم و قبول دارم)',
          t17: 'تعهد می نمایم اگر شرکت پستی به هر علتی از حمل بسته اینجانب خودداری کرد حق هر گونه اعتراضی را از خود سلب می نمایم و اجازه شکایت در این خصوص را نخواهم داشت.',
          t18: 'جهت اطلاع از روند پرداخت حق مقر نیز به بخش دستورالعمل مندرج در سایت مراجعه نمایید ',
          t19: 'در صورتی که از یک بارکد نامعتبر(کنسل شده) یا بارکدی که قبلا مرسوله آن رهسپاری شده استفاده کنید. شامل جریمه نقدی تا 5 برار هزینه بارکد استفاده شده خواهید شد',
          t20: 'مرسوله جمع آوری شده تحت هیچ شراطی عودت داده نخواهد شد مگر اینکه مشکل قانونی داشته باشد',
        },
        s2: {
          t1: 'قوانین مالی',
          t2: 'کنسلی سفارش',
          t3: 'می پذیرم در صورت ثبت سفارش از طریق پستِکس، چنانچه درخواست کنسلی سفارش را داشته باشم هیچ مبلغی عودت داده نخواهد شد',
          t4: 'می پذیرم چنانچه در زمان تحویل مرسولات، بسته ای تحویل داده نشود، به منزله کنسل شدن مرسوله می باشد',
          t5: 'تعهد می نمایم و می پذیرم چنانچه مرسوله از سامانه غیرپستی باشد، تا قبل از جمع آوری قابل کنسل کردن بوده و چنانچه برای جمع آوری مراجعه شود یا اینکه جمع آوری انجام شود برای کنسلی هیچ وجهی مسترد نخواهد شد.',
          t6: 'مدت زمان ارسال بسته طبق SLA  مندرج در توضیحات هر فعال پستی قید گردیده. بارهایی که مدت زمان ارسال  بیش از زمان مندرج در جدول SLA ارسال و تحویل شوند مشمول غرامت  تاخیر در ارسال خواهند شد که می بایستی از طریق eop.post.ir  ثبت گردد',
          t7: 'برای استفاده از سرویس پس کرایه یا COD مبلغ 1،500،000 ريال داخل کیف پول بلوکه خواهد شد. درصورت  درخواست کنسل کردن حساب پس کرایه، چنانچه تعداد سفارش های پس کرایه ثبت شده زیر10 سفارش باشد مبلغ عودت و در صورت ثبت سفارش بالای 10 تا، مبلغ عودت نخواهد شد و از مبلغ بلوکه شده می توان به جای هزینه سفارش پیش کرایه استفاده کرد',
          t8: 'مشتری گرامی چنانچه درخواست بازگشت کیف پول را داشته باشید این امر با ارسال تیکت و درخواست بازگشت کیف پول امکان پذیر میباشد ۷۲ ساعت پس از ارسال تیکت و اعلام شماره شبا مبلغ باقیمانده کیف پول شما عودت داده خواهد شد',
        },
        s3: {
          t1: 'تعهدات بیمه ای',
          t2: 'کلیه مرسولات تا درب محل گیرنده دارای بیمه می باشد و پس از تحویل به گیرنده و دریافت امضای گیرنده، هیچ گونه غرامتی پرداخت نخواهد شد  لذا گیرنده بایستی از دریافت مرسوله آسیب دیده خودداری نماید',
          t3: 'شرکت تنها در صورتی غرامت خسارت مرسوله را پرداخت می نماید که خود، کالا را بسته بندی نموده باشد. همچنین بیمه انتخاب شده متضامن کالاهایی که دارای بسته بندی استاندارد نمی باشند، نخواهد بود.',
          t4: 'مشتریانی که بیش از ۲ بار در ۱۰۰ مرسوله درخواست خسارت نمایند هیچگونه خسارتی حتی با رعایت شروط فوق پرداخت نخواهد شد',
          t5: 'در صورت دست دوم بودن کالا، قیمت کالای نو مشابه پس از برآورد  معادل 50% قیمت کالای نو تا سقف بیمه درخواست شده پرداخت میشود.',
          t6: 'در زمان درخواست غرامت برای مرسولات ثبت شده با سرویس ، می بایستی  مشخصات کارت ملی متقاضی غرامت (تصویر کارت ملی)، آدرس و شماره حساب در بخش مشخصات متقاضی غرامت   در لینک eop.post.ir درج گردد',
        }
      },
      paymentStatus: {
        t1: 'پرداخت شما با موفقیت انجام شد',
        t2: 'پرداخت شما ناموفق بود',
        t3: 'مبلغ کل',
        t4: 'ریال',
        t5: 'کد سفارش',
        t6: 'کد رهگیری',
        t7: 'تاریخ سفارش',
        t8: 'اضافه کردن سفارش جدید',
        t9: 'برگشت به صفحه اصلی',
        t10: 'بازگشت به صفحه سفارشات',
        t11: 'پرینت فاکتور',
        t12: 'نظرسنجی سامانه',
        t13: 'بازگشت به چت دیوار',
      },
      about: {
        t1: 'با پستِکس آسون بفرست!',
        t2: 'پستِکس، اولین سامانه جامع خدمات حمل و نقل در کشور.',
        t3: 'این سامانه با بهره گیری از انواع خدمات پستی داخلی و خارجی اکسپرس بصورت درب تا درب و با قیمت هایی ویژه خدمات بی نظیری را \n' +
           'به مشتریان خود ارائه می نماید. از دیگر نکات بارز و حائز اهمیت این سامانه استفاده از سیستم های پشتیبانی قوی و عالیست بطوری که \n' +
           'مشتریان آن بصورت 24 ساعته از خدمات پشتیبانی بهره مند می باشند.',
        t4: 'سرویس های پستِکس',
        t5: 'در سامانه پستِکس صاحبان مشاغل و صنایع قادر خواهند بود با استفاده از همکاری فعالین پستی اعم از سرویس های متنوع اپراتور اول پست\n' +
           ' سرویس چاپار، اسنپ باکس، DPE، DTS، TPG، تعارف، از سرویس متنوع پست شهری و بین شهری در داخل کشــور و پســــت خارجی با \n' +
           'استفاده از سرویس شرکتDPE و TPG و در بخش حمل و نقل سنگین سرویس سامانه اوبار و با امکان مقایسه قیمـــت،سرعت و کیفـــیت \n' +
           'استفاده نمایند.',
        t6: 'خدمات درب تا درب و تولید بارکد',
        t7: 'از نکات برجسته سامانه پستِکس به امکان استفاده از تمامی سرویس ها بصورت درب تا درب و دریافت بارکد پستی بلافاصــله پس از ثبـــت \n' +
           'سفارش میتوان اشاره نموده است. در عین حال سرویس پست خارجی این سامانه دارای دو بخش صادرات و واردات برای ۱۸۰ کشـــور در دنیا \n' +
           'میتوان اشاره کرد. شما می توانید با مطالعه قوانین پستِکس قبل از اقدام به استفاده از آن ، از ارسالی امن و مطمئن بهره مند گردید. فرامــوش \n' +
           'نکنید که اگر فعال پستی هم هستین میتونید با درآمدی خوب نماینده ما بشید.',

        t8: 'راه های ارتباطی',
        t9: 'ثبت سفارش'
      },
      loginEDU: {
        t1: 'http و آموزش ورود به سایت',
        t2: 'پروتکل http یا همان Hyper Text Transfer Protocol در واقع همان درگاه اتصال سیستم کاربران با انواع سایت ها می باشد و پروتکل https که خلاصه شده ی Hypertext Transfer Protocol Secure به معنای پروتکل امن انتقال ابر متن است ، در واقع همان نسخه ایمن شده ی http می باشد.' +
           '\n' +
           'وارد شدن به برخی از سایت های داخلی از طریق http امکان پذیر نیست و یا با تداخل همراه است و یا بالعکس نیاز است که برخی سایت ها فقط با آدرس http بارگذاری شوند،در موارد این چنین با انجام چند مرحله ساده زیر مشکل برطرف خواهد شد.',
        t3: '1. کلیک کردن و کپی کردن ادرس URL اولین قدمی است که برمیدارید ',
        t4: 'اولین گام کپی کردن آدرس سایت در مرورگر می باشد',
        t5: '2.لینک کپی شده را در تب جدید وارید کنید و بدون شک آدرس https یا http را مشاهده میکنید',
        t6: '3.با ویرایش کردن آدرس https در این مثال و تغییر آن به http میتوانید به راحتی سایت های داخلی به خصوص پستِکس را در اختیار داشته باشید',
        t7: '4. در پایان میتوانید سایت پست بار و پستِکس یا هر سایت داخلی دیگری را بدون ایراد و با http در اختیار داشته باشید',
        t8: 'با سپاس از اینکه مارا همراهی می نمایید.\n' +
           '\n' +
           'لطفا با مطالعه سوالات پر تکرار ما را در خدمت رسانی هر چه بهتر به خود یاری فرمایید.پستِکس ارائه کننده انواع خدمات پستی داخلی و خارجی بصورت درب تا درب اکسپرس در خدمت شماست.\n' +
           '\n' +
           'اگر فعال پستی هم هستین میتونید با درآمدی خوب نماینده ما بشید.',
        t9: 'تلگرام',
        t10: 'اینستاگرام',
        t11: 'سایت',
        t12: 'تلفن تماس'
      },
      representation: {
        t1: 'شرایط اخذ نمایندگی پستِکس',
        t2: 'چنانچه از فعالین پستی در شهر و استان خود می باشید و تمایل به اخذ نمایندگی پستِکس را دارید شما را دعوت به مطالعه ی ادامه این صفحه و همچنین سایر قوانین این سامانه می نماییم.لطفا در نظر داشته باشید که بعد از مطالعه این موارد حتما فرم درخواست نمایندگی پستِکس را تکمیل فرمایید',
        t3: 'پیش نیاز های نمایندگی پستِکس',
        t4: 'دفتر کار حداقل 20 متر (مسکونی نباشد)',
        t5: ' خط تلفن ، آب و گاز و برق مستقل و بستر اینترنت مناسب',
        t6: 'سرمایه لازم برای اداره شعبه',
        t7: 'عدم همکاری همزمان  با شرکتهای رقیب',
        t8: 'ضمانت معتبر',
        t9: 'حداقل لیسانس و یا سابقه 10 ساله موثر در زمینه کسب و کار مرتبط',
        t10: 'مدارک لازم',
        t11: 'کپی شناسنامه برابر اصل',
        t12: 'کپی کارت ملی برابر اصل',
        t13: 'دو قطعه عکس 4×3',
        t14: 'کپی مدرک تحصیلی برابر اصل',
        t15: 'تضامین و اسناد بانکی طبق قرارداد(100 میلیون)میباشد',
        t16: 'گواهی عدم سوء پیشینه به نام شرکت معماران به طرح',
        t17: 'قرارداد نمایندگی امضا شده و گواهی امضا',
        t18: 'وظایف',
        t19: 'بازاریابی',
        t20: 'هماهنگی با پست برای جمع آوری',
        t21: 'پیگیری تاخیر در جمع آوری ارسال و تحویل و غرامتهای شکستن و تاخیر و جمع آوری احتمالی بارهایی که پست جمع نکرده است',
        t22: 'تبلیغات منطقه ای',
        t23: 'لینک دانلود قرارداد اخذ نمایندگی',
        t24: 'نمونه سفته تکمیل شده',
        t25: 'دریافت فایل کمیسیون ها',
      },
      cartoon: {
        t1: 'کارتن و لفاف',
        t2: 'کارتن و لفاف و جعبه های استاندارد پستی چیست؟ پاسخ به این سوال و رعایت آن یکی از قوانین مهم استفاده از خدمات پستی می باشد. اساسا کارتن و لفاف و جعبه استاندارد پستی میبایستی ۳ تا ۵ لایه باشد تا در مسیر جابجایی پستی جعبه متلاشی نگردد.',
        t3: 'خرید بسته بندی',
        t4: 'حالا شما میتوانید با استفاده از گزینه خرید جعبه و کارتـــــن بسته استاندارد پستی از این سرویس توسط هر یک از فعالین پستی برخوردار شوید. امروزه اهمیت بسته بندی با توجه بــه محدودیت های فضاهای پستی، نیاز به ابعاد استاندارد و جعبه های استاندارد برای انجام فرایند مرسوله امریست ضروری.',
        t5: 'سایز های استاندارد کارتن و لفاف جعبه های پستی',
        t6: 'بسته بندی سایز',
        t7: 'طول:',
        t8: 'عرض:',
        t9: 'ارتفاع:',
      },
      msg: {
        t1: 'آدرس با موفقیت ثبت شد',
        t2: 'آدرس با موفقیت بروزرسانی شد',
        t3: 'لطفا یکی از فیلد های بارکد پستی یا شماره سفارش را وارد کنید',
        t4: 'در حال بارگزاری اطلاعات',
        t5: "درخواست شما با موفقیت ثبت شد",
        t6: "آیتم ها بررسی کنید",
        t7: "عملیات با موفقیت انجام شد",
        t8: "موردی یافت نشد",
        t9: "درخواست شما با مشکل مواجه شد",
        t10: "گذرواژه ها باید یکسان باشند",
        t11: "اینترنت خود را بررسی کنید",
        t12: "مشکلی در اجرای درخواست بوجود آمده است"
      },
      rate: {
        t1: 'ممنون از اینکه سرویس پستِکس را انتخاب کردید.',
        t2: 'برای ثبت تجربه خود پس از استفاده از سرویس پستِکس و همچنین کمک به بهتر شدن این سرویس، لطفا در نظرسنجی زیر شرکت کنید.',
        t3: '1- از عدد 1 تا 10 چه نمره ای به تجربه کلی خود، از ثبت سفارش با پستِکس میدهید؟',
        t4: 'بد',
        t5: 'خوب',
        t6: 'خیلی خوب',
        t7: '2- فرآیند استفاده از وبسایت پستِکس را چطور ارزیابی میکنید؟',
        t8: 'سخت',
        t9: 'معمولی',
        t10: 'آسان',
        t11: '3- چه عاملی باعث شد تا سرویس پستِکس رو برای ثبت سفارش انتخاب کنید؟',
        t12: 'قیمت گذاری مناسب',
        t13: 'نظرات دیگران',
        t14: 'راحت بودن فرآیند ثبت سفارش',
        t15: 'تنوع سرویس های پستی',
        t16: 'سیستم رهگیری مناسب',
        t17: '4- تجربه شما از کار کردن با سیستم رهگیری پستِکس به چه شکل بود؟',
        t18: 'اصلا رضایت نداشتم',
        t19: 'تا حدی رضایت داشتم',
        t20: 'کاملا راضی بودم',
        t21: '5- اگر در حین استفاده از سرویس پستِکس، با تیم پشتیبانی تماس داشته اید، لطفا میزان رضایت خود را نسبت به کیفیت پشتیبانی اعلام کنید.',
        t22: 'مشکلم برطرف نشد',
        t23: 'تا حدی مشکلم برطرف شد',
        t24: 'کاملا مشکلم برطرف شد',
        t25: '6- سرویس پستِکس را از لحاظ قیمت گذاری چطور ارزیابی میکنید.',
        t26: 'خیلی گران',
        t27: 'معمولی',
        t28: 'کاملا ارزان و مقرون به صرفه',
        t29: '7- چقدر احتمال داره سرویس پستِکس را به دوستان خود پیشنهاد بدهید؟',
        t30: 'اصلا پیشنهاد نمیدهم',
        t31: 'شاید پیشنهاد بدهم',
        t32: 'حتما پیشنهاد میدهم',
        t33: '8- آیا نظری درباره قسمت های مختلف سرویس پستِکس دارید که به بهبود این سرویس کمک کند؟',
        t34: 'پایان نظرسنجی',
      },
      orderCancellation: {
        t1: "فرم کنسلی سفارش",
        t2: "",
        t3: "نام و نام خانوادگی",
        t4: "تلفن همراه",
        t5: "شماره سفارش",
        t6: "دلیل کنسلی",
        t7: "عدم جمع آوری به موقع پست",
        t8: "عدم تطابق وزن واقعی با وزن اظهار شده",
        t9: "بسته بندی نامناسب",
        t10: "کنسل به درخواست مشتری",
        t11: "عدم تطابق آدرس با کد پستی اظهارشده برای فرستنده یا گیرنده",
        t12: "عدم تطابق محتویات با نوع مرسوله اظهار شده",
        t13: "عدم تحویل مرسوله توسط فرستنده",
        t14: "عدم حضور فرستنده در محل",
        t15: "ممنوعات پستی",
        t16: "سایر",
        t17: "توضیحات",
        t18: "عودت مبلغ خدمات پستی",
        t19: "عودت مبلغ خدمات فنی و پشتیبانی",
        t20: "عودت مبلغ کارتن و بسته بندی",
        t21: "عودت مبلغ جمع آوری",
        t22: "درصد توافقی عودت وجه",
        t23: "انتخاب نحوه واریز",
        t24: "کیف پول",
        t25: "کارت بانکی",
        t26: "ثبت درخواست",
      },
      withdrawalRequest: {
        t1: "درخواست برداشت از کیف پول",
        t2: "واریزی ها روزهای شنبه، دوشنبه و چهارشنبه خواهد بود.",
        t3: "مبلغ 500 هزار تومان در حساب بلوکه میشود.",
        t4: "سقف برداشت هر واریزی روزانه 5 میلیون تومان است.",
        t5: "سقف برداشت ماهیانه 80 میلیون تومان است.",
        t6: "نام و نام خانوادگی",
        t7: "تلفن همراه - نام کاربری",
        t8: "شماره شبا",
        t9: "مبلغ درخواستی (ریال)",
        t10: "ثبت درخواست",
      },
      agencyRequest: {
        t1: "فرم درخواست نمایندگی و فروشگاه",
        t2: "شما میتوانید به راحتی و تحمل هزینه هایی نزدیک به صفر با ما همکاری کنید یک فرم آنلاین درخواست نمایندگی یا فروشگاه رو پر کنید همکاران فنی ما پس تایید و بررسی صلاحیت با شما تماس خواهند گرفت",
        t3: "نام",
        t4: "شهر / استان",
        t5: "آدرس",
        t6: "رشته تحصیلی",
        t7: "تلفن ثابت (به همراه کد شهر)",
        t8: "تلفن همراه",
        t9: "ایمیل",
        t10: "وضعیت تاهل",
        t11: "مجرد",
        t12: "متاهل",
        t13: "سن",
        t14: "دسترسی به فضای دفتر کاری",
        t15: "هیچکدام",
        t16: "دارم",
        t17: "ندارم",
        t18: "سوابق پستی دارید؟ توضیح دهید.",
        t19: "آیا توان تجهیز نمایندگی تا 35 میلیون تومان را دارید؟",
        t20: "بله",
        t21: "خیر",
        t22: "آیا توان پرداخت حقوق و حق بیمه کارکنان خود را دارید؟",
        t23: "نحوه آشنایی",
        t24: "سایت دیوار",
        t25: "نماینده یاب",
        t26: "از طریق سایت پستِکس",
        t27: "معرفی دوستان",
        t28: "اینستاگرام",
        t29: "اپلیکیشن ایرانسل من",
        t30: "سایر",
        t31: "آیا امکان معرفی یک ضامن را دارید؟",
        t32: "آیا فضای دفتری شما در همکف می باشد؟",
        t33: "ظرفیت ناوگان شما برای توزیع و جمع آوری چند نقطه در روز می باشد؟",
        t34: "نقطه",
        t35: "کدام موارد زیر در دفتر خود موجود دارید؟",
        t36: "کامپیوتر",
        t37: "بارکد اسکنر",
        t38: "قفسه بندی",
        t39: "دوربین مداربسته",
        t40: "لوکیشن (لت و لانگ) آدرس مغازه را وارد کنید",
        t41: "تاریخ اتمام اجاره را انتخاب کنید",
        t42: "تاریخ را انتخاب کنید",
        t43: "آیا دارای شغل دیگری هستین؟",
        t44: "قوانین و مقررات نمایدگی را خواندم و قبول دارم",
        t45: "توضیحات",
        t46: "لطفا بعد از ثبت درخواست خود از صفحه خارج نشوید و صفحه ضمائم و مقررات را مطالعه نمایید",
        t47: "ثبت درخواست نمایندگی",
        t48: "درخواست نماینده",
        t49: "درخواست فروشگاه",
        t50: "نام فروشگاه",
        t51: "نام خانوادگی",
        t52: "اطلاعات هویتی",
        t53: "نام پدر",
        t54: "شماره شناسنامه",
        t55: "سریال شناسنامه",
        t56: "سری شناسنامه",
        t57: "محل صدور شناسنامه",
        t58: "تاریخ تولد",
        t59: "کد ملی",
        t60: "سریال کارت ملی",
        t61: "جنسیت",
        t62: "مرد",
        t63: "زن",
        t64: "اطلاعات محل سکونت",
        t65: "کدپستی",
        t66: "اطلاعات محل نمایندگی",
        t67: "اطلاعات بانکی",
        t68: "شماره شبا",
        t69: "شماره حساب",
        t70: "بانک",
        t71: "نام شعبه",
      },
      codRequest: {
        t1: "نام",
        t2: "نام خانوادگی",
        t3: "تلفن ثابت (به همراه کد شهر)",
        t4: "کد پستی",
        t5: "کد ملی/شناسه ملی",
        t6: "شماره سریال کارت ملی",
        t7: "تاریخ تولد",
        t8: "موبایل",
        t9: "ایمیل",
        t10: "شماره حساب",
        t11: "شماره شبا",
        t12: "نام شعبه بانک",
        t13: "استان/شهر",
        t14: "شهرستان",
        t15: "آدرس",
        t16: "درگاه پرداخت",
        t17: "ثبت درخواست",
        t18: "فرم درخواست پسکرایه",
      },
      myRequests: {
        t1: "درخواست های من",
        t2: "جستجوی کلمه مورد نظر...",
        t3: "درخواست وازیر وجه",
        t4: "کنسلی سفارش",
        t5: "درخواست نمایندگی",
        t6: "درخواست فروشگاه",
        t7: "شماره تیکت",
        t8: " تاریخ",
        t9: "مشاهده",
        t10: "شماره درخواست",
        t11: "شماره سفارش",
      },
      employment: {
        t1: "فرم درخواست استخدام",
        t2: "ارزیابی کمی",
        t3: "نام",
        t4: "نام خانوادگی",
        t5: "تلفن ثابت",
        t6: "تلفن همراه",
        t7: "ایمیل",
        t8: "لطفا بخش مورد نظر خود را مشخص کنید",
        t9: "استان/شهر",
        t10: "آدرس",
        t11: "آخرین مدرک تحصیلی",
        t12: "دیپلم",
        t13: "کاردانی",
        t14: "کارشناسی",
        t15: "کارشناسی ارشد",
        t16: "دکتری",
        t17: "دانشگاه محل تحصیل",
        t18: "رشته تحصیلی",
        t19: "وضعیت نظام وظیفه",
        t20: "پایان خدمت",
        t21: "معافیت تحصیلی (دانشجو)",
        t22: "سایر",
        t23: "وضعیت تاهل",
        t24: "مجرد",
        t25: "متاهل",
        t26: "تاریخ تولد",
        t27: "میزان سابقه کار",
        t28: "میزان حقوق درخواستی",
        t29: "میزان آشنایی به زبان انگلیسی",
        t30: "کم",
        t31: "متوسط",
        t32: "زیاد",
        t33: "پیشرفته",
        t34: "ثبت درخواست",
        t35: "انتخاب رزومه",
        t36: "دانشجو",
      }
    },
    amnito: {
      navBar: {
        t1: 'ورود / ثبت نام',
        t2: 'خانه',
        t3: 'سفارش تکی',
        t4: 'سفارش انبوه',
        t5: 'کیف پول',
        t6: 'پیشخوان',
        t7: 'حساب من',
        t8: 'کاربر',
        t9: 'فرم نمایندگی',
        t10: 'تماس با دفتر مرکزی',
        t11: 'ارسال بسته انبوه'
      },
      bottomNavigation: {
        t1: 'خانه',
        t2: 'پشتیبانی',
        t3: 'سفارش',
        t4: 'کیف پول',
        t5: 'پیشخوان',
        t6: 'سفارشات من',
      },
      footer: {
        t1: 'اطلاعات کلی سایت',
        t2: 'قوانین سامانه امنیتو',
        t3: 'درباره امنیتو',
        t4: 'اخبار',
        t5: 'انجمن ها',
        t6: 'بلاگ',
        t7: 'راهنمای مشتریان',
        t8: 'مستندات وب سرویس',
        t9: 'وجه دریافتی از گیرنده به اشتباه',
        t10: 'http و آموزش ورود به سایت',
        t11: 'شرایط اخذ نمایندگی امنیتو',
        t12: 'کارتن و لفاف',
        t13: 'آکادمی آموزش',
        t14: 'سوالات متداول',
        t15: 'حساب من',
        t16: 'پیشخوان',
        t17: 'لیست سفارشات',
        t18: 'ویرایش حساب کاربری',
        t19: 'خدمات',
        t20: 'حسابداری',
        t21: 'تیکت',
        t22: 'ارتباط با امنیتو',
        t23: 'دریافت اپلیکیشن',
        t24: 'منطقه شهرداری هفت، خیابان شریعتی، کوچه مسجد، پلاک ۱۸، طبقه دوم',
        t25: 'شماره تماس',
        t26: 'تمام حقوق این سایت متعلق به معماران بهطرح میباشد | 2023'
      },
      drawer: {
        t1: 'خدمات پستی',
        t2: 'پیک هاب (پیک درون شهری)',
        t3: 'PME (پست خارجی)',
        t4: 'شاپکس (فروشگاه ساز)',
        t5: 'لودکس (حمل و نقل سنگین)',
        t6: 'بیوپست (پست سرد)',
        t7: 'کادوکس (ارسال کادو)',
        t8: 'سفارشات من',
        t9: 'اصلاح سایز بسته بندی',
        t10: 'دانلود اپلیکیشن',
        t11: 'پشتیبانی',
        t12: 'ارسال تیکت به پشتیبانی',
        t13: 'لیست تیکت های من',
        t14: 'اخذ نمایندگی',
        t15: 'نظرات کاربران',
        t16: 'افزونه / API',
        t17: 'نشریه حمل و نقل',
        t18: 'درباره ما',
        t19: 'امنیتو ( سوالات متداول )',
        t20: 'تنظیمات حساب کاربری',
        t21: 'خروج از حساب کاربری',
        t22: 'سفارشات دیگران برای من',
        t23: "خانه",
        t24: "همکاری با ما"
      },
      login: {
        t1: 'پستِکس اولین هاب پستی ایران با ارائه دهنده خدمات آنلاین پست به صورت درب تا درب',
        t2: 'ورود به حساب کاربری',
        t3: 'شماره موبایل',
        t4: 'رمز عبور',
        t5: 'مرا به خاطر داشته باش',
        t6: 'فراموشی رمز عبور؟',
        t7: 'ورود به حساب کاربری',
        t8: 'کاربر جدید هستید در پستِکس؟',
        t9: 'ثبت نام',
        t10: 'بازگشت به صفحه اصلی',
      },
      register: {
        t1: 'شما میتوانید به راحتی با مقایسه قیمت، سرعت و کیفیت خدمات، از سرویس های متنوع سامانه پستِکس استفاده کنید',
        t2: 'ثبت نام در پستِکس',
        t3: 'شماره موبایل همراه با صفر',
        t4: 'کد ملی',
        t5: 'رمز عبور',
        t6: 'تایید رمز عبور',
        t7: 'ثبت نام در پستِکس',
        t8: 'ثبت نام در پستِکس به منزله موافقت با قوانین است.',
        t9: 'قوانین',
        t10: 'قبلا در پستِکس ثبت نام کرده اید؟',
        t11: 'ورود',
        t12: 'بازگشت به صفحه اصلی',
        t13: 'پسوردها یکی نمیباشند',
        t14: 'نام',
        t15: 'نام خانوادگی',
        t16: 'موافقم'
      },
      newPassword: {
        t1: 'شما میتوانید به راحتی با مقایسه قیمت، سرعت و کیفیت خدمات، از سرویس های متنوع سامانه پستِکس استفاده کنید',
        t2: 'لطفا رمز عبور جدید را وارد کنید',
        t3: 'رمز عبور جدید',
        t4: 'تایید رمز عبور جدید',
        t5: 'ثبت رمز عبور',
        t6: 'بازگشت به صفحه اصلی',
        t7: 'شماره موبایل',
        t8: 'ارسال',
      },
      forgetPassword: {
        t1: 'شما میتوانید به راحتی با مقایسه قیمت، سرعت و کیفیت خدمات، از سرویس های متنوع سامانه پستِکس استفاده کنید',
        t2: 'لطفا کد دریافتی را وارد کنید',
        t3: 'تایید کد',
        t4: 'کد دریافت نکرده اید؟',
        t5: 'اصلاح شماره تماس',
        t6: 'بازگشت به صفحه اصلی',
        t7: 'ارسال مجدد کد',
        t8: 'کد تایید',
        t9: 'پسورد جدید',
        t10: 'تکرار پسورد جدید',
        t11: 'ثبت',
      },
      homeDesktop: {
        s1: {
          t1: "پرداخت امن با امنیتو",
          t2: 'امنیت پرداخت در فروشگاه های اینترنتی',
          t3: {
            tt1: 'رهگیری مرسولات پستی',
            tt2: 'بارکد پستی (کد رهگیری)، شماره سفارش یا موبایل فرستنده/گیرنده را وارد کنید:',
            tt3: 'بارکد پستی',
            tt4: 'شماره سفارش',
            tt5: 'موبایل فرستنده/گیرنده',
            tt6: 'رهگیری مرسوله',
            tt7: 'بارکد پستی یا شماره سفارش',
            tt8: 'رهگیری بسته و محاسبه قیمت بسته',
          },
          t4: {
            tt1: 'محاسبه سریع قیمت پستی',
            tt2: 'لطفا برای محاسبه قیمت پستی، اطلاعات زیر را وارد کنید',
            tt3: 'پست داخلی',
            tt4: 'پست خارجی',
            tt5: 'فرستنده',
            tt6: 'شهر - استان',
            tt7: 'گیرنده',
            tt8: 'شهر - استان',
            tt9: 'سایز',
            tt10: 'انتخاب کنید',
            tt11: 'ارزش کالا (ریال)',
            tt12: 'وزن ( گرم )',
            tt13: 'توزیع',
            tt14: 'نیاز به جمع آوری',
            tt15: 'بسته بندی',
            tt16: 'استعلام قیمت',
            tt17: 'پس کرایه',
            tt18: 'پرداخت در محل(COD)',
            tt19: 'کشور',
            tt20: 'آیا شکستنی است؟',
            tt21: 'آیا حاوی مایعات است؟',
            tt22: "سایز بزرگتراز 9",
            tt23: "ارزش کالا جهت تعیین سقف تعهدات"
          },
          t5: 'بسته تو ارسال کن',
          t6: 'نتیجه رهگیری مرسوله شما',
          t7: 'کد رهیگری/شماره سفارش/موبایل',
          t8: 'نام سرویس پستی',
          t9: 'نوع مرسوله',
          t10: 'تاریخ جمع آوری',
          t11: 'تاریخ ارسال',
          t12: 'تاریخ تحویل',
          t13: 'نام فرستنده',
          t14: 'آدرس فرستنده',
          t15: 'نام گیرنده',
          t16: 'آدرس گیرنده',
          t17: 'نتیجه محاسبه سریع قیمت',
          t18: 'با',
          t19: 'امنیتو',
          t20: 'امن خرید و فروش',
          t21: 'کنید',
          t22: 'شاپکس',
          t23: 'فروشگاه ساز آنلاین',
          t24: 'با امنیتو امکان ارسال بسته به خارج از کشور رو هم داری',
          t25: 'با پیک هاب کسب و کارت رو به راهه',
          t26: 'کد رهیگری',
          t27: 'ارسال بسته',
          t28: "حضور امنیتو در نمایشگاه Gitex",
          t29: "",
          t30: "تنها رویداد برای ارتباط با 250 نهاد دولتی",
          t31: "بزرگترین حضور دولت در میان رویدادهای فناوری، پرده برداری از پروژه های دیجیتال ملی و مشارکت خصوصی و دولتی",
          t32: "نو آورترین شرکت های جهان",
          t33: "قدرت انکارناپذیر نوآوری را در نمایشی جامع از محصولات و راه حل های جهانی با کاربردهای صنعتی متنوع تجربه کنید",
          t34: "جیتکس، الهام بخش و بهبود دهنده زندگی",
          t35: "نشست خبری نمایشگاه جیتکس جهانی که دوشنبه هفته آینده افتتاح می‌شود با حضور وزیر دولت امارات متحده عربی در حوزه هوش مصنوعی برگزار شد",
          t36: "برای نخستین بار جیتکس گلوبال امسال در دو محل وسیع برگزار می‌شود",
          t37: "این نمایشگاه محل عرضه تازه‌ترین فناوری‌ها و پیشرفت‌ها در حوزه هوش مصنوعی، رایانش ابری، وب ۳.۰ و اقتصاد پایدار دیجیتال است",
        },
        s2: {
          t1: 'چرا مرسولاتم رو باید با امنیتو بفرستم؟',
          t2: 'سرویس های امنیتو',
          t3: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع ',

          t4: 'سرویس امنیتو',
          t5: '<h2>با امنیتو، لذت <b>خرید اینترنتی</b> را به مشتری هدیه بدهید</h2>',
          t6: 'یکی از مشکلات خرید فروش اینترنتی، اعتماد کاربر و پرداخت هزینه هست که امنیتو با سرویس پرداخت امن به نام امنیتو این مشکل را حل کرده است و میرسد به نظر راهکاری مناسب، برای جلب اعتماد خریدار و فروشنده است',
          t7: 'در سرویس امنیتو، در زمان فروش کالا، خریدار وجه کالا ر تا زمان تحویل و رویت مرسوله، وجه کالا را در حساب واسط و امانی امنیتو قرار میدهد که در صورت تایید مرسوله و دریافت وضعیت تحویل مبلغ مرسوله به نفع فروشنده آزاد خواهد شد و در صورت عدم تایید مرسوله و دریافت وضعیت عدم تایید،',
          t8: 'خرید و فروش امن در فروشگاه های اینترنتی',
          t9: 'شروع به کار',

          t10: 'سرویس بیو پست',
          t11: '<h2>دیگه نگران جابه جایی <b>نمونه های آزمایشگاهی</b> نباش!</h2>',
          t12: 'پست بیولوژیک و پست سرد خدمتی جدید از امنیتو که با نام با نام بیو امنیتو که مخصوص حمل نمونه های عفونی-آزمایشگاهی و مواد شیمیایی است در۲۴ الی ۳۶ ساعت در تمامی نقاط کشورتوزیع میشود و جمع آوران، مرسولات همراه و موقعیت پستی در سلامت خواهند بود',
          t13: 'جا به جایی نمونه های آزمایشگاهی',

          t14: 'سابکس',
          t15: '<h2> دیگه نگران فیلترینگ اینستاگرام نباش! <b>با سابکس فروشگاهت رو گسترش بده.</b></h2>',
          t16: '  با استفاده از سرویس سابکس میتوانید کلیه محصولات خود را در پنل شخصی خود بارگذاری کرده و با دریافت یک لینک اختصاصی و عرضه آن به مشتری یا قرار دادن در بیوگرافی، خریدار با مراجعه به کلیک کردن لینک شما، لیست کاملی از محصولات فروشگاه شما را خواهد داشت',
          t17: '  پس لذا به راحتی میتواند با ئارد کردن آدرس؛ نوع کالای منتخب، روش ارسال و حتی نوع سرویس پرداخت از مجموعه شما خرید بنماید که با این روش شما میتوانید به امکانات و اطلاعات فوق العاده ای دست پیدا کنید',
          t18: 'سرویس سابکس جایگزین اینستاگرام',

          t19: 'شیپیتو پلاس',
          t20: '<h2>محاسبه مسیر ها  <b> ارزانترین و سریعترین </b> برای ارسال بسته ها!</h2>',
          t21: 'اگر فروشگاهی دارای ناوگانی برای عرضه خدمت در حوزه جمع آوری و توزیع مرسولات خود باشد یکی از مهمترین چالش ها، محاسبه بهینه مسیرهای ناوگان، بر اساس کوتاه ترین و کم ترافیک ترین مسیرها است',
          t22: 'اگر فرض بر این باشد که این امر در تعداد کم و با توجه به شناخت مسیرها مقدور باشد ولی محاسبه انسانی در تعداد بالای امریست غیر ممکن و ثانیا دانش ترافیک های منطقه ای بصورت آنلاین و یا تقویمی، خود امریست موثر در این محاسبه',
          t23: 'پست هوشمند با هوش مصنوعی',

          t24: 'فروشگاه ساز شاپکس',
          t25: '<h2>ساخت <b>فروشگاه آنلاین با پنل اختصاصی </b>و کلی امکانات دیگه با شاپکس! </h2>',
          t26: 'با گسترش روزافزون روش های فروش و تبلیغات، یکی از قدیمی ترین روشهای فروش یعنی تله مارکتینگ با استفاده از کال سنتر همچنان یکی از روشهای موثر در امر فروش است',
          t27: 'حال شما میتوانید کلیه محصولات خود را در پنل شخصی خود بارگذاری کرده و 4 روش ارسال رایگان، پرداخت در محل، پرداخت نقدی، خرید و فروش امن و امکاناتی نظیر لیزینگ مبلغ کالای فروخته شده بر اساس درصد برگشتی به مانند خط اعتباری دایمی از شاپکس استفاده نمایید و با این روش شما میتوانید به امکانات و اطلاعات فوق العاده ای دست پیدا کنید',
          t28: 'با شاپکس همه چیز رو با هم بفروش',

          t29: 'پست داخلی',
          t30: '<h2> بسته خود را با انواع سرویس های <b> پست داخلی </b> ارسال کنید! </h2>',
          t31: 'با گسترش روزافزون روش های فروش و تبلیغات، یکی از قدیمی ترین روشهای فروش یعنی تله مارکتینگ با استفاده از کال سنتر همچنان یکی از روشهای موثر در امر فروش است',
          t32: 'حال شما میتوانید کلیه محصولات خود را در پنل شخصی خود بارگذاری کرده و 4 روش ارسال رایگان، پرداخت در محل، پرداخت نقدی، خرید و فروش امن و امکاناتی نظیر لیزینگ مبلغ کالای فروخته شده بر اساس درصد برگشتی به مانند خط اعتباری دایمی از شاپکس استفاده نمایید و با این روش شما میتوانید به امکانات و اطلاعات فوق العاده ای دست پیدا کنید',
          t33: 'با پست بار نگران ارسال بسته هات نباش',

          t34: 'کادوکس',
          t35: '<h2>دیگه نگران فرستادن <b>کادو</b>برای عزیزانتان نباشید!</h2>',
          t36: ' بزارید جواب این سوال رو با یک سوال شروع کنیم!\n' +
             'تا به حال در شرایطی قرار گرفتید که برای فردی برای روز تولدش بخواهید کنارش باشید و به هر علتی این شرایط فراهم نشده است و احتمالا کادوی مورد نظر ایشون رو هم آماه کردید و با شرکتهای پستی فرستادید و سر موقع نرسیده باشد.\n' +
             'کادوکس سامانه کادو اکسپرسی است که شما با ثبت شهر مقصد خود، نیاز به کادوپیچی، گل و حتی کیک مد نظرتان میتوانید کادوی مورد مورد نظرتان رو به موقع و با شرایط مورد نظرتان به دست فردی که در نظر دارید برسانید',
          t37: 'با کادوکس فاصله ها کم میشه',

          t38: 'امنیتو یار',
          t39: '<h2><b>امنیتو یار،</b> همراه افراد معلول و کسانی که محدودیت داردند!</h2>',
          t40: 'خدمت نوین پستی برای روشن دلان، معلولان، جانبازان و یا اونهایی که به گوشی هوشمند دسترسی ندارن یا بلد نیستن بخوبی ازش استفاده کنه این امکان رو میده با تماس در کوتاه ترین زمان جمع آور امنیتو رو درب محل زندگی یا کارش ببینه و مرسولات رو بدون انجام روند ثبت سفارش اینترنتی رهسپاری کنه',
          t41: 'امنیتو یار - یار و غم خوار',
          t42: 'بزودی...'
        },
        s3: {
          t1: 'چگونه نمایندگی امنیتو را دریافت کنید',
          t2: '<h2>آیا می‌خواهید به عنوان <b>جمع‌آور</b> یا <b>نماینده‌ی امنیتو</b> با ما همکاری کنید؟</h2>',
          t3: 'اگر چنین است، می‌توانید درخواست نمایندگی خود را برای ما ارسال کنید. دریافت نمایندگی امنیتو هر فردی که می‌خواهد به صورت مستقل و منعطف، با حداقل هزینه و بیشترین میزان سود فعالیت کند، یک فرصت به حساب می‌آید. مراحل دریافت نمایندگی به صورت زیر است:',
          t4: 'درخواست نمایندگی',
          t5: 'درخواست نمایندگی شما تایید شد!',
          t6: 'پر کردن فرم مربوط به درخواست نمایندگی',
          t7: 'تماس تیم پشتیبانی برای تأیید صلاحیت',
          t8: 'ارائه‌ی مدارک درخواستی اعم از چک بانکی، سفته، قرارداد امضا شده، مدارک مالکیت وسیله نقلیه، اجاره‌نامه محل کسب و غیره.',
          t9: 'دریافت حق نمایندگی امنیتو'
        },
        s4: {
          t1: 'نرم افزار رهگیری',
          t2: '<h2>هم اکنون می‌توانید از <b>اپ رهگیری</b> روی <b>گوشی اندرویدی</b> خود استفاده کنید</h2>',
          t3: 'معرفی برنامه',
          t4: 'سامانه امنیتو سرویس امنیتو راهی مناسب برای افزایش اعتماد مشتری و همچنین افزایش فروش فروشگاه های انترنتی با تامین امنیت پرداخت',
          t5: 'گوگل پلی',
          t6: 'کافه بازار',
          t7: 'رهگیری مرسوله، در هر لحظه در هرجا!',
          t8: 'امنیتو',
          t9: 'معماران بهطرح',
          t10: ' سامانه امنیتو (www.amnito.postex.ir) اولین سامانه جامع حمل و نقل آنلاین پستی ایران از درب تا درب می باشد',
          t11: 'خدمات و ویژگی های امنیتو:',
          t12: 'پست ملی ایران ، چاپار، یارباکس و پست پیشتاز ، پست سفارشی ، پست سریع ، پست ویژه ، پست شهری'
        },
        s5: {
          t1: 'همکاران امنیتو',
          t2: '<h2>سرویس هایی که ما <b>افتخار همکاری</b> با آنها را داریم</h2>',
          t3: 'اسنپ باکس',
          t4: 'شرکت اسپید',
          t5: 'شرکت گنجه',
          t6: 'بیو پست ( پست سرد )',
          t7: 'اسکای پست',
          t8: 'راه آسمان آبی',
          t9: 'پست خارجی',
          t10: 'آرامکس',
          t11: 'چاپار',
          t12: 'پست پیشرو',
          t13: 'ماهکس',
          t14: 'پست ملی ایران',
          t15: 'یار باکس',
          t16: 'ندکس',
          t17: 'کالا رسان',
        },
        s6: {
          t1: 'خبرنامه امنیتو',
          t2: '<h2>از آخرین <b>اخبار و تخفیف ها</b> با خبر شو!</h2>',
          t3: 'لطفا ایمیل خودتون رو وارد کنید ...',
          t4: 'عضویت',
        }
      },
      // <div dangerouslySetInnerHTML={{ __html: t("homeDesktop.s2.t5") }} />
      // {t("homeDesktop.s5.t6")}
      homeMobile: {
        t1: 'رهگیری مرسولات',
        t2: 'لطفا اطلاعات خود را وارد کنید',
        t3: 'بارکد پستی',
        t4: 'رهگیری مرسوله',
        t5: 'محاسبه سریع قیمت پستی',
        t6: 'بسته تو ارسال کن',
        t7: 'محاسبه سریع قیمت پستی',
        t8: 'پست داخلی',
        t9: 'پست خارجی',
        t10: 'فرستنده',
        t11: 'شهر - استان',
        t12: 'گیرنده',
        t13: 'سایز',
        t14: 'انتخاب کنید',
        t15: 'ارزش کالا (ریال)',
        t16: 'وزن مرسوله ( گرم )',
        t17: 'توزیع',
        t18: ' نیاز به جمع آوری',
        t19: 'بسته بندی',
        t20: 'فرستنده',
        t21: 'کشور',
        t22: 'استعلام قیمت',
        t23: 'بسته های من',
        t24: 'تحویل پست داده شده',
        t25: 'آخرین به روز رسانی: 3 ساعت پیش',
        t26: 'شماره سفارش',
        t27: 'موبایل فرستنده/گیرنده',
        t28: 'بارکد پستی یا شماره سفارش',
        t29: 'اولین بستتو ارسال کن',
        t30: 'شروع ثبت سفارش',
        t31: 'رهگیری مرسوله یا استعلام قیمت',
        t32: "ارزش کالا جهت تعیین سقف تعهدات"
      },
      dashboard: {
        sideBar: {
          t1: 'دفترچه آدرس ها',
          t2: 'پیام ها',
          t3: 'سفارشات من',
          t4: 'درخواست فاکتور',
          t5: 'امتیاز معرفی',
          t6: 'تنظیمات',
          t7: 'خروج از حساب کاربری',
          t8: 'لیست آدرس ها',
          t9: 'سفارشات دیگران برای من',
          t10: 'درخواست های من',
        },
        address: {
          t1: 'دفترچه آدرس ها',
          t2: 'افزودن آدرس جدید',
          t3: 'جستجو در آدرس های قبلی',
          t4: 'نام',
          t5: 'نام خانوادگی',
          t6: 'تلفن همراه',
          t7: 'نام شرکت',
          t8: 'اضافه کردن استان',
          t9: 'شهر - استان',
          t10: 'متن آدرس',
          t11: 'آدرس بصورت متنی',
          t12: 'ذخیره',
          t13: 'قسمتی از آدرس را تایپ کنید',
          t14: 'تهران - شهرک اکباتان - ...',
          t15: 'لیست آدرس ها',
          t16: 'آدرس',
          t17: 'گیرنده',
          t18: 'انتخاب شهر',
          t19: 'فرستنده',
          t20: 'آدرس برای',
          t21: 'آیا میخواهید آدرس راحذف کنید؟',
          t22: 'تایید',
          t23: 'انصراف',
          t24: 'انتخاب آدرس به عنوان پیش فرض',
          t25: 'آدرس پیش فرض',
          t26: 'ویرایش آدرس',

        },
        message: {
          t1: 'پیام ها'
        },
        order: {
          t1: 'سفارشات من',
          t2: 'همه',
          t3: 'پرداخت شده',
          t4: 'معلق',
          t5: 'چاپ',
          t6: 'شماره سفارش',
          t7: 'وضعیت پرداخت',
          t8: 'وضعیت سفارش',
          t9: 'وضعیت ارسال',
          t10: 'فرستنده',
          t11: 'گیرنده',
          t12: 'قیمت',
          t13: 'ریال',
          t14: 'پرداخت',
          t15: 'روش پرداخت',
          t16: 'لغو',
          t17: 'سفارشات دیگران برای من',
          t18: 'جستجو سفارش',
          t19: 'از تاریخ',
          t20: 'تا تاریخ',
          t21: 'جستجو',
          t22: 'بستن',
          t23: "لغو",
          t24: "جمع آوری",
          t25: "ویرایش",
          t26: "جزئیات",
          t27: "شماره سفارش",
          t28: "شماره محموله",
          t29: "وضعیت سفارش",
          t30: "وضعیت پرداخت",
          t31: "شماره رهگیری",
          t32: "تاریخ",
          t33: "استان/شهر مبدا",
          t34: "شهر مبدا",
          t35: "آدرس مبدا",
          t36: "نام کامل فرستنده",
          t37: "نام خانوادگی فرستنده",
          t38: "شماره موبایل فرستنده",
          t39: "استان/شهر مقصد",
          t40: "شهر مقصد",
          t41: "آدرس مقصد",
          t42: "نام کامل گیرنده",
          t43: "نام خانوادگی گیرنده",
          t44: "محتویات مرسوله",
          t45: "وزن مرسوله",
          t46: "هزینه بیمه",
          t47: "نیاز به پرینتر دارد؟",
          t48: "ارزش مرسوله",
          t49: "حق ثبت الکترونیکی",
          t50: "نیاز به کارتون دارد؟",
          t51: "طول بسته",
          t52: "عرض بسته",
          t53: "ارتفاع بسته",
          t54: "نیاز به چاپ لوگو دارد؟",
          t55: "نیاز به جمع آوری دارد؟",
          t56: "نیاز به توزیع دارد؟",
          t57: "بله",
          t58: "خیر",
          t59: "جزئیات سفارش",
          t60: "اطلاعات مرسوله",
          t61: "خدمات",
          t62: " موجود نیست ",
        },
        affiliate: {
          t1: 'امتیاز معرفی',
          t2: 'دریافت کد دعوت',
          t3: 'با دعوت از دوستان خود به امنیتو هدیه دریافت کنید',
          t4: 'کپی شد',
        },
        setting: {
          t1: 'تنظیمات',
          t2: 'سرویس دریافت ایمیل اطلاعات ثبت سفارش',
          t3: 'دسترسی به پرینتر',
          t4: 'دسترسی به بسته پستی',
          t5: 'بارگذاری نشان تجاری',
          t6: 'تغییر تم سایت',
          t7: 'تغییر زبان سایت',
          t8: 'ذخیره',
        },
        requestFactor: {
          t1: 'لیست فاکتور',
          t2: 'درخواست فاکتور',
          t3: 'نام',
          t4: 'نام خانوادگی',
          t5: 'کد ملی',
          t6: 'کد اقتصادی',
          t7: 'کد اتباع خارجی',
          t8: 'کد پستی',
          t9: 'آدرس',
          t10: 'درخواست',
          t11: 'درحال بررسی'
        }
      },
      wallet: {
        t1: 'افزایش اعتبار',
        t2: 'انتخاب مبلغ',
        t3: 'انتخاب کنید',
        t4: 'مبلغ دلخواه ( ریال )',
        t5: 'انتخاب روش پرداخت',
        t6: 'بانک ملت',
        t7: 'پرداخت و افزایش اعتبار',
        t8: 'گزارش مالی',
        t9: 'هفتگی',
        t10: 'ماهانه',
        t11: 'سالانه',
        t12: 'ریال',
        t13: 'واریز',
        t14: 'برداشت',
        t15: 'گزارش مالی',
        t16: 'ردیف',
        t17: 'نوع تراکنش',
        t18: 'مبلغ',
        t19: 'تاریخ تراکنش',
        t20: 'شماره تراکنش',
        t21: 'جیب',
        t22: 'کدام سفارش',
        t23: 'تایید و پرداخت',
        t24: 'انتقال اعتبار',
        t25: 'شماره تلفن',
        t26: 'مبلغ دلخواه ( ریال )',
        t27: 'انتخاب مبلغ',
        t28: 'موجودی فعلی',
        t29: 'لیست تراکنش ها',
        t30: 'پاک کردن لیست تراکنش ها',
        t31: 'تسویه حساب'
      },
      singleOrder: {
        t1: 'مرحله قبل',
        t2: 'مرحله بعد',
        t3: 'تکمیل سفارش',
        t4: 'پرداخت',
        t5: 'لغو',
        t6: 'فاکتور',
        step: {
          t1: 'فرستنده',
          t2: 'گیرنده',
          t3: 'اطلاعات بسته',
          t4: 'نوع سرویس',
          t5: 'بازبینی',
        },
        sender: {
          t1: 'ثبت آدرس فرستنده',
          t2: 'سفارش انبوه',
          t3: 'انتخاب آدرس های قبلی',
          t4: 'اضافه کردن آدرس جدید',
          t5: 'ثبت اطلاعات فرستنده',
          t6: 'نام',
          t7: 'نام خانوادگی',
          t8: 'تلفن همراه',
          t9: 'پست الکترونیک',
          t10: 'نام شرکت',
          t11: 'آدرس',
          t12: 'نیاز به جمع آوری',
          t13: 'در صورت انتخاب نیاز به جمع آوری، مرسوله شما از درب محل فرستنده جمع آوری خواهد شد' +
             'درصورتی که سفارش پیش از ساعت ۸ صبح ثبت شده باشد امروز تا ساعت ۱۸ جمع آوری خواهد شد و پس از ساعت ۸ فردا (در صورت نبودن تعطیلی)تا ساعت ۱۸ جمع آوری خواهد شد.',
          t14: 'انتخاب آدرس های قبلی',
          t15: 'انتخاب آدرس',
          t16: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t17: 'اضافه کردن آدرس جدید',
          t18: 'اضافه کردن آدرس',
          t19: 'استان / شهر مبدا',
          t20: 'آدرس فرستنده',
          t21: 'آدرس بصورت متنی',
          t22: 'اضافه کردن',
          t23: 'در صورت عدم انتخاب جمع آوری مرسوله را باید در دفتر نمایندگی امنیتو و یا سرویس پستی انتخاب شده تحویل فرمایید .',
          t24: 'شهر را انتخاب کنید',
          t25: 'تلفن ثابت (به همراه کد شهر)',
          t26: 'کد ملی',
          t27: 'کد پستی',
          t28: 'شهر خود را جستجو کنید',
          t29: 'انتخاب موقعیت مکانی فرستنده',
          t30: 'سایر موارد',
          t31: 'بستن',
          t32: "انتخاب آدرس از روی نقشه (اختیاری)",
          t33: "(اختیاری)"

        },
        receiver: {
          t1: 'ثبت آدرس گیرنده',
          t2: 'سفارش انبوه',
          t3: 'انتخاب آدرس های قبلی',
          t4: 'اضافه کردن آدرس جدید',
          t5: 'ثبت اطلاعات گیرنده',
          t6: 'نام',
          t7: 'نام خانوادگی',
          t8: 'تلفن همراه',
          t9: 'پست الکترونیک',
          t10: 'نام شرکت',
          t11: 'آدرس',
          t12: 'نیاز به توزیع',
          t13: 'در صورت انتخاب نیاز به توزیع، مرسوله شما درب محل گیرنده توزیع خواهد شد',
          t14: 'انتخاب آدرس های قبلی',
          t15: 'انتخاب آدرس',
          t16: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t17: 'اضافه کردن آدرس جدید',
          t18: 'اضافه کردن آدرس',
          t19: 'استان / شهر مقصد',
          t20: 'آدرس گیرنده',
          t21: 'آدرس بصورت متنی',
          t22: 'اضافه کردن',
          t23: 'در صورت عدم انتخاب نیاز به توزیع، مرسوله در محل دفتر نمایندگی شرکت پستی تحویل گیرنده خواهد شد',
          t24: 'شهر را انتخاب کنید',
          t25: 'تلفن ثابت (به همراه کد شهر)',
          t26: 'کد ملی',
          t27: 'کد پستی',
          t28: 'شهر خود را جستجو کنید',
          t29: 'انتخاب موقعیت مکانی گیرنده'
        },
        packageInfo: {
          t1: 'اطلاعات بسته',
          t2: 'محتویات مرسوله',
          t3: 'ارزش ریالی مرسوله',
          t4: 'وزن مرسوله ( گرم )',
          t5: 'اندازه بسته پستی',
          t6: 'بسته‌بندی می‌خواهم',
          t7: ' چاپ رسید',
          t8: 'اطلاع رسانی پیامکی',
          t9: 'اطلاع رسانی پیامکی فعال شد',
          t10: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است،',
          t11: 'تایید',
          t12: ' نشان تجاری شما',
          t13: 'نوع پرداخت',
          t14: 'پرداخت هزینه ارسال-عادی',
          t15: 'پرداخت درمحل(COD)',
          t16: 'پرداخت هزینه ارسال و کالا-امنیتو',
          t17: 'ارسال رایگان',
          t18: 'پس کرایه',
          t19: 'اضافه کردن بسته',
          t20: 'بسته با موفقیت اضافه شد',
          t21: 'شما میتوانید اطلاعات بسته های خود را از قسمت جزئیات بسته ها مشاهده کنید',
          t22: 'شکستنی',
          t23: 'حاوی مایعات',
          t24: 'در صورت انتخاب نیاز به بسته بندی، مرسوله شما پس از جمع آوری و در محل انبار امنیتو، بسته بندی شده و لیبل بارنامه بروی آن نصب خواهد شد.',
          t25: 'در صورت عدم انتخاب نیاز به بسته بندی، مرسوله را با بسته بندی استاندارد به جمع آور امنیتو تحویل دهید.',
          t26: 'در صورت انتخاب نیاز به چاپ لیبل بارنامه، مرسوله شما پس از جمع آوری و در محل انبار امنیتو، لیبل شده و لیبل بارنامه بروی آن نصب خواهد شد.' +
             'در زمان تحویل مرسوله به جمع آور پستِکس شماره سفارش خود را بروی مرسوله بنویسید به نحوی که کنده یا پاک نشود.',
          t27: 'در صورت عدم انتخاب نیاز به چاپ لیبل بارنامه، لیبل را چاپ و بروی مرسوله نصب نمایید و به جمع آور پستِکس تحویل دهید.',
          t28: 'فاکتور پستی باید چاپ و روی بسته چسبانده شود',
          t29: 'در صورت انتخاب گزینه اطلاع رسانی پیامکی در تمامی مراحل ارسال، وضعیت مرسوله از طریق پیامک به گیرنده و فرستنده اطلاع رسانی خواهد شد',
          t30: 'چنانچه شما به چاپگر جهت چاپ لیبل بارنامه خود دسترسی ندارید گزینه نیاز به چاپ فاکتور را انتخاب نمایید که پس از جمع آوری بار در انبار پستِکس لیبل بروی مرسوله الصاق میشود و در زمان تحویل مرسوله به جمع آور پستِکس می‌بایستی شماره محموله را بروی مرسوله درج فرمایید',
          t31: 'شما گزینه انتخاب نیاز به چاپ فاکتور، لیبل بارنامه را چاپ و بروی بارنامه الصاق فرمایید',
          t32: 'چنانچه مرسوله شما حاوی کالای شکستنی می‌باشد گزینه شکستنی را انتخاب کنید.',
          t33: 'چنانچه مرسوله شما حاوی مایعات می‌باشد گزینه مایعات را انتخاب کنید.',
          t34: "هزینه کالا + هزینه ارسال درب محل برعهده گیرنده میباشد",
          t35: "هزینه ارسال توسط فرستنده یا گیرنده پرداخت می‌شود",
          t36: "کلیه هزینه های ارسال و ارزش کالا از گیرنده دریافت میگردد و مجموع مبلغ دریافت شده، پس از کسر هزینه های مندرج در قوانین به حساب فرستنده واریز میشود.",
          t37: "هزینه کالا و ارسال توسط گیرنده پرداخت و امانی نزد پستِکس تا دریافت کالا از فرستنده می‌ماند",
          t38: "هزینه ارسال مرسوله در زمان تحویل به گیرنده، از ایشان اخذ میگردد",
          t39: 'خدمات نمایندگی',
          t40: 'خدمات نماینده',
          t41: "ارزش ریالی مرسوله جهت تعیین سقف تعهدات",
          t42: "برای فعالسازی روش های پرداخت بیشتر درخواست فروشگاه ثبت نمایید",
          t43: "درخواست فروشگاه",
          t44: "روش های پرداخت",
        },
        serviceType: {
          t1: 'انتخاب سرویس دهنده',
          t2: 'ارزان ترین',
          t3: 'سریع ترین',
          t4: 'محبوب ترین',
          t5: 'سرویس های موجود',
          t6: 'سرویس های نا موجود',
          t7: 'نوع سرویس',
          t8: 'زمان ارسال',
          t9: 'هزینه پستی و خدمات فنی',
          t10: 'توضیحات',
          t11: 'ریال',
          t12: 'جمع آوری',
          t13: 'توزیع',
          t14: 'بیمه تا سقف',
          t15: 'انتخاب سرویس الزامی میباشد',
          t16: 'یکی از نمایندگی های زیر را انتخاب کنید',
          t17: "قیمت تقریبی",
          t18: "جمع آوری مرسوله از درب محل فرستنده",
          t19: "<p>جمع آوری  <b>امروز</b> ، سفارش تا قبل از ۱۲ ظهر<br/>" +
             "جمع آوری  <b>فردا</b> ، سفارش بعد از ۱۲ ظهر</p>",
          t20: "هزینه جمع آوری",
          t21: "مراکز نزدیک به شما جهت تحویل بسته",
          t22: "با توجه به اینکه تیک نیاز به جمع آوری توسط شما انتخاب نشده است، مسئولیت تحویل کالا بر عهده شما میباشد.",
          t23: "تغییر وضعیت",
          t24: "آدرس مراکز نزدیک به شما جهت تحویل بسته",
          t25: "برای مبدا انتخابی شما سرویسی یافت نشد",
          t26: "یکی ار مراکز روی نقشه را انتخاب کنید",
          t27: "این سرویس برای مشخصات وارد شده شما فعال نمی باشد",
          t28: "مرکز انتخابی شما",
          t29: "سرویس انتخابی شما"
        },
        review: {
          t1: 'جزئیات بسته ها',
          t2: 'بسته',
          t3: 'محتویات مرسوله',
          t4: 'تعداد بسته پستی',
          t5: 'ارزش ریالی مرسوله',
          t6: 'ریال',
          t7: 'وزن مرسوله ( گرم )',
          t8: 'گرم',
          t9: 'اندازه بسته پستی',
          t10: 'سایز',
          t11: 'چاپ فاکتور',
          t12: 'اطلاعات گیرنده',
          t13: 'نوع سرویس',
          t14: 'زمان ارسال',
          t15: 'هزینه ارسال',
          t16: 'بسته بندی',
          t17: 'چاپ لیبل',
          t18: 'درج لوگو',
          t19: 'خدمات فنی مهندسی',
          t20: 'جمع آوری درب منزل',
          t21: 'توزیع',
          t22: 'اضافه کردن سفارش جدید',
        },
        invoice: {
          t1: 'تاریخ و زمان',
          t2: 'شماره سفارش',
          t3: 'پیش فاکتور پستی و خدمات فنی ',
          t4: 'خدمات پستی',
          t5: 'ردیف',
          t6: 'شرح',
          t7: 'تعداد',
          t8: 'قیمت(ريال)',
          t9: 'جمع',
          t10: 'ريال شامل مالیات',
          t11: 'خدمات فنی و پشتیبانی',
          t12: 'پرداخت',
          t13: 'مجموع سفارش',
          t14: 'ریال',
          t15: 'پرداخت با کیف پول',
          t16: 'موجودی شما',
          t17: 'بانک ملت',
          t18: 'ثبت سفارش جدید',
          t19: 'خدمات فنی، بیمه و جمع آوری کالا از محل و...',
          t20: 'مالیات بر ارزش افزوده',

          t21: 'چاپ و الصاق فاکتور',
          t22: 'ارزش افزوده نمایندگی',
          t23: 'هزینه کارتن و لفاف',
          t24: 'کارمزد و هزینه مالی',
          t25: 'هزینه توضیع مرسوله',
          t26: 'مبلغ کالا',
          t27: 'مبلغ بیمه',
          t28: 'خدمات فنی مهندسی',
          t29: 'چاپ نماد تجاری',
          t30: 'حق ثبت الکترونیکی',
          t31: 'هزینه پیامک و رهگیری',
          t32: 'هزینه جمع آوری',
          t33: 'کد تخفیف',

        }
      },
      multiOrder: {
        t1: 'مرحله قبل',
        t2: 'مرحله بعد',
        t3: 'تکمیل سفارش',
        s1: {
          t1: 'اطلاعات فرستنده',
          t2: 'انتخاب آدرس های قبلی',
          t3: 'اضافه کردن آدرس جدید',
          t4: 'اطلاعات سرویس',
          t5: 'نوع سرویس',
          t6: 'انتخاب کنید',
          t7: 'الصاق نشان تجاری روی فاکتور',
          t8: 'پاکت / کارتن پستی',
          t9: 'اطلاع رسانی پیامکی',
          t10: 'اطلاع رسانی پیامکی فعال شد',
          t11: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است،',
          t12: 'تایید',
          t13: 'دانلود فایل اکسل',
          t14: 'آپلود فایل اکسل',
          t15: 'انتخاب آدرس',
          t16: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t17: 'اضافه کردن آدرس',
          t18: 'استان را انتخاب کنید',
          t19: 'متن آدرس',
          t20: 'آدرس بصورت متنی',
          t21: 'اضافه کردن',
          t22: 'ردیف',
          t23: 'عملیات',
          t24: 'آیا شکستنی است؟',
          t25: 'آیا حاوی مایعات است؟',
          t26: 'دریافت فایل اکسل خام، برای سفارشات پیش کرایه',
          t27: 'دریافت فایل اکسل خام، برای سفارشات پرداخت توسط گیرنده(COD)',
          t28: 'شهر خود را جستجو کنید'
        },
        s2: {
          t1: 'اطلاعات مرسوله',
          t2: 'سطر جدید',
          t3: 'مرسوله',
          t4: 'محتویات مرسوله',
          t5: 'اندازه بسته پستی',
          t6: 'انتخاب کنید',
          t7: 'طول',
          t8: 'عرض',
          t9: 'ارتفاع',
          t10: 'ارزش ریالی مرسوله',
          t11: 'وزن مرسوله ( گرم)',
          t12: 'بیمه',
          t13: 'اضافه کردن اطلاعات گیرنده',
          t14: 'اطلاعات گیرنده',
          t15: 'انتخاب آدرس گیرنده',
          t16: 'نام',
          t17: 'نام خانوادگی',
          t18: 'تلفن همراه',
          t19: 'نام شرکت',
          t20: 'آدرس',
          t21: 'قسمتی از مشخصات یا موبایل یا آدرس قبلی را وارد کنید',
          t22: 'استان را انتخاب کنید',
          t23: 'آدرس بصورت متنی',
          t24: 'اضافه کردن',
          t28: 'شهر خود را جستجو کنید',
          t29: "ارزش ریالی مرسوله جهت تعیین سقف تعهدات"

        }
      },
      packing: {
        t1: 'اطلاعات مرسوله',
        t2: 'محتویات مرسوله',
        t3: 'ارزش ریالی',
        t4: 'ریال',
        t5: 'وزن مرسوله',
        t6: 'گرم',
        t7: 'اندازه بسته پستی',
        t8: 'تعداد بسته پستی',
        t9: 'جزئیات سفارش فعلی',
        t10: 'گیرنده',
        t11: 'شماره تماس',
        t12: 'آدرس گیرنده',
        t13: 'نوع سرویس',
        t14: 'نیاز به جمع آوری',
        t15: 'چاپ لیبل',
        t16: 'درج لوگو',
        t17: 'ویرایش اطلاعات مرسوله',
        t18: 'محتویات مرسوله',
        t19: 'ارزش ریالی',
        t20: 'وزن مرسوله (گرم)',
        t21: 'سایز بسته بندی',
        t22: 'تعداد بسته پستی',
        t23: 'چاپ فاکتور',
        t24: 'اضافه کردن',
        t25: 'قیمت واحد',
        t26: 'ذخیره تغییرات',
        t27: 'بله',
        t28: 'خیر',
        t29: 'طول',
        t30: 'عرض',
        t31: 'ارتفاع',
      },
      sendTicket: {
        t1: 'پشتیبانی',
        t2: 'لطفا پیش از ارسال تیکت پشتیبانی، ابتدا ',
        t3: 'پرسش های متداول',
        t4: 'را مشاهده کنید',
        t5: 'موضوع تیکت',
        t6: 'موضوع را انتخاب کنید',
        t7: 'نام و نام خانوادگی',
        t8: 'تلفن تماس یا ایمیل',
        t9: 'کد سفارش',
        t10: 'کد پیگیری',
        t11: 'اولویت',
        t12: 'متن پیام',
        t13: 'نوع کالا',
        t14: 'نوع کالا را انتخاب کنید',
        t15: 'کالای نو',
        t16: 'کالای دسته دو',
        t17: 'نام کالا',
        t18: 'قیمت خرید',
        t19: 'نام برند کالا',
        t20: 'شماره شبا',
        t21: 'توضیحات',
        t22: 'تلفن ثابت (به همراه کد شهر)',
        t23: 'کد پستی',
        t24: 'کد ملی',
        t25: 'شماره سریال کارت ملی',
        t26: 'تاریخ تولد',
        t27: 'شماره حساب',
        t28: 'نام شعبه بانک',
        t29: 'استان - شهرستان',
        t30: 'آدرس',
        t31: 'انتخاب تصویر',
        t32: 'حداکثر 3 تصویر JPEG، حداکثر 1 مگابایت',
        t33: 'ثبت و ارسال',
        t34: 'درخواست خسارت',
        t35: 'درخواست پس کرایه',
        t36: 'سایر',
        t37: 'نام بخش',
        t38: 'نوع تیکت',
      },
      listTicker: {
        t1: 'لیست تیکت های من',
        t2: 'همه تیکت ها',
        t3: 'در نوبت ارسال به پشتیبانی',
        t4: 'پاسخ داده شده',
        t5: 'متن پیام',
        t6: 'پاسخ پشتیبانی',
        t7: 'بستن',
        t8: 'پاسخ به پشتیبانی',
        t9: 'ثبت و ارسال',
      },
      faq: {
        t1: 'سوالات متداول',
        t2: 'جستجوی کلمه مورد نظر...',
        t3: 'هزینه و سرویس ها',
        t4: 'زمانبندی ارسال',
        t5: 'غرامت و خسارت پستی و مالی',
        t6: 'ممنوعات پستی',
        t7: 'محدودیتهای ارسال',
        t8: 'سوالات اخذ نمایندگی',

        t9: 'آیا میتوانم از خدمات پسکرایه یا پرداخت در محل استفاده کنم؟',
        t10: 'شما میتوانید با پرداخت هزینه سالیانه ای از خدمات پسکرایه٬ ارسال رایگان و پرداخت در محل ( cod ) پلتفرم پستِکس استفاده نمایید جهت ثبت درخواست خود با مراجعه به لینک پسکرایه در پستِکس درخواست خود را ثبت نمایید و از پیش نیازهای درخواست خود مطلع گردید. لازم به ذکر است هزینه خدمات مالی برای استفاده از خدمات ارسال رایگان و پرداخت در محل ( cod ) معادل ۱ الی ۳ درصد ارزش کالا میباشد.\n' +
           'ارجاع به صفحه پسکرایه\n',
        t11: 'از کجا به کجا میتوانم بار ارسال کنم یا شهرهای تحت پوشش پستِکس کجاست؟',
        t12: 'مطالعه این صفحه',
        t13: 'قوانین استفاده از خدمات پستِکس چیست؟',
        t14: 'مطالعه این صفحه',
        t15: 'آیا پستِکس پست خارجی نیز دارد؟',
        t16: 'بله جهت استعلام آنلاین قیمت پستی به صفحه ذیل مراجعه کنید',
        t17: 'چطور میتوانم تخفیف بگیرم؟',
        t18: 'سامانه هوشمند پستِکس با محاسبه ماهیانه تعداد مرسولات شما اقدام به ارایه تخفیف مینماید ولی چنانچه نیاز به مذاکره بیشتر دارید میتوانبد با مراجعه به لینک زیر تیکت خود را ثبت نمایید',
        t19: 'فروشگاه اینترنتی دارم شرایط همکاری با پستِکس به چیست؟',
        t20: 'شما با ثبت نام در سایت پستِکس و در صورت داشتن کالای استاندارد٬ غیر قاچاق و ممنوعه نبودن میتوانید از خدمات پستِکس بصورت پیشکرایه٬ پسکرایه٬ ارسال رایگان و پرداخت در محل ( cod) استفاده نمایید.',
        t21: 'مرسوله ام بسته بندی نشده و چطور میتونم از شما خدمات دریافت کنم؟',
        t22: 'مشتری گرامی چنانچه در شهری که شما در حال ثبت سفارش هستید پستِکس دارای نماینده انبارش میباشد شما میتوانید در زمان ثبت سفارش گزینه نیاز به بسته بندی یا دسترسی به پرینت ندارم را انتخاب نمایید که پس از جمع آوری مرسوله توسط نماینده پستِکس در محل انبار نماینده پستِکس بار پسته بندی و لیبل بارکد خواهد شد لذدا توجه داشته باشید نماینده امکان بسته بندی در محل شما را نخواهد داشت.',
        t23: 'ثبت سفارش تلفنی هم دارین و از طریق سایت ممکنه راهنمایی کنید به چه صورت هست ؟',
        t24: 'متاسفانه در پستِکس امکان ثبت سفارش تلفنی مقدور نمیباشد و لذا شما با مراجعه به لینک ذیل و پس از ثبت نام میتوانید ثبت سفارش بنمایید',
        t25: 'آیا پستِکس جمع آوری نیز دارد؟',
        t26: 'مشتری گرامی در تمامی نقاطی که پستِکس نمایندگی دارد پستِکس در صورت درخواست شما امکان جمع آوری دارد و در صورتی که نمایندگی نداشته باشد شما میتوانید پس از ثبت در پستِکس که شامل تخفیف خواهد بود بار را شخصا به شرکت پستی تحویل بدهید.',
        t27: 'هزینه ارسال مرسوله من چقدر خواهد بود؟',
        t28: 'مشتری گرامی با مراجعه به لینک زیر میتوانید هزینه سرویس های متنوع پستی را با یکدیگر مقایسه بنمایید',

        t29: 'بارم من کجاست؟',
        t30: 'مشتری گرامی سرویس های متنوع پستی دارای زمانبندی متنوعی میباشد که شرح ذیل میباشد:\n' +
           'سرویس پستبار اکسپرس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس پست پیشتاز درون استانی  ۴ الی ۶ ساعت\n' +
           'سرویس پست پیشتاز بین استانی  ۷ الی ۹ ساعت\n' +
           'سرویس ماهکس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس چاپار ۳۶ الی ۷۲ ساعت\n' +
           'سرویس چاپار اکسپرس ۳۶ الی ۴۸ ساعت\n' +
           'سرویس اسکای پست ۲۴ الی ۴۸ ساعت\n' +
           'سرویس کالارسان ۳۶ الی ۴۸ ساعت\n' +
           'سرویس درون شهری پیک هاب ۱۸ الی ۲۴ ساعت\n' +
           'توجه داشته باشید تمام زمانبدی های فوق روز و ساعت کاری است و محاسبه مشمول ایام تعطیل نمیباشد و از زمان تحویل مرسوله به نماینده پستِکس محاسبه میگردد. \n' +
           '\n' +
           'لذا چنانچه از روند ارسال مرسوله میخواهید با خبر شوید به لینک رهگیری مراجعه فرمایید\n',
        t31: 'مرسوله من جمع آوری نشده چه زمانی مرسوله من جمع آوری خواهد شد؟',
        t32: 'اگر قبل از ساعت ۸ صبح امروز ثبت کردید تا ساعت ۱۹ جمع میشود و اگر بعد از ساعت ۸ ثبت کردید فردا تا ۱۹ جمع میگردد. چنانچه از نتیجه رهگیری راضی نیستید لطفا در تیکیت اعلام فرمایید تا همکاران ما در پستِکس رسیدگی بنمایند\n' +
           ' اگر قبل از ۸ صبح امروز ثبت  سفارش نمودید و تا ساعت ۱۹ امروز بار شما جمع آوری نگردیده  است لطفا با مراجعه به لینک زیر تیکت خود را اعلام فرمایید.\n',
        t33: 'چند بسته باهم برام ارسال کردن اما بسته ها کامل به دستم نرسیدند؟',
        t34: 'مشتری گرامی توجه داشته باشید لزوما اگر چند مرسوله از یک مبدا و در یک روز برای شما ارسال شده حتما همگی در یک روز به دست شما نخواهد رسید زیرا ممکن است در ماشین هاتی متفاوتی جهت ارسال بارگیری شده باشد لذا بر اساس زمان مکشخص شده در زمان ثبت سفارش برای تحویل منتظر وصول مرسوله باشید و اگر چنانچه بیش از زمان مقرر بود از طریق تیکت پشتیبانی با ما در ارتباط باشید.',
        t35: 'حرکت مرسوله من چندین روز است که متوقف شده و هیچ روندی نداره چطوری پیگیری کنم ؟',
        t36: 'مشتری گرامی لطفا به لینک تیکت مراجعه نمایید و با ثبت شماره بارنامه خود منتظر تماس همکاران ما در پستِکس باشید',
        t37: 'بار یا بسته من چه زمانی خواهد رسید؟',
        t38: 'مشتری گرامی سرویس های متنوع پستی دارای زمانبندی متنوعی میباشد که شرح ذیل میباشد:\n' +
           'سرویس پستبار اکسپرس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس پست پیشتاز درون استانی  ۴ الی ۶ ساعت\n' +
           'سرویس پست پیشتاز بین استانی  ۷ الی ۹ ساعت\n' +
           'سرویس ماهکس ۲۴ الی ۴۸ ساعت\n' +
           'سرویس چاپار ۳۶ الی ۷۲ ساعت\n' +
           'سرویس چاپار اکسپرس ۳۶ الی ۴۸ ساعت\n' +
           'سرویس اسکای پست ۲۴ الی ۴۸ ساعت\n' +
           'سرویس کالارسان ۳۶ الی ۴۸ ساعت\n' +
           'سرویس درون شهری پیک هاب ۱۸ الی ۲۴ ساعت\n' +
           'توجه داشته باشید تمام زمانبدی های فوق روز و ساعت کاری است و محاسبه مشمول ایام تعطیل نمیباشد و از زمان تحویل مرسوله به نماینده پستِکس محاسبه میگردد. \n',
        t39: 'مرسوله من باجه معطله است چه باید بکنم؟',
        t40: 'چنانچه رهگیری مرسوله شما را در باجه معطله نشان بدهد میتوانید با مراجعه به باجه معطله شرکت پستی شهر خود تا ۵ روز مرسوله را تحویل بگیرید و چنانچه رهگیری دو بار مراجعه پستچی را نشان دهد و در همان روز قرار داشته باشید میتوانید با مراجعه به شرکت پستی مرسوله را تحویل بگیرید.',

        t41: 'مرسوله ای که به دستم رسیده آسیب دیده برای دریافت غرامت چه بکنم؟',
        t42: 'مسئولیت تضمین غرامت مرسولات پستی تا درب محل گیرنده میباشد لذا اگر مرسوله را تحویل گرفته باشید شامل هیچ نوع تضمین خسارتی نیست زیرا شما این فرصت را دارید تا در زمان تحویل مرسوله از پستچی بخواهید اجازه بدهد تا محتوای مرسوله را از جهت سلامت یا مطابقت با سفارش٬ کنترل نمایید.\n' +
           'حال اگر چنانچه موفق به انجام این امر نگردید و مرسوله شما از طرق شرکت ملی پست ارسال شده یود و چنانچه حداکثر ۲۴ ساعت از زمان تحویل گذشته باشد با مراجعه به سامانه غرامات پستی شانس خود را برای دریافت غرامت امتحان نمایید.\n' +
           'چنانچه مرسوله شما جز ممنوعات پستی باشد ما هیچگونه خدمتی برای پیگیری حرسوله ارايه نمیکنیم( لینک ممنوعات پستی)\n' +
           '\n' +
           'چنانچه از نتیجه رهگیری راضی نیستید لطفا در تیکیت اعلام فرمایید تا همکاران ما در پستِکس رسیدگی بنمایند\n',
        t43: 'چرا وجه کالای من که مقصد رسیده تسویه نگردیده است؟',
        t44: 'مشتری گرامی اصولا وضعیت توزیع به منزله تسویه حساب ارزش مرسوله نمیباشد و در صورت مشاهد وضعیت تایید یا تسویه مالی پس از ۴۸ ساعت وجه شما پرداخت میگردد.\n' +
           '\n' +
           'چنانچه از نتیجه پاسخ راضی نیستید و بیش از ۴۸ ساعت از تغییر وضعیت به حالت تایید و تسویه مالی میگذرد لطفا در تیکیت اعلام فرمایید تا همکاران ما در پستِکس رسیدگی بنمایند\n',
        t45: 'من در خواست کنسلی مرسوله رو کردم ولی وجه من واریز نشده یا کمتر واریز شده است',
        t46: 'مشتری گرامی اگر چنانچه قبل از مراجعه جمع آور٬ درخواست لغو سفارش  داشته باشید عودت وجه بدون کسر هیچگونه وجه پس از ۴۸ ساعت مرسوله به شما پرداخت میگردد\n' +
           ' اما چنانچه پس اعزام جمع آور درخواستی کنسلی سفارش را داشته باشید پس از کسر هزینه های جمع آوری الباقی مبلغ عودت خواهد شد\n' +
           'حال اگر چنانچه پس از جمع آوری کامل درخواستی کنسلی سفارش ار داشته باشید هیچگونه وجهی عودت نخواهد شد و جهت عودت مرسوله به مبدا ۵۰ هزار تومان هزینه از شما اخذ خواهد شد. لطفا جهت کنسلی سفارش با مراجعه به لینک زیر درخواست خود را ثبت نمایید.\n',
        t47: 'ثبت سفارش تلفنی هم دارین و از طریق سایت ممکنه راهنمایی کنید به چه صورت هست ؟ ',
        t48: 'متاسفانه در پستِکس امکان ثبت سفارش تلفنی مقدور نمیباشد و لذا شما با مراجعه به لینک ذیل و پس از ثبت نام میتوانید ثبت سفارش بنمایید.',
        t49: 'آدرس و اطلاعات به اشتباه ثبت شده و مرسوله من ارسال شده ممکنه راهنمایی کنید ؟',
        t50: 'چنانچه آدرسی را در پستِکس ثبت کرده باشید پس از دریافت بارکد امکان تغییر آدرس وجود ندارد.',
        t51: 'مرسوله ام بسته بندی نشده و چطور میتونم از شما خدمات دریافت کنم؟',
        t52: 'مشتری گرامی چنانچه در شهری که شما در حال ثبت سفارش هستید پستِکس دارای نماینده انبارش میباشد شما میتوانید در زمان ثبت سفارش گزینه نیاز به بسته بندی یا دسترسی به پرینت ندارم را انتخاب نمایید که پس از جمع آوری مرسوله توسط نماینده پستِکس در محل انبار نماینده پستِکس بار پسته بندی و لیبل بارکد خواهد شد لذدا توجه داشته باشید نماینده امکان بسته بندی در محل شما را نخواهد داشت.\n' +
           '\n' +
           'در عین حال توجه داشته باشید در صورت نیاز به سرویس بسته بندی در زمان تحویل مرسوله میبایستی بروی بسته شماره بارکد و سفارش خود را به نحوی بنویسید که تا پایان ارسیال پاک نشود.\n',
        t53: 'چطور میتوانم تخفیف بگیرم؟',
        t54: 'سامانه هوشمند پستِکس با محاسبه ماهیانه تعداد مرسولات شما اقدام به ارایه تخفیف مینماید ولی چنانچه نیاز به مذاکره بیشتر دارید میتوانبد با مراجعه به لینک زیر تیکت خود را ثبت نمایید',
        t55: 'وقتی کدرهگیری رو چک میکنم زده بسته تحویل گیرنده شده اما بنده که گیرنده هستم بسته ای رو تحویل نگرفت!  چه باید بکنم؟',
        t56: 'مشتری گرامی لطفا به لینک تیکت مراجعه نمایید و با ثبت شماره بارنامه خود منتظر تماس همکاران ما در پستِکس باشید',

        t57: ' آیا طلا یا نقره میتوانم ارسال کنم؟',
        t58: 'شما امکان ارسال طلا و نقره از طریق شرکتهای پستی ندارید زیرا این دست مرسولات جز ممنوعات پستی است و مسئولیت ارسال این دست مرسولات به عهده فرستنده میباشد و شامل هیچ تضمین غرامتی نیست.',
        t59: 'آیا چک یا پول نقد یا اسناد اداری میتوانم ارسال کنم؟',
        t60: 'شما امکان ارسال چک یا پول نقد یا اسناد اداری از طریق شرکتهای پستی ندارید زیرا این دست مرسولات جز ممنوعات پستی و مسئولیت ارسال این دست مرسولات به عهده فرستنده میباشد و شامل هیچ تضمین غرامتی نمی باشد.',
        t61: 'ممنوعات پستی چیست؟',
        t62: '-',

        t63: ' آیا بار شکستنی یا مایعات می توانم ارسال کنم؟',
        t64: 'شما در صورتی مایعات و شکستنی میتوانید ارسال نمایید که در زمان ثبت سفارش٬ گزینه شکستنی یا مایعات را انتخاب کرده و حتما از بسته بندی مناسب برای این امر استفاده نمایید در غیر اینصورت مسئولیت بار به عهده شماست.',
        t65: 'حداکثر وزنی که میتوانم ارسال کنم چیست؟',
        t66: 'حداکثر وزن در سرویس های پست معادل ۳۰ کیلوگرم است\n' +
           'حداکثر وزن در سرویس های ماهکس معادل ۳۰ کیلوگرم است\n' +
           'حداکثر وزن در سرویس های چاپار معادل ۳۵ کیلوگرم است\n' +
           'حداکثر وزن در اسکای پست معادل ۵۰ کیلوگرم است\n' +
           'حداکثر وزن در کالارسان معادل ۵۰ کیلوگرم است\n' +
           'حداکثر وزن در پودو معادل ۵۰ کیلوگرم است\n' +
           'حداکثر وزن در پیک هاب معادل ۵۰ کیلوگرم است\n',
        t67: 'حداکثر سایزی که میتونم ارسال چقدر است؟',
        t68: '-',
        t69: 'من نمیدانم سایز مرسوله من چند است؟',
        t70: 'مشتری محترم لطفا با مراجعه به لینک زیر با سایز بسته های پستی آسنا شوید و در زمان انتخاب سایز مرسوله٬ انتخاب درستی را به انجام برسانید',
        t71: 'آدرس و اطلاعات به اشتباه ثبت شده و مرسوله من ارسال شده ممکنه راهنمایی کنید ؟',
        t72: 'چنانچه آدرسی را در پستِکس ثبت کرده باشید پس از دریافت بارکد امکان تغییر آدرس وجود ندارد.',


        t73: 'چطور نمایندگی پستِکس را بگیرم؟',
        t74: 'شما میتوانید به مراجعه به لینک اخذ نمایندگی در پستِکس درخواست خود را ثبت نمایید و از پیش نیازهای درخواست خود مطلع گردید',
        t75: 'در آمد نمایندگی چگونه است؟',
        t76: 'پاسخ این سوال دقیقا در میزان تلاش منطقه ای نماینده برای جذب مرسولات پستی از همان منطقه مستتر میباشد بدین معنی که شما با اخذ نمایندگی پستِکس به انواع سرویس های پستی دسترسی دارید و بازاریابی از آن منطقه میتوانید میزان درآمد خود را تضمین بفرمایید.\n' +
           'ارجاع به صفحه اخذ نمایندگی در پستِکس\n',

        t77: 'اگر جواب سوالتون رو پیدا نکرده اید\n' +
           'با پشتیبانی ارتباط بگیرید.',
        t78: 'تیم پشتیبانی پستِکس، در اسرع وقت پاسخگو شما\n' +
           'خواهد بود و جواب شما را میدهد.',
        t79: 'ارتباط با پشتیبانی',
        t80: 'لینک صفحه'
      },
      profile: {
        t1: 'تنظیمات حساب کاربری',
        t2: 'نام',
        t3: 'نام خانوادگی',
        t4: 'تلفن همراه',
        t5: 'برای ویرایش شماره تلفن با پشتیبانی تماس بگیرید',
        t6: 'کد معرف',
        t7: 'تغییر کلمه عبور',
        t8: 'کلمه عبور فعلی',
        t9: 'کلمه عبور جدید',
        t10: 'تکرار کلمه عبور',
        t11: 'ذخیره',
        t12: 'دریافت کد',
        t13: 'تغییر گذرواژه',
        t14: 'کد یکبار مصرف',
        t15: 'شماره کارت',
        t16: 'شماره شبا',
        t17: 'کد ملی'
      },
      myPackage: {
        t1: 'مرسوله من',
        t2: 'شماره سفارش',
        t3: 'نام فرستنده',
        t4: 'آدرس گیرنده',
        t5: 'نوع سرویس',
        t6: 'زمان باقی مانده',
        t7: 'تاریخچه مرسوله',
        t8: 'دریافت شده',
        t9: 'تحویل انبار',
        t10: 'تحویل پیک',
        t11: 'تحویل مرسوله',
      },
      map: {
        t1: 'جستجو...'
      },
      error: {
        t1: 'ابتدا وارد شوید',
        t2: 'موردی یافت نشد',
        t3: "با توجه به موارد وارد شده از جمله سایز یا ارزش ریالی سرویسی در دسترس نیست لطفا به مرحله قبل برگردید و موارد را تغییر دهید",
        t4: "وارد کردن نام الزامی میباشد",
        t5: "وارد کردن نام خانوادگی الزامی میباشد",
        t6: "وارد کردن شماره موبایل الزامی میباشد",
        t7: "شماره موبایل وارد شده نامعتبر میباشد",
        t8: "وارد کردن آدرس الزامی میباشد",
        t9: "آدرس شما صحیح نمیباشد",
        t10: "آدرس شما نباید بیشتر از 150 کارکتر باشد",
        t11: "نام شما نباید بیشتر از 50 کارکتر باشد",
        t12: "نام خانوادگی شما نباید بیشتر از 50 کارکتر باشد",
        t13: "آدرس  شما فاقد موقعیت مکانی میباشد",
        t14: "کدپستی وارد شده نامعتبر میباشد",
        t15: "شماره موبایل وارد شده نامعتبر میباشد",
        t16: "شماره تلفن وارد شده نامعتبر میباشد",
        t17: "ایمیل وارد شده نامعتبر میباشد",
        t18: "نام شرکت نباید بیشتر از 50 کارکتر باشد",
        t19: "شماره موبایل فرستنده با شماره موبایل گیرنده نباید یکی باشد",
        t20: "انتخاب شهر و استان فرستنده الزامی میباشد",
        t21: "انتخاب شهر و استان گیرنده الزامی میباشد",
        t22: "وارد کردن اندازه بسته پستی الزامی میباشد",
        t23: "وارد کردن وزن مرسوله الزامی میباشد",
        t24: "وزن مرسوله نباید کمتراز 50 گرم باشد",
        t25: "وارد کردن ارزش ریالی مرسوله الزامی میباشد",
        t26: "وارد کردن محتویات مرسوله الزامی میباشد",
        t27: "انتخاب نوع پرداخت الزامی میباشد",
        t28: "انتخاب کشور گیرنده الزامی میباشد",
        t29: "انتخاب یا وارد کردن مبلغ الزامی میباشد",
        t30: "یک درگاه را انتخاب کنید",
        t31: "وارد کردن کد ملی الزامی میباشد",
        t32: "وارد کردن گذرواژه الزامی میباشد",
        t33: "گذرواژه خود را مجدد وارد کنید",
        t34: "گذرواژه ها باید یکسان باشند",
        t35: "وارد کردن کد یکبارمصرف الزامی میباشد",
        t36: "وارد کردن موضوع الزامی میباشد",
        t37: "وارد کردن اولویت الزامی میباشد",
        t38: "وارد کردن نام بخش الزامی میباشد",
        t39: "وارد کردن نوع تیکت الزامی میباشد",
        t40: "وارد کردن کد سفارش الزامی میباشد",
        t41: "وارد کردن کد پیگیری الزامی میباشد",
        t42: "وارد کردن متن پیام الزامی میباشد",
        t43: "وارد کردن شماره شبا الزامی میباشد",
        t44: "وارد کردن مبلغ الزامی میباشد",
        t45: "فایل انتخاب شده باید کمتر از 2 مگابایت باشد",
      },
      autoComplete: {
        t1: 'موردی یافت نشد'
      },
      rules: {
        t1: 'قوانین امنیتو',
        t2: 'فروشنده گرامی توجه داشته باشید که سه درصد ارزش کالا و خدمات پستی در ازای هر سفارش تایید شده از مبلغ کالا کسر و الباقی مبلغ واریز خواهد شد.' +
           'فروشنده محترم تعطیلات رسمی جز روند زمانی ارسال محسوب نمیگردد و شرکت در قبال آن مسئولیتی ندارد.',
        s1: {
          t1: 'قوانین سفارش کالا',
          t2: 'خریدار محترم لطفاً اطلاعاتی که برای این معامله لازم میباشد را جهت شروع فرایند ارسال مرسوله تکمیل بفرمایید',
          t3: 'خریدار محترم مبلغی که بابت خرید کالا٬ بصورت خرید فروش امن ( امنیتو ) به حساب امانی واریز میفرمایید تا زمان تحویل مرسوله و تحویل یا عدم تحویل مرسوله در حساب امانی پستِکس باقی میماند',
          t4: 'خریدار محترم شما مجاز هستید در زمان تحویل مرسوله محتوای مرسوله را در زمان تحویل کنترل نمایید و در صورت عدم تطابق با آگهی از تحویل آن خودداری ننمایید',
          t5: 'خریدار محترم شما پس از دریافت مرسوله میتوانید در نظرسنجی کیفیت کالای خریداری شده و سرویس دریافت شده شرکت نمایید',
          t6: 'خریدار محترم٬ فروشنده دو روز کاری فرصت دارد تا مرسوله را برای شما ارسال نماید و چنانچه در فرصت یاد شده مرسوله ارسال نگردد وجه امانی ظرف دو روز کاری به شما مسترد خواهد گردید',
          t7: 'توافق بر سر مبلغ کالا به عهده طرفین معامله میباشد لذا از ورود درست اطلاعات مالی و فردی\n' +
             '                             اطمینان حاصل بفرمایید',
          t8: 'خریدار محترم مرسوله شما در مقابل درب ورودی ساختمان و در خیابان تحویل داده خواهد شد',
          t9: 'برای پرداخت وجه معامله کنسل شده یا کالایی که مورد تایید خریدار نمیباشد ارائه شماره شبا بنام فروشنده الزامی است و در صورت تاخیر در ارائه مسئولیت تاخیر در پرداخت بعهده خریدار میباشد',
          t10: 'زمان تسویه حساب مالی دو روز کاری می باشد',
          t11: 'چنانچه به هر علت ٬ اعم از عدم شناسایی آدرس و یا برگشتی پس از ارسال به باجه معطله مرجوع گردد کلیه هزینه های پستی و فنی از حساب گیرنده کسر خواهد شدو ارسال مجدد و هزینه انبارداری به عهده فرستنده میباشد',
          t12: 'فروشنده محترم لازم است کالای ارسالی مطابق آگهی منتشر شده باشد تا در نظر سنجی رضایت خریدار با نمره منفی مواجه نگردید',
          t13: 'فروشنده محترم تعهد غرامت ناشی از عملیات پستی بعهده پستِکس است توجه داشته باشید تشخص خسارت وارده به عهده کارشناسان خبره بیمه ای پستِکس میباشد و به میزان ارزش واقعی مرسوله تعیین خواهد شد',
          t14: 'فروشنده محترم مرسوله شما در مقابل درب ورودی ساختمان و در خیابان تحویل گرفته خواهد شد',
          t15: 'برای پرداخت وجه کالا ارائه شماره شبا بنام فروشنده الزامی است و در صورت تاخیر در ارائه مسئولیت تاخیر در پرداخت بعهده فرستنده میباشد',
          t16: 'فروشنده محترم کلیه مرسولاتی که از ساعت ۸ صبح دیروز تا ساعت ۸ صبح امروز ثبت میشوند، همان روز تا ساعت ۱۷ جمع آوری و در فرایند ارسال قرار می گیرند. برای روزهای تعطیل فرایند ارسال از اولین روز کاری شروع می شود',
          t17: 'زمان تسویه حساب مالی دو روز کاری می باشد.',
          t18: 'جهت اطلاع از روند پرداخت حق مقر نیز به بخش دستورالعمل مندرج در سایت مراجعه نمایید ',
          t19: 'در صورتی که از یک بارکد نامعتبر(کنسل شده) یا بارکدی که قبلا مرسوله آن رهسپاری شده استفاده کنید. شامل جریمه نقدی تا 5 برار هزینه بارکد استفاده شده خواهید شد',
          t20: 'مرسوله جمع آوری شده تحت هیچ شراطی عودت داده نخواهد شد مگر اینکه مشکل قانونی داشته باشد',
        },
        s2: {
          t1: 'قوانین خریدار',
          t2: 'کنسلی سفارش',
          t3: 'می پذیرم در صورت ثبت سفارش از طریق پستِکس، چنانچه درخواست کنسلی سفارش را داشته باشم هیچ مبلغی عودت داده نخواهد شد',
          t4: 'می پذیرم چنانچه در زمان تحویل مرسولات، بسته ای تحویل داده نشود، به منزله کنسل شدن مرسوله می باشد',
          t5: 'تعهد می نمایم و می پذیرم چنانچه مرسوله از سامانه غیرپستی باشد، تا قبل از جمع آوری قابل کنسل کردن بوده و چنانچه برای جمع آوری مراجعه شود یا اینکه جمع آوری انجام شود برای کنسلی هیچ وجهی مسترد نخواهد شد.',
          t6: 'مدت زمان ارسال بسته طبق SLA  مندرج در توضیحات هر فعال پستی قید گردیده. بارهایی که مدت زمان ارسال  بیش از زمان مندرج در جدول SLA ارسال و تحویل شوند مشمول غرامت  تاخیر در ارسال خواهند شد که می بایستی از طریق eop.post.ir  ثبت گردد',
          t7: 'برای استفاده از سرویس پس کرایه یا COD مبلغ 1،500،000 ريال داخل کیف پول بلوکه خواهد شد. درصورت  درخواست کنسل کردن حساب پس کرایه، چنانچه تعداد سفارش های پس کرایه ثبت شده زیر10 سفارش باشد مبلغ عودت و در صورت ثبت سفارش بالای 10 تا، مبلغ عودت نخواهد شد و از مبلغ بلوکه شده می توان به جای هزینه سفارش پیش کرایه استفاده کرد',
          t8: 'مشتری گرامی چنانچه درخواست بازگشت کیف پول را داشته باشید این امر با ارسال تیکت و درخواست بازگشت کیف پول امکان پذیر میباشد ۷۲ ساعت پس از ارسال تیکت و اعلام شماره شبا مبلغ باقیمانده کیف پول شما عودت داده خواهد شد',
        },
        s3: {
          t1: 'قوانین فروشنده',
          t2: 'کلیه مرسولات تا درب محل گیرنده دارای بیمه می باشد و پس از تحویل به گیرنده و دریافت امضای گیرنده، هیچ گونه غرامتی پرداخت نخواهد شد  لذا گیرنده بایستی از دریافت مرسوله آسیب دیده خودداری نماید',
          t3: 'شرکت تنها در صورتی غرامت خسارت مرسوله را پرداخت می نماید که خود، کالا را بسته بندی نموده باشد. همچنین بیمه انتخاب شده متضامن کالاهایی که دارای بسته بندی استاندارد نمی باشند، نخواهد بود.',
          t4: 'مشتریانی که بیش از ۲ بار در ۱۰۰ مرسوله درخواست خسارت نمایند هیچگونه خسارتی حتی با رعایت شروط فوق پرداخت نخواهد شد',
          t5: 'در صورت دست دوم بودن کالا، قیمت کالای نو مشابه پس از برآورد  معادل 50% قیمت کالای نو تا سقف بیمه درخواست شده پرداخت میشود.',
          t6: 'در زمان درخواست غرامت برای مرسولات ثبت شده با سرویس ، می بایستی  مشخصات کارت ملی متقاضی غرامت (تصویر کارت ملی)، آدرس و شماره حساب در بخش مشخصات متقاضی غرامت   در لینک eop.post.ir درج گردد',
        }
      },
      paymentStatus: {
        t1: 'پرداخت شما با موفقیت انجام شد',
        t2: 'پرداخت شما ناموفق بود',
        t3: 'مبلغ کل',
        t4: 'ریال',
        t5: 'کد سفارش',
        t6: 'کد رهگیری',
        t7: 'تاریخ سفارش',
        t8: 'اضافه کردن سفارش جدید',
        t9: 'برگشت به صفحه اصلی',
        t10: 'بازگشت به صفحه سفارشات',
        t11: 'پرینت فاکتور',
        t12: 'نظرسنجی سامانه',
        t13: 'بازگشت به چت دیوار',
      },
      about: {
        t1: 'با پستِکس آسون بفرست!',
        t2: 'پستِکس، اولین سامانه جامع خدمات حمل و نقل در کشور.',
        t3: 'این سامانه با بهره گیری از انواع خدمات پستی داخلی و خارجی اکسپرس بصورت درب تا درب و با قیمت هایی ویژه خدمات بی نظیری را \n' +
           'به مشتریان خود ارائه می نماید. از دیگر نکات بارز و حائز اهمیت این سامانه استفاده از سیستم های پشتیبانی قوی و عالیست بطوری که \n' +
           'مشتریان آن بصورت 24 ساعته از خدمات پشتیبانی بهره مند می باشند.',
        t4: 'سرویس های پستِکس',
        t5: 'در سامانه پستِکس صاحبان مشاغل و صنایع قادر خواهند بود با استفاده از همکاری فعالین پستی اعم از سرویس های متنوع اپراتور اول پست\n' +
           ' سرویس چاپار، اسنپ باکس، DPE، DTS، TPG، تعارف، از سرویس متنوع پست شهری و بین شهری در داخل کشــور و پســــت خارجی با \n' +
           'استفاده از سرویس شرکتDPE و TPG و در بخش حمل و نقل سنگین سرویس سامانه اوبار و با امکان مقایسه قیمـــت،سرعت و کیفـــیت \n' +
           'استفاده نمایند.',
        t6: 'خدمات درب تا درب و تولید بارکد',
        t7: 'از نکات برجسته سامانه پستِکس به امکان استفاده از تمامی سرویس ها بصورت درب تا درب و دریافت بارکد پستی بلافاصــله پس از ثبـــت \n' +
           'سفارش میتوان اشاره نموده است. در عین حال سرویس پست خارجی این سامانه دارای دو بخش صادرات و واردات برای ۱۸۰ کشـــور در دنیا \n' +
           'میتوان اشاره کرد. شما می توانید با مطالعه قوانین پستِکس قبل از اقدام به استفاده از آن ، از ارسالی امن و مطمئن بهره مند گردید. فرامــوش \n' +
           'نکنید که اگر فعال پستی هم هستین میتونید با درآمدی خوب نماینده ما بشید.',

        t8: 'راه های ارتباطی',
        t9: 'ثبت سفارش'
      },
      loginEDU: {
        t1: 'http و آموزش ورود به سایت',
        t2: 'پروتکل http یا همان Hyper Text Transfer Protocol در واقع همان درگاه اتصال سیستم کاربران با انواع سایت ها می باشد و پروتکل https که خلاصه شده ی Hypertext Transfer Protocol Secure به معنای پروتکل امن انتقال ابر متن است ، در واقع همان نسخه ایمن شده ی http می باشد.' +
           '\n' +
           'وارد شدن به برخی از سایت های داخلی از طریق http امکان پذیر نیست و یا با تداخل همراه است و یا بالعکس نیاز است که برخی سایت ها فقط با آدرس http بارگذاری شوند،در موارد این چنین با انجام چند مرحله ساده زیر مشکل برطرف خواهد شد.',
        t3: '1. کلیک کردن و کپی کردن ادرس URL اولین قدمی است که برمیدارید ',
        t4: 'اولین گام کپی کردن آدرس سایت در مرورگر می باشد',
        t5: '2.لینک کپی شده را در تب جدید وارید کنید و بدون شک آدرس https یا http را مشاهده میکنید',
        t6: '3.با ویرایش کردن آدرس https در این مثال و تغییر آن به http میتوانید به راحتی سایت های داخلی به خصوص پستِکس را در اختیار داشته باشید',
        t7: '4. در پایان میتوانید سایت پست بار و پستِکس یا هر سایت داخلی دیگری را بدون ایراد و با http در اختیار داشته باشید',
        t8: 'با سپاس از اینکه مارا همراهی می نمایید.\n' +
           '\n' +
           'لطفا با مطالعه سوالات پر تکرار ما را در خدمت رسانی هر چه بهتر به خود یاری فرمایید.پستِکس ارائه کننده انواع خدمات پستی داخلی و خارجی بصورت درب تا درب اکسپرس در خدمت شماست.\n' +
           '\n' +
           'اگر فعال پستی هم هستین میتونید با درآمدی خوب نماینده ما بشید.',
        t9: 'تلگرام',
        t10: 'اینستاگرام',
        t11: 'سایت',
        t12: 'تلفن تماس'
      },
      representation: {
        t1: 'شرایط اخذ نمایندگی پستِکس',
        t2: 'چنانچه از فعالین پستی در شهر و استان خود می باشید و تمایل به اخذ نمایندگی پستِکس را دارید شما را دعوت به مطالعه ی ادامه این صفحه و همچنین سایر قوانین این سامانه می نماییم.لطفا در نظر داشته باشید که بعد از مطالعه این موارد حتما فرم درخواست نمایندگی پستِکس را تکمیل فرمایید',
        t3: 'پیش نیاز های نمایندگی پستِکس',
        t4: 'دفتر کار حداقل 20 متر (مسکونی نباشد)',
        t5: ' خط تلفن ، آب و گاز و برق مستقل و بستر اینترنت مناسب',
        t6: 'سرمایه لازم برای اداره شعبه',
        t7: 'عدم همکاری همزمان  با شرکتهای رقیب',
        t8: 'ضمانت معتبر',
        t9: 'حداقل لیسانس و یا سابقه 10 ساله موثر در زمینه کسب و کار مرتبط',
        t10: 'مدارک لازم',
        t11: 'کپی شناسنامه برابر اصل',
        t12: 'کپی کارت ملی برابر اصل',
        t13: 'دو قطعه عکس 4×3',
        t14: 'کپی مدرک تحصیلی برابر اصل',
        t15: 'تضامین و اسناد بانکی طبق قرارداد(100 میلیون)میباشد',
        t16: 'گواهی عدم سوء پیشینه به نام شرکت معماران به طرح',
        t17: 'قرارداد نمایندگی امضا شده و گواهی امضا',
        t18: 'وظایف',
        t19: 'بازاریابی',
        t20: 'هماهنگی با پست برای جمع آوری',
        t21: 'پیگیری تاخیر در جمع آوری ارسال و تحویل و غرامتهای شکستن و تاخیر و جمع آوری احتمالی بارهایی که پست جمع نکرده است',
        t22: 'تبلیغات منطقه ای',
        t23: 'لینک دانلود قرارداد اخذ نمایندگی',
        t24: 'نمونه سفته تکمیل شده',
        t25: 'دریافت فایل کمیسیون ها',
      },
      cartoon: {
        t1: 'کارتن و لفاف',
        t2: 'کارتن و لفاف و جعبه های استاندارد پستی چیست؟ پاسخ به این سوال و رعایت آن یکی از قوانین مهم استفاده از خدمات پستی می باشد. اساسا کارتن و لفاف و جعبه استاندارد پستی میبایستی ۳ تا ۵ لایه باشد تا در مسیر جابجایی پستی جعبه متلاشی نگردد.',
        t3: 'خرید بسته بندی',
        t4: 'حالا شما میتوانید با استفاده از گزینه خرید جعبه و کارتـــــن بسته استاندارد پستی از این سرویس توسط هر یک از فعالین پستی برخوردار شوید. امروزه اهمیت بسته بندی با توجه بــه محدودیت های فضاهای پستی، نیاز به ابعاد استاندارد و جعبه های استاندارد برای انجام فرایند مرسوله امریست ضروری.',
        t5: 'سایز های استاندارد کارتن و لفاف جعبه های پستی',
        t6: 'بسته بندی سایز',
        t7: 'طول:',
        t8: 'عرض:',
        t9: 'ارتفاع:',
      },
      msg: {
        t1: 'آدرس با موفقیت ثبت شد',
        t2: 'آدرس با موفقیت بروزرسانی شد',
        t3: 'لطفا یکی از فیلد های بارکد پستی یا شماره سفارش را وارد کنید',
        t4: 'در حال بارگزاری اطلاعات',
        t5: "درخواست شما با موفقیت ثبت شد",
        t6: "آیتم ها بررسی کنید",
        t7: "عملیات با موفقیت انجام شد",
        t8: "موردی یافت نشد",
        t9: "درخواست شما با مشکل مواجه شد",
        t10: "گذرواژه ها باید یکسان باشند",
        t11: "اینترنت خود را بررسی کنید",
        t12: "مشکلی در اجرای درخواست بوجود آمده است"
      },
      rate: {
        t1: 'ممنون از اینکه سرویس امنیتو را انتخاب کردید.',
        t2: 'برای ثبت تجربه خود پس از استفاده از سرویس امنیتو و همچنین کمک به بهتر شدن این سرویس، لطفا در نظرسنجی زیر شرکت کنید.',
        t3: '1- تجربه کلی شما از انتخاب سرویس امنیتو به چه صورت بود؟',
        t4: 'بد',
        t5: 'خوب',
        t6: 'خیلی خوب',
        t7: '2- فرآیند استفاده از سرویس امنیتو را چطور ارزیابی میکنید؟',
        t8: 'سخت',
        t9: 'معمولی',
        t10: 'آسان',
        t11: '3- تا چه حد از انجام خرید با سرویس امنیتو اطمینان خاطر داشتید؟',
        t12: 'مطمئن نبودم',
        t13: 'تا حدی مطمئن بودم',
        t14: 'کاملا مطمئن بودم',
        t15: '4- چقدر از کیفیت تحویل کالای خود رضایت داشتید؟',
        t16: 'اصلا رضایت نداشتم',
        t17: 'تا حدی رضایت داشتم',
        t18: 'کاملا راضی بودم',
        t19: '5- اگر در حین استفاده از سرویس امنیتو، با تیم پشتیبانی تماس داشته اید، لطفا میزان رضایت خود را نسبت به کیفیت پشتیبانی اعلام کنید.',
        t20: 'مشکلم برطرف نشد',
        t21: 'تا حدی مشکلم برطرف شد',
        t22: 'کاملا مشکلم برطرف شد',
        t23: '6- سرویس امنیتو را از لحاظ قیمت گذاری چطور ارزیابی میکنید.',
        t24: 'خیلی گران',
        t25: 'معمولی',
        t26: 'کاملا ارزان و مقرون به صرفه',
        t27: '7- چقدر احتمال داره سرویس امنیتو را به دوستان خود پیشنهاد بدهید؟',
        t28: 'اصلا پیشنهاد نمیدهم',
        t29: 'شاید پیشنهاد بدهم',
        t30: 'حتما پیشنهاد میدهم',
        t31: '8- آیا نظری درباره قسمت های مختلف سرویس امنیتو دارید که به بهبود این سرویس کمک کند؟',
        t32: 'پایان نظرسنجی',
      },
      orderCancellation: {
        t1: "فرم کنسلی سفارش",
        t2: "",
        t3: "نام و نام خانوادگی",
        t4: "تلفن همراه",
        t5: "شماره سفارش",
        t6: "دلیل کنسلی",
        t7: "عدم جمع آوری به موقع پست",
        t8: "عدم تطابق وزن واقعی با وزن اظهار شده",
        t9: "بسته بندی نامناسب",
        t10: "کنسل به درخواست مشتری",
        t11: "عدم تطابق آدرس با کد پستی اظهارشده برای فرستنده یا گیرنده",
        t12: "عدم تطابق محتویات با نوع مرسوله اظهار شده",
        t13: "عدم تحویل مرسوله توسط فرستنده",
        t14: "عدم حضور فرستنده در محل",
        t15: "ممنوعات پستی",
        t16: "سایر",
        t17: "توضیحات",
        t18: "عودت مبلغ خدمات پستی",
        t19: "عودت مبلغ خدمات فنی و پشتیبانی",
        t20: "عودت مبلغ کارتن و بسته بندی",
        t21: "عودت مبلغ جمع آوری",
        t22: "درصد توافقی عودت وجه",
        t23: "انتخاب نحوه واریز",
        t24: "کیف پول",
        t25: "کارت بانکی",
        t26: "ثبت درخواست",
      },
      withdrawalRequest: {
        t1: "درخواست برداشت از کیف پول",
        t2: "واریزی ها روزهای شنبه، دوشنبه و چهارشنبه خواهد بود.",
        t3: "مبلغ 500 هزار تومان در حساب بلوکه میشود.",
        t4: "سقف برداشت هر واریزی روزانه 5 میلیون تومان است.",
        t5: "سقف برداشت ماهیانه 80 میلیون تومان است.",
        t6: "نام و نام خانوادگی",
        t7: "تلفن همراه - نام کاربری",
        t8: "شماره شبا",
        t9: "مبلغ درخواستی (ریال)",
        t10: "ثبت درخواست",
      },
      agencyRequest: {
        t1: "فرم درخواست نمایندگی و فروشگاه",
        t2: "شما میتوانید به راحتی و تحمل هزینه هایی نزدیک به صفر با ما همکاری کنید یک فرم آنلاین درخواست نمایندگی یا فروشگاه رو پر کنید همکاران فنی ما پس تایید و بررسی صلاحیت با شما تماس خواهند گرفت",
        t3: "نام",
        t4: "شهر / استان",
        t5: "آدرس",
        t6: "رشته تحصیلی",
        t7: "تلفن ثابت (به همراه کد شهر)",
        t8: "تلفن همراه",
        t9: "ایمیل",
        t10: "وضعیت تاهل",
        t11: "مجرد",
        t12: "متاهل",
        t13: "سن",
        t14: "دسترسی به فضای دفتر کاری",
        t15: "هیچکدام",
        t16: "دارم",
        t17: "ندارم",
        t18: "سوابق پستی دارید؟ توضیح دهید.",
        t19: "آیا توان تجهیز نمایندگی تا 35 میلیون تومان را دارید؟",
        t20: "بله",
        t21: "خیر",
        t22: "آیا توان پرداخت حقوق و حق بیمه کارکنان خود را دارید؟",
        t23: "نحوه آشنایی",
        t24: "سایت دیوار",
        t25: "نماینده یاب",
        t26: "از طریق سایت پستِکس",
        t27: "معرفی دوستان",
        t28: "اینستاگرام",
        t29: "اپلیکیشن ایرانسل من",
        t30: "سایر",
        t31: "آیا امکان معرفی یک ضامن را دارید؟",
        t32: "آیا فضای دفتری شما در همکف می باشد؟",
        t33: "ظرفیت ناوگان شما برای توزیع و جمع آوری چند نقطه در روز می باشد؟",
        t34: "نقطه",
        t35: "کدام موارد زیر در دفتر خود موجود دارید؟",
        t36: "کامپیوتر",
        t37: "بارکد اسکنر",
        t38: "قفسه بندی",
        t39: "دوربین مداربسته",
        t40: "لوکیشن (لت و لانگ) آدرس مغازه را وارد کنید",
        t41: "تاریخ اتمام اجاره را انتخاب کنید",
        t42: "تاریخ را انتخاب کنید",
        t43: "آیا دارای شغل دیگری هستین؟",
        t44: "قوانین و مقررات نمایدگی را خواندم و قبول دارم",
        t45: "توضیحات",
        t46: "لطفا بعد از ثبت درخواست خود از صفحه خارج نشوید و صفحه ضمائم و مقررات را مطالعه نمایید",
        t47: "ثبت درخواست نمایندگی",
        t48: "درخواست نماینده",
        t49: "درخواست فروشگاه",
        t50: "نام فروشگاه",
        t51: "نام خانوادگی",
        t52: "اطلاعات هویتی",
        t53: "نام پدر",
        t54: "شماره شناسنامه",
        t55: "سریال شناسنامه",
        t56: "سری شناسنامه",
        t57: "محل صدور شناسنامه",
        t58: "تاریخ تولد",
        t59: "کد ملی",
        t60: "سریال کارت ملی",
        t61: "جنسیت",
        t62: "مرد",
        t63: "زن",
        t64: "اطلاعات محل سکونت",
        t65: "کدپستی",
        t66: "اطلاعات محل نمایندگی",
        t67: "اطلاعات بانکی",
        t68: "شماره شبا",
        t69: "شماره حساب",
        t70: "بانک",
        t71: "نام شعبه",
      },
      codRequest: {
        t1: "نام",
        t2: "نام خانوادگی",
        t3: "تلفن ثابت (به همراه کد شهر)",
        t4: "کد پستی",
        t5: "کد ملی/شناسه ملی",
        t6: "شماره سریال کارت ملی",
        t7: "تاریخ تولد",
        t8: "موبایل",
        t9: "ایمیل",
        t10: "شماره حساب",
        t11: "شماره شبا",
        t12: "نام شعبه بانک",
        t13: "استان/شهر",
        t14: "شهرستان",
        t15: "آدرس",
        t16: "درگاه پرداخت",
        t17: "ثبت درخواست",
        t18: "فرم درخواست پسکرایه",
      },
      myRequests: {
        t1: "درخواست های من",
        t2: "جستجوی کلمه مورد نظر...",
        t3: "درخواست وازیر وجه",
        t4: "کنسلی سفارش",
        t5: "درخواست نمایندگی",
        t6: "درخواست فروشگاه",
        t7: "شماره تیکت",
        t8: " تاریخ",
        t9: "مشاهده",
        t10: "شماره درخواست",
        t11: "شماره سفارش",
      },
      employment: {
        t1: "فرم درخواست استخدام",
        t2: "ارزیابی کمی",
        t3: "نام",
        t4: "نام خانوادگی",
        t5: "تلفن ثابت",
        t6: "تلفن همراه",
        t7: "ایمیل",
        t8: "لطفا بخش مورد نظر خود را مشخص کنید",
        t9: "استان/شهر",
        t10: "آدرس",
        t11: "آخرین مدرک تحصیلی",
        t12: "دیپلم",
        t13: "کاردانی",
        t14: "کارشناسی",
        t15: "کارشناسی ارشد",
        t16: "دکتری",
        t17: "دانشگاه محل تحصیل",
        t18: "رشته تحصیلی",
        t19: "وضعیت نظام وظیفه",
        t20: "پایان خدمت",
        t21: "معافیت تحصیلی (دانشجو)",
        t22: "سایر",
        t23: "وضعیت تاهل",
        t24: "مجرد",
        t25: "متاهل",
        t26: "تاریخ تولد",
        t27: "میزان سابقه کار",
        t28: "میزان حقوق درخواستی",
        t29: "میزان آشنایی به زبان انگلیسی",
        t30: "کم",
        t31: "متوسط",
        t32: "زیاد",
        t33: "پیشرفته",
        t34: "ثبت درخواست",
        t35: "انتخاب رزومه",
      }
    }
  }
})


